var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024px",
    height: "1024px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656565",
    d: "M 532.5,50.5 C 532.5,50.1667 532.5,49.8333 532.5,49.5C 549.167,49.5 565.833,49.5 582.5,49.5C 582.5,87.1667 582.5,124.833 582.5,162.5C 582.167,162.5 581.833,162.5 581.5,162.5C 581.5,125.167 581.5,87.8333 581.5,50.5C 565.167,50.5 548.833,50.5 532.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 532.5,50.5 C 548.833,50.5 565.167,50.5 581.5,50.5C 581.5,87.8333 581.5,125.167 581.5,162.5C 581.5,200.5 581.5,238.5 581.5,276.5C 573.833,276.5 566.167,276.5 558.5,276.5C 554.724,276.531 554.557,275.864 558,274.5C 560.411,276.153 561.578,275.487 561.5,272.5C 562.578,269.598 563.244,266.598 563.5,263.5C 561.427,262.862 559.427,261.862 557.5,260.5C 556.158,262.005 554.492,262.672 552.5,262.5C 552.665,259.482 552.498,256.482 552,253.5C 550.131,257.651 550.631,261.318 553.5,264.5C 553.207,268.437 553.54,272.27 554.5,276C 547.508,276.5 540.508,276.666 533.5,276.5C 532.583,201.172 532.25,125.838 532.5,50.5 Z M 554.5,263.5 C 557.5,263.5 560.5,263.5 563.5,263.5C 563.244,266.598 562.578,269.598 561.5,272.5C 559.283,273.369 556.95,273.702 554.5,273.5C 554.5,270.167 554.5,266.833 554.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d8d8",
    d: "M 208.5,51.5 C 222.833,51.5 237.167,51.5 251.5,51.5C 251.5,70.5 251.5,89.5 251.5,108.5C 237.217,108.294 223.05,108.628 209,109.5C 208.769,103.629 208.269,97.7957 207.5,92C 208.473,78.5369 208.807,65.0369 208.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#080808",
    d: "M 5.5,59.5 C 11.0945,62.4656 16.7611,65.1322 22.5,67.5C 23.0347,69.4456 24.368,70.4456 26.5,70.5C 27.1667,70.8333 27.8333,71.1667 28.5,71.5C 28.8212,73.0481 29.8212,73.7148 31.5,73.5C 32.7095,73.9321 33.7095,74.5987 34.5,75.5C 35.0478,77.5323 36.3812,78.5323 38.5,78.5C 39.4916,78.3284 40.1583,78.6618 40.5,79.5C 41.0347,81.4456 42.368,82.4456 44.5,82.5C 45.609,82.5569 46.609,82.8902 47.5,83.5C 47.8212,85.0481 48.8212,85.7148 50.5,85.5C 53.8333,87.8333 57.1667,90.1667 60.5,92.5C 61.0347,94.4456 62.368,95.4456 64.5,95.5C 67.538,97.1118 70.3713,99.1118 73,101.5C 73.6667,108.167 73.6667,114.833 73,121.5C 66.3455,126.822 59.1789,131.322 51.5,135C 41.9701,141.926 32.3034,148.593 22.5,155C 16.47,157.348 10.8034,160.182 5.5,163.5C 4.35089,163.209 3.68423,162.376 3.5,161C 2.92335,158.863 2.59001,156.696 2.5,154.5C 2.83545,122.653 3.83545,90.9868 5.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717171",
    d: "M 22.5,67.5 C 24.2303,68.0256 25.5637,69.0256 26.5,70.5C 24.368,70.4456 23.0347,69.4456 22.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6713",
    d: "M 661.5,68.5 C 702.833,68.5 744.167,68.5 785.5,68.5C 785.173,78.3478 785.506,88.0144 786.5,97.5C 789.709,118.539 788.875,139.539 784,160.5C 773.863,161.824 763.697,161.824 753.5,160.5C 751.902,152.837 752.569,145.503 755.5,138.5C 756.495,125.677 756.829,112.677 756.5,99.5C 750.5,99.5 744.5,99.5 738.5,99.5C 738.5,115.833 738.5,132.167 738.5,148.5C 728.5,148.5 718.5,148.5 708.5,148.5C 709.151,132.132 708.485,116.132 706.5,100.5C 701.08,99.3214 695.746,99.6547 690.5,101.5C 689.504,116.991 689.17,132.658 689.5,148.5C 680.167,148.5 670.833,148.5 661.5,148.5C 661.5,121.833 661.5,95.1667 661.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7d",
    d: "M 28.5,71.5 C 29.7095,71.9321 30.7095,72.5987 31.5,73.5C 29.8212,73.7148 28.8212,73.0481 28.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feac7f",
    d: "M 661.5,68.5 C 702.997,67.5014 744.663,67.168 786.5,67.5C 786.5,77.5 786.5,87.5 786.5,97.5C 785.506,88.0144 785.173,78.3478 785.5,68.5C 744.167,68.5 702.833,68.5 661.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717171",
    d: "M 34.5,75.5 C 36.1216,76.1224 37.4549,77.1224 38.5,78.5C 36.3812,78.5323 35.0478,77.5323 34.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8d8d8",
    d: "M 88.5,77.5 C 119.835,77.3334 151.168,77.5 182.5,78C 182.267,93.2492 182.267,108.749 182.5,124.5C 151.167,124.5 119.833,124.5 88.5,124.5C 88.5,108.833 88.5,93.1667 88.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6c6c",
    d: "M 40.5,79.5 C 42.2303,80.0256 43.5637,81.0256 44.5,82.5C 42.368,82.4456 41.0347,81.4456 40.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767777",
    d: "M 47.5,83.5 C 48.7095,83.9321 49.7095,84.5987 50.5,85.5C 48.8212,85.7148 47.8212,85.0481 47.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7c7b",
    d: "M 60.5,92.5 C 62.2303,93.0256 63.5637,94.0256 64.5,95.5C 62.368,95.4456 61.0347,94.4456 60.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#515252",
    d: "M 5.5,59.5 C 3.83545,90.9868 2.83545,122.653 2.5,154.5C 2.7924,127.366 2.45907,100.199 1.5,73C 2.14435,67.8843 2.81102,62.7176 3.5,57.5C 4.5223,57.8555 5.18897,58.5222 5.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcaa7b",
    d: "M 706.5,100.5 C 708.485,116.132 709.151,132.132 708.5,148.5C 718.5,148.5 728.5,148.5 738.5,148.5C 738.5,148.833 738.5,149.167 738.5,149.5C 728.167,149.5 717.833,149.5 707.5,149.5C 707.818,133.089 707.484,116.756 706.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b7b7",
    d: "M 339.5,93.5 C 396.833,93.5 454.167,93.5 511.5,93.5C 511.5,112.5 511.5,131.5 511.5,150.5C 454.166,150.667 396.832,150.5 339.5,150C 338.524,143.924 338.19,137.758 338.5,131.5C 344.529,131.575 350.529,131.241 356.5,130.5C 355.886,126.865 355.552,123.198 355.5,119.5C 349.833,119.5 344.167,119.5 338.5,119.5C 338.197,110.749 338.53,102.082 339.5,93.5 Z M 404.5,119.5 C 424.833,119.5 445.167,119.5 465.5,119.5C 465.5,123.167 465.5,126.833 465.5,130.5C 445.167,130.5 424.833,130.5 404.5,130.5C 404.5,126.833 404.5,123.167 404.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0d1d1",
    d: "M 809.5,103.5 C 849.5,103.5 889.5,103.5 929.5,103.5C 929.5,107.5 929.5,111.5 929.5,115.5C 889.311,115.495 849.311,115.495 809.5,115.5C 809.126,111.664 809.126,107.664 809.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9c9ae",
    d: "M 755.5,138.5 C 755.5,125.833 755.5,113.167 755.5,100.5C 750.167,100.5 744.833,100.5 739.5,100.5C 739.83,117.009 739.496,133.342 738.5,149.5C 738.5,149.167 738.5,148.833 738.5,148.5C 738.5,132.167 738.5,115.833 738.5,99.5C 744.5,99.5 750.5,99.5 756.5,99.5C 756.829,112.677 756.495,125.677 755.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadedc",
    d: "M 241.5,113.5 C 242.833,114.167 242.833,114.167 241.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dcdd",
    d: "M 243.5,113.5 C 244.833,114.167 244.833,114.167 243.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6d6d6",
    d: "M 809.5,117.5 C 848.664,118.233 888.331,118.233 928.5,117.5C 929.833,120.5 929.833,123.5 928.5,126.5C 908.851,126.535 889.351,126.535 870,126.5C 869.5,127 869,127.5 868.5,128C 873.553,128.217 878.553,128.717 883.5,129.5C 890.724,128.653 898.057,128.32 905.5,128.5C 910.099,128.803 914.599,129.47 919,130.5C 921.804,128.052 924.471,128.052 927,130.5C 927.333,129.833 927.667,129.167 928,128.5C 929.375,130.937 929.875,133.603 929.5,136.5C 892.212,136.445 854.878,136.445 817.5,136.5C 854.226,137.971 891.226,138.804 928.5,139C 929.423,141.041 929.756,143.208 929.5,145.5C 889.5,145.5 849.5,145.5 809.5,145.5C 809.433,135.957 809.433,126.624 809.5,117.5 Z M 856.5,126.5 C 857.043,126.56 857.376,126.893 857.5,127.5C 855.926,128.631 854.259,128.798 852.5,128C 854.058,127.79 855.391,127.29 856.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb272",
    d: "M 210.5,123.5 C 224.323,122.504 238.323,122.171 252.5,122.5C 252.5,141.833 252.5,161.167 252.5,180.5C 251.503,161.674 251.17,142.674 251.5,123.5C 237.833,123.5 224.167,123.5 210.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdab7d",
    d: "M 661.5,68.5 C 661.5,95.1667 661.5,121.833 661.5,148.5C 670.833,148.5 680.167,148.5 689.5,148.5C 689.17,132.658 689.504,116.991 690.5,101.5C 690.5,117.5 690.5,133.5 690.5,149.5C 680.5,149.5 670.5,149.5 660.5,149.5C 660.169,122.328 660.502,95.3282 661.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6d7d7",
    d: "M 89.5,145.5 C 103.5,145.5 117.5,145.5 131.5,145.5C 130.738,167.241 130.405,189.241 130.5,211.5C 128.167,211.5 125.833,211.5 123.5,211.5C 123.5,214.167 123.5,216.833 123.5,219.5C 125.833,219.5 128.167,219.5 130.5,219.5C 130.174,237.41 130.508,255.243 131.5,273C 117.5,273.667 103.5,273.667 89.5,273C 89.5739,230.583 89.5739,188.083 89.5,145.5 Z M 108.5,245.5 C 110.833,246.833 113.167,246.833 115.5,245.5C 115.649,246.552 115.483,247.552 115,248.5C 113.817,247.269 112.651,247.269 111.5,248.5C 110.902,249.795 110.402,251.128 110,252.5C 109.023,250.26 108.523,247.927 108.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b0b0b",
    d: "M 193.5,147.5 C 194.497,163.992 194.83,180.658 194.5,197.5C 181.62,198.189 168.62,198.189 155.5,197.5C 155.5,180.833 155.5,164.167 155.5,147.5C 168.167,147.5 180.833,147.5 193.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4c6a2",
    d: "M 632.5,150.5 C 621.833,150.5 611.167,150.5 600.5,150.5C 601.2,154.798 601.533,159.131 601.5,163.5C 600.356,159.036 599.69,154.37 599.5,149.5C 610.679,149.172 621.679,149.505 632.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa7405",
    d: "M 632.5,150.5 C 633.833,151.167 633.833,151.833 632.5,152.5C 631.51,158.645 631.177,164.978 631.5,171.5C 628.857,170.36 626.191,169.026 623.5,167.5C 622.396,166.369 622.729,165.535 624.5,165C 623.552,164.517 622.552,164.351 621.5,164.5C 620.058,163.18 619.392,161.514 619.5,159.5C 623.047,159.271 623.047,158.271 619.5,156.5C 614.575,157.4 614.242,159.066 618.5,161.5C 618.737,162.791 618.404,163.791 617.5,164.5C 615.088,164.331 612.921,164.997 611,166.5C 608.994,164.998 607.328,165.331 606,167.5C 604.017,165.003 604.85,163.836 608.5,164C 606.301,162.417 603.968,162.25 601.5,163.5C 601.533,159.131 601.2,154.798 600.5,150.5C 611.167,150.5 621.833,150.5 632.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#737474",
    d: "M 193.5,147.5 C 180.833,147.5 168.167,147.5 155.5,147.5C 155.5,164.167 155.5,180.833 155.5,197.5C 154.503,180.675 154.17,163.675 154.5,146.5C 167.677,146.171 180.677,146.505 193.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9671c",
    d: "M 619.5,159.5 C 618.662,159.842 618.328,160.508 618.5,161.5C 614.242,159.066 614.575,157.4 619.5,156.5C 623.047,158.271 623.047,159.271 619.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767877",
    d: "M 2.5,154.5 C 2.59001,156.696 2.92335,158.863 3.5,161C 3.68423,162.376 4.35089,163.209 5.5,163.5C 4.79105,164.404 3.79105,164.737 2.5,164.5C 1.76096,160.985 1.76096,157.652 2.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#515151",
    d: "M 550.5,162.5 C 556.868,162.17 563.202,162.504 569.5,163.5C 566.333,163.833 563.167,164.167 560,164.5C 556.424,164.485 553.258,163.818 550.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d8d7",
    d: "M 316.5,205.5 C 317.721,204.972 318.887,204.305 320,203.5C 320.499,209.157 320.666,214.824 320.5,220.5C 319.883,220.389 319.383,220.056 319,219.5C 316.5,220.667 314,221.833 311.5,223C 303.422,223.198 295.422,223.698 287.5,224.5C 282.695,223.513 277.695,223.179 272.5,223.5C 273.364,218.266 273.364,212.933 272.5,207.5C 276.555,207.824 280.555,207.491 284.5,206.5C 280.893,205.511 277.226,205.177 273.5,205.5C 273.071,202.214 273.071,199.047 273.5,196C 276.884,195.909 280.051,196.076 283,196.5C 283.5,196 284,195.5 284.5,195C 280.472,194.608 276.472,194.108 272.5,193.5C 272.133,189.95 273.133,186.95 275.5,184.5C 279.31,184.391 283.143,184.724 287,185.5C 287.875,183.487 289.209,183.487 291,185.5C 291.333,184.833 291.667,184.167 292,183.5C 293.907,183.421 295.907,183.754 298,184.5C 299.399,183.773 300.899,183.273 302.5,183C 301.892,182.13 301.059,181.63 300,181.5C 295.179,181.518 290.346,181.851 285.5,182.5C 283.833,182.167 282.167,181.833 280.5,181.5C 280.167,180.5 279.5,179.833 278.5,179.5C 276.591,180.348 274.591,180.682 272.5,180.5C 272.5,178.833 272.5,177.167 272.5,175.5C 286.946,174.861 301.279,174.527 315.5,174.5C 301.379,173.446 287.379,172.613 273.5,172C 272.594,170.301 272.261,168.467 272.5,166.5C 280.189,166.387 287.855,165.887 295.5,165C 288.159,164.831 280.825,164.331 273.5,163.5C 273.709,162.914 274.043,162.414 274.5,162C 272.538,151.758 271.872,141.258 272.5,130.5C 288.5,130.5 304.5,130.5 320.5,130.5C 321.4,147.771 321.234,165.104 320,182.5C 314.669,181.527 309.169,181.193 303.5,181.5C 303.281,182.675 303.614,183.675 304.5,184.5C 309.578,184.294 314.912,184.294 320.5,184.5C 320.5,187.5 320.5,190.5 320.5,193.5C 314.793,194.487 309.293,194.487 304,193.5C 302.933,194.191 301.766,194.691 300.5,195C 307.158,195.5 313.825,195.666 320.5,195.5C 320.662,197.527 320.495,199.527 320,201.5C 317.929,202.103 316.762,203.436 316.5,205.5 Z M 306.5,163.5 C 310.459,164.106 314.459,164.773 318.5,165.5C 318.167,165.833 317.833,166.167 317.5,166.5C 310.55,165.702 303.55,165.202 296.5,165C 300.025,164.821 303.359,164.321 306.5,163.5 Z M 296.5,193.5 C 297.756,193.461 298.756,193.961 299.5,195C 296.574,195.218 293.74,195.718 291,196.5C 289.084,196.645 287.251,196.145 285.5,195C 289.356,194.823 293.023,194.323 296.5,193.5 Z M 286.5,205.5 C 287.376,205.369 288.043,205.702 288.5,206.5C 286.192,207.873 285.525,207.54 286.5,205.5 Z M 294.5,205.5 C 295.756,205.461 296.756,205.961 297.5,207C 294.833,207.667 292.167,207.667 289.5,207C 291.382,206.802 293.048,206.302 294.5,205.5 Z M 316.5,205.5 C 316.516,207.484 315.516,208.484 313.5,208.5C 308.863,207.78 304.197,207.28 299.5,207C 305.215,206.742 310.882,206.242 316.5,205.5 Z M 295.5,214.5 C 297.581,214.634 299.581,215.134 301.5,216C 299.167,216.667 296.833,216.667 294.5,216C 295.056,215.617 295.389,215.117 295.5,214.5 Z M 304.5,215.5 C 305.251,214.427 306.251,214.26 307.5,215C 306.648,216.728 305.648,216.895 304.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c6c3a",
    d: "M 619.5,159.5 C 619.392,161.514 620.058,163.18 621.5,164.5C 621.762,165.978 621.429,167.311 620.5,168.5C 618.253,167.626 615.92,167.292 613.5,167.5C 614.448,166.022 615.781,165.022 617.5,164.5C 618.404,163.791 618.737,162.791 618.5,161.5C 618.328,160.508 618.662,159.842 619.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 812.5,278.5 C 812.5,244.5 812.5,210.5 812.5,176.5C 821.833,176.5 831.167,176.5 840.5,176.5C 840.5,175.5 840.5,174.5 840.5,173.5C 841.167,173.5 841.5,173.167 841.5,172.5C 842.289,172.217 842.956,171.717 843.5,171C 833.172,170.5 822.839,170.334 812.5,170.5C 812.5,168.5 812.5,166.5 812.5,164.5C 824.167,164.5 835.833,164.5 847.5,164.5C 847.5,202.5 847.5,240.5 847.5,278.5C 835.833,278.5 824.167,278.5 812.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2af70",
    d: "M 632.5,152.5 C 632.193,158.093 632.527,163.593 633.5,169C 632.877,171.607 632.21,174.107 631.5,176.5C 631.5,174.833 631.5,173.167 631.5,171.5C 631.177,164.978 631.51,158.645 632.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#050505",
    d: "M -0.5,169.5 C 23.8333,169.5 48.1667,169.5 72.5,169.5C 72.7724,193.519 72.4391,217.519 71.5,241.5C 69.2488,250.751 63.5821,256.751 54.5,259.5C 52.1016,259.259 50.1016,259.926 48.5,261.5C 40.3014,263.87 31.8014,264.87 23,264.5C 16.5858,264.711 10.4191,264.045 4.5,262.5C 3.21959,261.069 1.55292,260.402 -0.5,260.5C -0.5,230.167 -0.5,199.833 -0.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757575",
    d: "M 811.5,170.5 C 811.833,170.5 812.167,170.5 812.5,170.5C 822.839,170.334 833.172,170.5 843.5,171C 842.956,171.717 842.289,172.217 841.5,172.5C 831.5,171.833 821.5,171.167 811.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3681d",
    d: "M 621.5,164.5 C 622.552,164.351 623.552,164.517 624.5,165C 622.729,165.535 622.396,166.369 623.5,167.5C 626.191,169.026 628.857,170.36 631.5,171.5C 631.5,173.167 631.5,174.833 631.5,176.5C 631.784,178.415 631.451,180.081 630.5,181.5C 630.5,178.5 630.5,175.5 630.5,172.5C 624.824,172.666 619.157,172.499 613.5,172C 613.034,170.701 613.034,169.201 613.5,167.5C 615.92,167.292 618.253,167.626 620.5,168.5C 621.429,167.311 621.762,165.978 621.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaead",
    d: "M 811.5,167.5 C 811.5,168.5 811.5,169.5 811.5,170.5C 821.5,171.167 831.5,171.833 841.5,172.5C 841.5,173.167 841.167,173.5 840.5,173.5C 830.442,172.86 820.775,173.527 811.5,175.5C 810.167,172.833 810.167,170.167 811.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#414240",
    d: "M 549.5,174.5 C 549.5,175.833 549.5,177.167 549.5,178.5C 547.738,178.357 546.071,178.691 544.5,179.5C 541.721,178.327 541.054,176.493 542.5,174C 544.929,173.297 547.262,173.463 549.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 556.5,172.5 C 560.226,172.177 563.893,172.511 567.5,173.5C 558.232,174.532 558.232,175.532 567.5,176.5C 567.5,178.167 567.5,179.833 567.5,181.5C 565.833,181.5 564.167,181.5 562.5,181.5C 563.609,180.71 564.942,180.21 566.5,180C 563.774,179.818 561.107,179.318 558.5,178.5C 557.167,177.167 557.167,175.833 558.5,174.5C 557.757,173.818 557.091,173.151 556.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fda676",
    d: "M 688.5,287.5 C 688.5,283.5 688.5,279.5 688.5,275.5C 720.833,275.5 753.167,275.5 785.5,275.5C 785.5,243.167 785.5,210.833 785.5,178.5C 744.167,178.5 702.833,178.5 661.5,178.5C 661.5,198.167 661.5,217.833 661.5,237.5C 660.503,217.674 660.17,197.674 660.5,177.5C 702.5,177.5 744.5,177.5 786.5,177.5C 786.5,210.5 786.5,243.5 786.5,276.5C 754.167,276.5 721.833,276.5 689.5,276.5C 689.815,280.371 689.482,284.038 688.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1b9a3",
    d: "M 601.5,165.5 C 602.659,170.5 602.826,175.5 602,180.5C 602.11,182.848 603.277,184.348 605.5,185C 604.756,186.039 603.756,186.539 602.5,186.5C 601.23,184.017 600.564,181.35 600.5,178.5C 600.951,174.031 601.284,169.697 601.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd6610",
    d: "M 688.5,287.5 C 687.901,290.168 686.234,292.002 683.5,293C 678.587,294.345 673.587,295.178 668.5,295.5C 666.5,295.5 664.5,295.5 662.5,295.5C 662.83,277.326 662.497,259.326 661.5,241.5C 660.314,240.295 660.314,238.961 661.5,237.5C 661.5,217.833 661.5,198.167 661.5,178.5C 702.833,178.5 744.167,178.5 785.5,178.5C 785.5,210.833 785.5,243.167 785.5,275.5C 753.167,275.5 720.833,275.5 688.5,275.5C 688.5,279.5 688.5,283.5 688.5,287.5 Z M 690.5,209.5 C 696.167,209.5 701.833,209.5 707.5,209.5C 707.5,221.833 707.5,234.167 707.5,246.5C 701.833,246.5 696.167,246.5 690.5,246.5C 690.5,234.167 690.5,221.833 690.5,209.5 Z M 739.5,209.5 C 744.833,209.5 750.167,209.5 755.5,209.5C 755.5,221.833 755.5,234.167 755.5,246.5C 750.167,246.5 744.833,246.5 739.5,246.5C 739.5,234.167 739.5,221.833 739.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8e8d",
    d: "M 556.5,172.5 C 557.091,173.151 557.757,173.818 558.5,174.5C 557.167,175.833 557.167,177.167 558.5,178.5C 561.107,179.318 563.774,179.818 566.5,180C 564.942,180.21 563.609,180.71 562.5,181.5C 562.5,181.833 562.5,182.167 562.5,182.5C 562.565,182.938 562.399,183.272 562,183.5C 559.871,182.088 558.038,180.421 556.5,178.5C 554.958,177.699 553.292,177.366 551.5,177.5C 551.715,175.821 551.048,174.821 549.5,174.5C 551.279,172.656 553.612,171.99 556.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#404141",
    d: "M 842.5,178.5 C 841.127,178.343 839.793,178.51 838.5,179C 839.833,180 839.833,181 838.5,182C 834.459,182.827 830.459,182.66 826.5,181.5C 827.981,180.056 827.648,179.389 825.5,179.5C 830.17,178.7 835.004,178.034 840,177.5C 841.07,177.528 841.903,177.861 842.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#605b5c",
    d: "M 822.5,180.5 C 821.01,182.28 819.01,182.946 816.5,182.5C 818.102,180.926 820.102,180.259 822.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c6439",
    d: "M 622.5,182.5 C 619.753,182.187 617.086,182.52 614.5,183.5C 615.668,185.217 617.335,185.884 619.5,185.5C 615.377,187.524 613.044,186.191 612.5,181.5C 616.042,181.187 619.375,181.521 622.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8e8e",
    d: "M 842.5,178.5 C 841.058,179.82 840.392,181.486 840.5,183.5C 837.833,183.5 835.167,183.5 832.5,183.5C 826.642,183.822 820.975,183.489 815.5,182.5C 815.833,182.5 816.167,182.5 816.5,182.5C 819.01,182.946 821.01,182.28 822.5,180.5C 823.391,179.89 824.391,179.557 825.5,179.5C 827.648,179.389 827.981,180.056 826.5,181.5C 830.459,182.66 834.459,182.827 838.5,182C 839.833,181 839.833,180 838.5,179C 839.793,178.51 841.127,178.343 842.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ce8c4f",
    d: "M 630.5,181.5 C 630.167,183.5 629.833,185.5 629.5,187.5C 628.9,186.1 627.9,185.1 626.5,184.5C 625.5,183.833 624.5,183.167 623.5,182.5C 625.95,182.702 628.283,182.369 630.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454544",
    d: "M 815.5,182.5 C 820.975,183.489 826.642,183.822 832.5,183.5C 826.322,184.817 819.988,184.817 813.5,183.5C 813.957,182.702 814.624,182.369 815.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4856",
    d: "M 622.5,182.5 C 622.833,182.5 623.167,182.5 623.5,182.5C 624.5,183.167 625.5,183.833 626.5,184.5C 624.393,185.468 622.059,185.802 619.5,185.5C 617.335,185.884 615.668,185.217 614.5,183.5C 617.086,182.52 619.753,182.187 622.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3dee4",
    d: "M 200.5,186.5 C 201.833,187.167 201.833,187.167 200.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f87d16",
    d: "M 617.5,164.5 C 615.781,165.022 614.448,166.022 613.5,167.5C 613.034,169.201 613.034,170.701 613.5,172C 619.157,172.499 624.824,172.666 630.5,172.5C 630.5,175.5 630.5,178.5 630.5,181.5C 628.283,182.369 625.95,182.702 623.5,182.5C 623.167,182.5 622.833,182.5 622.5,182.5C 619.375,181.521 616.042,181.187 612.5,181.5C 613.044,186.191 615.377,187.524 619.5,185.5C 622.059,185.802 624.393,185.468 626.5,184.5C 627.9,185.1 628.9,186.1 629.5,187.5C 631.987,190.616 633.32,194.282 633.5,198.5C 633.506,203.538 633.173,208.538 632.5,213.5C 631.981,209.951 630.814,206.618 629,203.5C 626.563,206.149 625.23,205.483 625,201.5C 624.819,204.695 624.319,207.695 623.5,210.5C 623.5,205.167 623.5,199.833 623.5,194.5C 620.813,194.336 618.146,194.503 615.5,195C 614.209,196.292 614.209,197.458 615.5,198.5C 614.909,199.151 614.243,199.818 613.5,200.5C 614.348,202.409 614.682,204.409 614.5,206.5C 614.5,207.167 614.5,207.833 614.5,208.5C 613.933,210.698 613.933,213.031 614.5,215.5C 614.5,216.167 614.167,216.5 613.5,216.5C 612.514,214.484 610.847,213.151 608.5,212.5C 607.289,211.28 607.289,210.113 608.5,209C 607.551,208.383 606.718,208.549 606,209.5C 605.395,207.519 604.395,207.185 603,208.5C 602.831,221.007 602.331,233.34 601.5,245.5C 601.5,229.167 601.5,212.833 601.5,196.5C 600.006,192.975 600.339,189.642 602.5,186.5C 603.756,186.539 604.756,186.039 605.5,185C 603.277,184.348 602.11,182.848 602,180.5C 602.826,175.5 602.659,170.5 601.5,165.5C 601.5,164.833 601.5,164.167 601.5,163.5C 603.968,162.25 606.301,162.417 608.5,164C 604.85,163.836 604.017,165.003 606,167.5C 607.328,165.331 608.994,164.998 611,166.5C 612.921,164.997 615.088,164.331 617.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2dfe6",
    d: "M 198.5,188.5 C 199.833,189.167 199.833,189.167 198.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a89",
    d: "M 557.5,190.5 C 555.5,190.5 554.5,191.5 554.5,193.5C 553.448,193.649 552.448,193.483 551.5,193C 552.973,192.29 553.64,191.124 553.5,189.5C 551.876,189.36 550.71,190.027 550,191.5C 549.421,190.072 549.588,188.738 550.5,187.5C 550.821,185.952 551.821,185.285 553.5,185.5C 555.232,185.631 556.899,185.631 558.5,185.5C 557.282,186.803 557.615,187.803 559.5,188.5C 558.757,189.182 558.091,189.849 557.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3dee6",
    d: "M 202.5,193.5 C 200.656,192.796 200.156,191.463 201,189.5C 201.41,190.901 201.91,192.234 202.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#363636",
    d: "M 550.5,187.5 C 549.588,188.738 549.421,190.072 550,191.5C 550.71,190.027 551.876,189.36 553.5,189.5C 553.64,191.124 552.973,192.29 551.5,193C 552.448,193.483 553.448,193.649 554.5,193.5C 552.833,194.167 551.167,194.833 549.5,195.5C 548.904,192.383 547.237,189.883 544.5,188C 547.544,187.641 547.878,186.974 545.5,186C 547.495,185.387 549.162,185.887 550.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a3b3b",
    d: "M 556.5,178.5 C 558.038,180.421 559.871,182.088 562,183.5C 562.399,183.272 562.565,182.938 562.5,182.5C 563.675,182.281 564.675,182.614 565.5,183.5C 563.922,184.298 562.256,184.798 560.5,185C 563.377,186.127 566.377,186.794 569.5,187C 566.48,187.906 563.813,189.406 561.5,191.5C 560.264,190.754 558.93,190.421 557.5,190.5C 558.091,189.849 558.757,189.182 559.5,188.5C 557.615,187.803 557.282,186.803 558.5,185.5C 556.899,185.631 555.232,185.631 553.5,185.5C 554.66,184.389 555.993,183.389 557.5,182.5C 556.975,181.808 556.308,181.308 555.5,181C 556.252,180.329 556.586,179.496 556.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1dee5",
    d: "M 202.5,193.5 C 203.833,194.167 203.833,194.167 202.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585858",
    d: "M 840.5,173.5 C 840.5,174.5 840.5,175.5 840.5,176.5C 831.167,176.5 821.833,176.5 812.5,176.5C 812.5,210.5 812.5,244.5 812.5,278.5C 812.167,278.5 811.833,278.5 811.5,278.5C 811.5,244.167 811.5,209.833 811.5,175.5C 820.775,173.527 830.442,172.86 840.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2dee7",
    d: "M 198.5,193.5 C 199.643,193.908 200.643,194.575 201.5,195.5C 199.604,196.639 198.604,195.973 198.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1dde5",
    d: "M 203.5,195.5 C 204.833,196.167 204.833,196.167 203.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f605f",
    d: "M 557.5,190.5 C 559.719,192.776 559.052,194.609 555.5,196C 555.728,196.399 556.062,196.565 556.5,196.5C 555.048,197.302 553.382,197.802 551.5,198C 552.308,198.308 552.975,198.808 553.5,199.5C 552.398,200.176 551.398,200.842 550.5,201.5C 548.738,201.357 547.071,201.691 545.5,202.5C 544.05,201.345 543.05,199.845 542.5,198C 545.226,197.818 547.893,197.318 550.5,196.5C 550.376,195.893 550.043,195.56 549.5,195.5C 551.167,194.833 552.833,194.167 554.5,193.5C 554.5,191.5 555.5,190.5 557.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb7602",
    d: "M 210.5,123.5 C 224.167,123.5 237.833,123.5 251.5,123.5C 251.17,142.674 251.503,161.674 252.5,180.5C 251.515,211.456 251.182,242.456 251.5,273.5C 237.833,273.5 224.167,273.5 210.5,273.5C 210.5,223.5 210.5,173.5 210.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2550f",
    d: "M 230.5,178.5 C 230.5,182.5 230.5,186.5 230.5,190.5C 226.818,190.335 223.152,190.501 219.5,191C 222.695,191.181 225.695,191.681 228.5,192.5C 225.167,192.5 221.833,192.5 218.5,192.5C 218.5,191.5 218.5,190.5 218.5,189.5C 222.167,189.5 225.833,189.5 229.5,189.5C 229.185,185.629 229.518,181.962 230.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24241f",
    d: "M 237.5,189.5 C 239.531,189.972 241.198,190.972 242.5,192.5C 237.761,193.378 233.095,193.378 228.5,192.5C 225.695,191.681 222.695,191.181 219.5,191C 223.152,190.501 226.818,190.335 230.5,190.5C 230.5,186.5 230.5,182.5 230.5,178.5C 232.808,177.286 235.141,177.286 237.5,178.5C 235.107,182.185 235.107,185.852 237.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#27261e",
    d: "M 240.5,165.5 C 241.434,166.568 241.768,167.901 241.5,169.5C 234.825,169.666 228.158,169.5 221.5,169C 220.944,168.617 220.611,168.117 220.5,167.5C 226.842,167.666 233.175,167.5 239.5,167C 240.056,166.617 240.389,166.117 240.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97500e",
    d: "M 240.5,165.5 C 240.389,166.117 240.056,166.617 239.5,167C 233.175,167.5 226.842,167.666 220.5,167.5C 226.987,166.485 233.654,165.818 240.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#884309",
    d: "M 235.5,153.5 C 237.5,153.5 239.5,153.5 241.5,153.5C 241.5,154.5 241.5,155.5 241.5,156.5C 236.305,156.821 231.305,156.487 226.5,155.5C 231.179,155.666 235.845,155.499 240.5,155C 238.618,154.802 236.952,154.302 235.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd5707",
    d: "M 219.5,140.5 C 221.833,140.5 224.167,140.5 226.5,140.5C 226.5,143.833 226.5,147.167 226.5,150.5C 225.523,147.713 225.19,144.713 225.5,141.5C 223.265,141.795 221.265,141.461 219.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15120d",
    d: "M 228.5,131.5 C 230.167,131.5 231.833,131.5 233.5,131.5C 233.263,132.791 233.596,133.791 234.5,134.5C 236.607,135.468 238.941,135.802 241.5,135.5C 241.5,137.167 241.5,138.833 241.5,140.5C 239.265,140.205 237.265,140.539 235.5,141.5C 235.5,145.5 235.5,149.5 235.5,153.5C 236.952,154.302 238.618,154.802 240.5,155C 235.845,155.499 231.179,155.666 226.5,155.5C 226.5,153.833 226.5,152.167 226.5,150.5C 226.5,147.167 226.5,143.833 226.5,140.5C 224.167,140.5 221.833,140.5 219.5,140.5C 219.167,140.5 218.833,140.5 218.5,140.5C 218.5,139.167 218.5,137.833 218.5,136.5C 220.735,136.795 222.735,136.461 224.5,135.5C 225.833,135.5 227.167,135.5 228.5,135.5C 228.5,134.167 228.5,132.833 228.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#663207",
    d: "M 241.5,135.5 C 242.461,137.265 242.795,139.265 242.5,141.5C 240.167,141.5 237.833,141.5 235.5,141.5C 237.265,140.539 239.265,140.205 241.5,140.5C 241.5,138.833 241.5,137.167 241.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e4207",
    d: "M 224.5,135.5 C 222.735,136.461 220.735,136.795 218.5,136.5C 218.5,137.833 218.5,139.167 218.5,140.5C 217.549,139.081 217.216,137.415 217.5,135.5C 219.833,135.5 222.167,135.5 224.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b4a07",
    d: "M 228.5,131.5 C 230.265,130.539 232.265,130.205 234.5,130.5C 234.5,131.833 234.5,133.167 234.5,134.5C 233.596,133.791 233.263,132.791 233.5,131.5C 231.833,131.5 230.167,131.5 228.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99531e",
    d: "M 618.5,197.5 C 618.5,197.833 618.5,198.167 618.5,198.5C 617.617,201.368 616.284,204.035 614.5,206.5C 614.682,204.409 614.348,202.409 613.5,200.5C 614.243,199.818 614.909,199.151 615.5,198.5C 616.391,197.89 617.391,197.557 618.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#523123",
    d: "M 623.5,210.5 C 622.532,208.393 622.198,206.059 622.5,203.5C 621.85,201.565 621.517,199.565 621.5,197.5C 620.5,197.5 619.5,197.5 618.5,197.5C 617.391,197.557 616.391,197.89 615.5,198.5C 614.209,197.458 614.209,196.292 615.5,195C 618.146,194.503 620.813,194.336 623.5,194.5C 623.5,199.833 623.5,205.167 623.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878787",
    d: "M 556.5,196.5 C 558.977,197.12 558.977,198.12 556.5,199.5C 558.542,200.503 558.875,201.837 557.5,203.5C 559.538,205.97 561.205,208.637 562.5,211.5C 562.167,211.5 561.833,211.5 561.5,211.5C 558.257,210.42 554.924,210.253 551.5,211C 545.274,215.252 544.941,214.419 550.5,208.5C 549.754,207.264 549.421,205.93 549.5,204.5C 550.5,204.5 551.5,204.5 552.5,204.5C 552.715,202.821 552.048,201.821 550.5,201.5C 551.398,200.842 552.398,200.176 553.5,199.5C 552.975,198.808 552.308,198.308 551.5,198C 553.382,197.802 555.048,197.302 556.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#623d2c",
    d: "M 618.5,198.5 C 618.525,202.19 618.858,206.023 619.5,210C 619.167,211.833 618.833,213.667 618.5,215.5C 617.893,215.376 617.56,215.043 617.5,214.5C 617.66,212.801 617.494,211.134 617,209.5C 616.329,208.748 615.496,208.414 614.5,208.5C 614.5,207.833 614.5,207.167 614.5,206.5C 616.284,204.035 617.617,201.368 618.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575655",
    d: "M 581.5,162.5 C 581.833,162.5 582.167,162.5 582.5,162.5C 582.5,200.833 582.5,239.167 582.5,277.5C 574.5,277.5 566.5,277.5 558.5,277.5C 558.5,277.167 558.5,276.833 558.5,276.5C 566.167,276.5 573.833,276.5 581.5,276.5C 581.5,238.5 581.5,200.5 581.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3c4c3",
    d: "M 1023.5,88.5 C 1023.5,157.833 1023.5,227.167 1023.5,296.5C 1022.17,227.167 1022.17,157.833 1023.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb7401",
    d: "M 632.5,213.5 C 631.503,232.993 631.17,252.66 631.5,272.5C 621.5,272.5 611.5,272.5 601.5,272.5C 601.5,263.5 601.5,254.5 601.5,245.5C 602.331,233.34 602.831,221.007 603,208.5C 604.395,207.185 605.395,207.519 606,209.5C 606.718,208.549 607.551,208.383 608.5,209C 607.289,210.113 607.289,211.28 608.5,212.5C 610.847,213.151 612.514,214.484 613.5,216.5C 613.369,217.239 613.536,217.906 614,218.5C 614.77,217.402 615.603,217.402 616.5,218.5C 617.828,219.91 617.495,221.076 615.5,222C 616.044,222.717 616.711,223.217 617.5,223.5C 621.209,224.689 623.876,223.356 625.5,219.5C 625.376,218.893 625.043,218.56 624.5,218.5C 623.942,217.21 622.942,216.377 621.5,216C 623.192,214.599 623.859,212.766 623.5,210.5C 624.319,207.695 624.819,204.695 625,201.5C 625.23,205.483 626.563,206.149 629,203.5C 630.814,206.618 631.981,209.951 632.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 870.5,208.5 C 889.993,207.503 909.66,207.17 929.5,207.5C 929.827,216.682 929.493,225.682 928.5,234.5C 928.5,234.167 928.5,233.833 928.5,233.5C 928.5,225.167 928.5,216.833 928.5,208.5C 909.5,208.5 890.5,208.5 871.5,208.5C 871.167,208.5 870.833,208.5 870.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 871.5,208.5 C 890.5,208.5 909.5,208.5 928.5,208.5C 928.5,216.833 928.5,225.167 928.5,233.5C 909.5,233.5 890.5,233.5 871.5,233.5C 871.5,225.167 871.5,216.833 871.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0c7b4",
    d: "M 601.5,196.5 C 601.5,212.833 601.5,229.167 601.5,245.5C 601.5,254.5 601.5,263.5 601.5,272.5C 601.5,272.833 601.5,273.167 601.5,273.5C 600.823,250.961 600.157,228.294 599.5,205.5C 600.089,202.36 600.756,199.36 601.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a25821",
    d: "M 614.5,208.5 C 615.496,208.414 616.329,208.748 617,209.5C 617.494,211.134 617.66,212.801 617.5,214.5C 616.391,214.557 615.391,214.89 614.5,215.5C 613.933,213.031 613.933,210.698 614.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646664",
    d: "M 561.5,215.5 C 559.37,214.968 557.37,214.135 555.5,213C 558.375,212.039 560.375,212.872 561.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a95d26",
    d: "M 622.5,203.5 C 622.198,206.059 622.532,208.393 623.5,210.5C 623.859,212.766 623.192,214.599 621.5,216C 622.942,216.377 623.942,217.21 624.5,218.5C 624.44,219.043 624.107,219.376 623.5,219.5C 621.898,218.399 620.898,216.899 620.5,215C 620.992,210.995 621.659,207.162 622.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3994e",
    d: "M 5.5,200.5 C 17.8333,200.5 30.1667,200.5 42.5,200.5C 42.9172,209.915 42.4172,219.248 41,228.5C 33.7027,238.361 24.2027,241.194 12.5,237C 4.90713,231.831 1.90713,224.665 3.5,215.5C 3.3372,210.336 4.00387,205.336 5.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faad81",
    d: "M 689.5,208.5 C 695.833,208.5 702.167,208.5 708.5,208.5C 708.5,221.5 708.5,234.5 708.5,247.5C 702.167,247.5 695.833,247.5 689.5,247.5C 689.5,234.5 689.5,221.5 689.5,208.5 Z M 690.5,209.5 C 690.5,221.833 690.5,234.167 690.5,246.5C 696.167,246.5 701.833,246.5 707.5,246.5C 707.5,234.167 707.5,221.833 707.5,209.5C 701.833,209.5 696.167,209.5 690.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555556",
    d: "M 339.5,164.5 C 396.833,164.5 454.167,164.5 511.5,164.5C 511.5,182.5 511.5,200.5 511.5,218.5C 454.167,218.5 396.833,218.5 339.5,218.5C 339.5,200.5 339.5,182.5 339.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 340.5,165.5 C 397.167,165.5 453.833,165.5 510.5,165.5C 510.5,182.833 510.5,200.167 510.5,217.5C 453.833,217.5 397.167,217.5 340.5,217.5C 340.5,200.167 340.5,182.833 340.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787b7b",
    d: "M 455.5,195.5 C 455.421,196.93 455.754,198.264 456.5,199.5C 456.043,200.298 455.376,200.631 454.5,200.5C 454.5,200.167 454.5,199.833 454.5,199.5C 454.461,198.417 454.127,197.417 453.5,196.5C 453.957,195.702 454.624,195.369 455.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5f5f",
    d: "M 439.5,183.5 C 441.735,183.205 443.735,183.539 445.5,184.5C 443.833,184.5 442.167,184.5 440.5,184.5C 440.5,189.167 440.5,193.833 440.5,198.5C 440.5,199.167 440.833,199.5 441.5,199.5C 442.338,199.158 442.672,198.492 442.5,197.5C 444.833,197.5 447.167,197.5 449.5,197.5C 450.167,197.5 450.833,197.5 451.5,197.5C 451.5,198.5 451.5,199.5 451.5,200.5C 450.778,200.082 450.278,199.416 450,198.5C 448.352,200.028 446.352,200.695 444,200.5C 442.293,200.492 440.793,200.158 439.5,199.5C 439.5,194.167 439.5,188.833 439.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c5d5c",
    d: "M 421.5,196.5 C 422.594,197.582 423.927,198.248 425.5,198.5C 427.516,197.822 429.516,197.156 431.5,196.5C 431.5,197.5 431.5,198.5 431.5,199.5C 428.77,199.473 426.27,200.14 424,201.5C 422.301,201.613 421.134,200.947 420.5,199.5C 421.404,198.791 421.737,197.791 421.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcdcd",
    d: "M 452.5,184.5 C 453.833,184.5 454.5,185.167 454.5,186.5C 453.033,189.654 453.366,192.654 455.5,195.5C 454.624,195.369 453.957,195.702 453.5,196.5C 454.127,197.417 454.461,198.417 454.5,199.5C 453.833,199.5 453.5,199.833 453.5,200.5C 452.833,200.5 452.167,200.5 451.5,200.5C 451.5,199.5 451.5,198.5 451.5,197.5C 452.485,193.366 452.818,189.032 452.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868787",
    d: "M 431.5,184.5 C 432.675,184.281 433.675,184.614 434.5,185.5C 433.918,189.838 433.918,194.505 434.5,199.5C 433.5,200.833 432.5,200.833 431.5,199.5C 431.5,198.5 431.5,197.5 431.5,196.5C 431.665,193.15 431.498,189.817 431,186.5C 427.725,184.909 424.725,185.242 422,187.5C 421.502,190.482 421.335,193.482 421.5,196.5C 421.737,197.791 421.404,198.791 420.5,199.5C 419.883,199.389 419.383,199.056 419,198.5C 415.74,186.565 419.906,181.898 431.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8a",
    d: "M 445.5,184.5 C 446.708,185.234 448.041,185.567 449.5,185.5C 449.907,188.59 450.407,191.59 451,194.5C 451.179,190.975 451.679,187.641 452.5,184.5C 452.818,189.032 452.485,193.366 451.5,197.5C 450.833,197.5 450.167,197.5 449.5,197.5C 448.74,193.973 447.406,190.64 445.5,187.5C 444.675,186.614 443.675,186.281 442.5,186.5C 442.5,190.167 442.5,193.833 442.5,197.5C 442.672,198.492 442.338,199.158 441.5,199.5C 440.833,199.5 440.5,199.167 440.5,198.5C 440.5,193.833 440.5,189.167 440.5,184.5C 442.167,184.5 443.833,184.5 445.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a3a3a",
    d: "M 410.5,185.5 C 410.5,190.833 410.5,196.167 410.5,201.5C 408.901,201.768 407.568,201.434 406.5,200.5C 407.5,200.5 408.5,200.5 409.5,200.5C 409.179,195.305 409.513,190.305 410.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#212626",
    d: "M 431.5,184.5 C 433.948,183.527 436.615,183.194 439.5,183.5C 439.5,188.833 439.5,194.167 439.5,199.5C 438.85,199.804 438.183,200.137 437.5,200.5C 436.672,196.204 436.172,191.871 436,187.5C 435.824,191.688 435.324,195.688 434.5,199.5C 433.918,194.505 433.918,189.838 434.5,185.5C 433.675,184.614 432.675,184.281 431.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5d5d",
    d: "M 454.5,186.5 C 455.171,187.847 455.171,189.014 454.5,190C 456.632,191.62 456.965,193.454 455.5,195.5C 453.366,192.654 453.033,189.654 454.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989796",
    d: "M 410.5,185.5 C 409.513,190.305 409.179,195.305 409.5,200.5C 408.5,200.5 407.5,200.5 406.5,200.5C 406.5,198.5 406.5,196.5 406.5,194.5C 405.972,193.279 405.305,192.113 404.5,191C 406.55,189.364 407.55,187.198 407.5,184.5C 409.738,183.463 412.071,183.297 414.5,184C 415.451,184.718 415.617,185.551 415,186.5C 413.644,185.62 412.144,185.286 410.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#141313",
    d: "M 449.5,197.5 C 447.167,197.5 444.833,197.5 442.5,197.5C 442.5,193.833 442.5,190.167 442.5,186.5C 443.675,186.281 444.675,186.614 445.5,187.5C 447.406,190.64 448.74,193.973 449.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#434344",
    d: "M 407.5,184.5 C 407.55,187.198 406.55,189.364 404.5,191C 405.305,192.113 405.972,193.279 406.5,194.5C 404.5,194.833 402.5,195.167 400.5,195.5C 399.357,192.498 399.357,189.498 400.5,186.5C 401.281,187.737 402.281,188.737 403.5,189.5C 404.463,189.03 404.463,188.363 403.5,187.5C 405.43,187.229 406.764,186.229 407.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#060707",
    d: "M 431.5,196.5 C 429.516,197.156 427.516,197.822 425.5,198.5C 423.927,198.248 422.594,197.582 421.5,196.5C 421.335,193.482 421.502,190.482 422,187.5C 424.725,185.242 427.725,184.909 431,186.5C 431.498,189.817 431.665,193.15 431.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6d",
    d: "M 452.5,184.5 C 455.495,182.983 456.661,183.983 456,187.5C 455.617,186.944 455.117,186.611 454.5,186.5C 454.5,185.167 453.833,184.5 452.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818180",
    d: "M 403.5,187.5 C 404.463,188.363 404.463,189.03 403.5,189.5C 402.281,188.737 401.281,187.737 400.5,186.5C 399.357,189.498 399.357,192.498 400.5,195.5C 400.5,197.167 400.5,198.833 400.5,200.5C 396.045,201.027 395.379,199.527 398.5,196C 397.801,192.2 397.135,188.367 396.5,184.5C 397.95,180.661 398.95,180.661 399.5,184.5C 400.5,184.5 401.5,184.5 402.5,184.5C 402.263,185.791 402.596,186.791 403.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8d8d8",
    d: "M 145.5,218.5 C 161.5,218.5 177.5,218.5 193.5,218.5C 193.5,236.833 193.5,255.167 193.5,273.5C 177.5,273.5 161.5,273.5 145.5,273.5C 145.5,255.167 145.5,236.833 145.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#414242",
    d: "M 553.5,229.5 C 552.778,229.918 552.278,230.584 552,231.5C 550.255,230.044 548.422,228.711 546.5,227.5C 547.736,225.689 547.736,223.856 546.5,222C 547.029,220.441 547.696,218.941 548.5,217.5C 548.376,216.893 548.043,216.56 547.5,216.5C 549.187,214.834 551.187,213.5 553.5,212.5C 553.833,212.833 554.167,213.167 554.5,213.5C 553.624,214.251 552.624,214.751 551.5,215C 551.957,215.414 552.291,215.914 552.5,216.5C 551.473,219.563 550.14,222.396 548.5,225C 550.883,225.065 551.55,225.898 550.5,227.5C 551.602,228.176 552.602,228.842 553.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868786",
    d: "M -0.5,169.5 C -0.5,169.167 -0.5,168.833 -0.5,168.5C 24.1667,168.5 48.8333,168.5 73.5,168.5C 73.6666,191.169 73.5,213.836 73,236.5C 72.8019,238.382 72.3019,240.048 71.5,241.5C 72.4391,217.519 72.7724,193.519 72.5,169.5C 48.1667,169.5 23.8333,169.5 -0.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7c9b1",
    d: "M 738.5,208.5 C 744.5,208.5 750.5,208.5 756.5,208.5C 756.5,221.5 756.5,234.5 756.5,247.5C 750.5,247.5 744.5,247.5 738.5,247.5C 738.5,234.5 738.5,221.5 738.5,208.5 Z M 739.5,209.5 C 739.5,221.833 739.5,234.167 739.5,246.5C 744.833,246.5 750.167,246.5 755.5,246.5C 755.5,234.167 755.5,221.833 755.5,209.5C 750.167,209.5 744.833,209.5 739.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e17f29",
    d: "M 618.5,197.5 C 619.5,197.5 620.5,197.5 621.5,197.5C 621.517,199.565 621.85,201.565 622.5,203.5C 621.659,207.162 620.992,210.995 620.5,215C 620.898,216.899 621.898,218.399 623.5,219.5C 624.107,219.376 624.44,219.043 624.5,218.5C 625.043,218.56 625.376,218.893 625.5,219.5C 623.876,223.356 621.209,224.689 617.5,223.5C 618.793,221.636 618.793,219.636 617.5,217.5C 616.893,217.624 616.56,217.957 616.5,218.5C 615.603,217.402 614.77,217.402 614,218.5C 613.536,217.906 613.369,217.239 613.5,216.5C 614.167,216.5 614.5,216.167 614.5,215.5C 615.391,214.89 616.391,214.557 617.5,214.5C 617.56,215.043 617.893,215.376 618.5,215.5C 618.833,213.667 619.167,211.833 619.5,210C 618.858,206.023 618.525,202.19 618.5,198.5C 618.5,198.167 618.5,197.833 618.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d8d8",
    d: "M 320.5,220.5 C 321.24,228.253 321.406,236.253 321,244.5C 320.667,243.833 320.333,243.167 320,242.5C 312.827,245.22 313.327,246.553 321.5,246.5C 321.5,248.5 321.5,250.5 321.5,252.5C 310.833,253.167 310.833,253.833 321.5,254.5C 321.5,257.167 321.5,259.833 321.5,262.5C 312.316,263.753 312.316,264.419 321.5,264.5C 321.296,267.518 320.963,270.518 320.5,273.5C 306.484,273.833 292.484,273.499 278.5,272.5C 277.312,270.738 275.645,269.738 273.5,269.5C 273.506,258.015 273.173,246.682 272.5,235.5C 275.187,235.664 277.854,235.497 280.5,235C 278.7,231.366 276.034,228.533 272.5,226.5C 277.548,225.786 282.548,225.119 287.5,224.5C 294.805,225.354 302.138,225.687 309.5,225.5C 312.744,224.382 316.077,223.549 319.5,223C 320.252,222.329 320.586,221.496 320.5,220.5 Z M 315.5,232.5 C 316.239,232.369 316.906,232.536 317.5,233C 314.852,237.833 314.185,237.666 315.5,232.5 Z M 302.5,252.5 C 304.103,252.312 305.437,252.812 306.5,254C 304.537,254.844 303.204,254.344 302.5,252.5 Z M 311.5,262.5 C 313.592,263.286 313.259,264.286 310.5,265.5C 303.577,265.449 296.743,265.449 290,265.5C 288.933,264.809 287.766,264.309 286.5,264C 295.01,263.829 303.343,263.329 311.5,262.5 Z M 317.5,267.5 C 320.137,269.154 319.803,269.654 316.5,269C 317.056,268.617 317.389,268.117 317.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a36e4d",
    d: "M 616.5,218.5 C 616.56,217.957 616.893,217.624 617.5,217.5C 618.793,219.636 618.793,221.636 617.5,223.5C 616.711,223.217 616.044,222.717 615.5,222C 617.495,221.076 617.828,219.91 616.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555656",
    d: "M 561.5,211.5 C 561.833,211.5 562.167,211.5 562.5,211.5C 563.885,212.574 565.051,213.907 566,215.5C 566.709,219.868 566.542,224.201 565.5,228.5C 568.364,231.343 567.697,233.01 563.5,233.5C 562.558,233.392 561.725,233.059 561,232.5C 560.066,233.858 559.232,235.192 558.5,236.5C 556.5,235.833 554.5,235.167 552.5,234.5C 557.992,235.335 559.326,233.668 556.5,229.5C 558.369,228.376 560.369,227.543 562.5,227C 561.833,226.667 561.167,226.333 560.5,226C 561.893,223.822 563.56,222.822 565.5,223C 564.538,220.239 563.205,217.739 561.5,215.5C 562.686,214.295 562.686,212.961 561.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757475",
    d: "M 547.5,216.5 C 548.043,216.56 548.376,216.893 548.5,217.5C 547.696,218.941 547.029,220.441 546.5,222C 547.736,223.856 547.736,225.689 546.5,227.5C 548.422,228.711 550.255,230.044 552,231.5C 552.278,230.584 552.778,229.918 553.5,229.5C 554.765,231.357 554.432,233.024 552.5,234.5C 554.5,235.167 556.5,235.833 558.5,236.5C 549.167,237.167 549.167,237.833 558.5,238.5C 558.827,243.214 558.493,247.88 557.5,252.5C 556.673,248.541 556.173,244.541 556,240.5C 555,241.833 554,241.833 553,240.5C 552.827,244.541 552.327,248.541 551.5,252.5C 550.829,245.903 549.829,239.403 548.5,233C 548.833,232.667 549.167,232.333 549.5,232C 546.048,230.711 544.381,228.211 544.5,224.5C 544.55,221.459 545.55,218.792 547.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545454",
    d: "M 870.5,208.5 C 870.833,208.5 871.167,208.5 871.5,208.5C 871.5,216.833 871.5,225.167 871.5,233.5C 890.5,233.5 909.5,233.5 928.5,233.5C 928.5,233.833 928.5,234.167 928.5,234.5C 909.167,234.5 889.833,234.5 870.5,234.5C 870.5,225.833 870.5,217.167 870.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9baba",
    d: "M 404.5,234.5 C 440.167,234.5 475.833,234.5 511.5,234.5C 511.5,248.167 511.5,261.833 511.5,275.5C 474.937,275.778 438.937,276.111 403.5,276.5C 403.185,262.421 403.518,248.421 404.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6a",
    d: "M 811.5,278.5 C 811.833,278.5 812.167,278.5 812.5,278.5C 824.167,278.5 835.833,278.5 847.5,278.5C 847.5,240.5 847.5,202.5 847.5,164.5C 835.833,164.5 824.167,164.5 812.5,164.5C 812.5,166.5 812.5,168.5 812.5,170.5C 812.167,170.5 811.833,170.5 811.5,170.5C 811.5,169.5 811.5,168.5 811.5,167.5C 811.5,165.833 811.5,164.167 811.5,162.5C 823.856,162.296 836.189,162.63 848.5,163.5C 848.5,202.167 848.5,240.833 848.5,279.5C 835.989,279.829 823.655,279.495 811.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6d7d7",
    d: "M 870.5,249.5 C 914.833,249.5 959.167,249.5 1003.5,249.5C 1003.51,263.361 1003.18,277.027 1002.5,290.5C 958.5,290.5 914.5,290.5 870.5,290.5C 870.5,276.833 870.5,263.167 870.5,249.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575657",
    d: "M 563.5,263.5 C 560.5,263.5 557.5,263.5 554.5,263.5C 553.833,263.5 553.5,263.833 553.5,264.5C 550.631,261.318 550.131,257.651 552,253.5C 552.498,256.482 552.665,259.482 552.5,262.5C 554.492,262.672 556.158,262.005 557.5,260.5C 559.427,261.862 561.427,262.862 563.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8f8e",
    d: "M 54.5,259.5 C 52.7857,260.738 50.7857,261.405 48.5,261.5C 50.1016,259.926 52.1016,259.259 54.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f8081",
    d: "M -0.5,261.5 C -0.5,261.167 -0.5,260.833 -0.5,260.5C 1.55292,260.402 3.21959,261.069 4.5,262.5C 2.7839,262.371 1.11723,262.038 -0.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcddda",
    d: "M 384.5,269.5 C 385.833,270.167 385.833,270.167 384.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7dadc",
    d: "M 273.5,269.5 C 273.657,270.873 273.49,272.207 273,273.5C 272.235,271.934 272.402,270.601 273.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc965b",
    d: "M 661.5,241.5 C 662.497,259.326 662.83,277.326 662.5,295.5C 664.5,295.5 666.5,295.5 668.5,295.5C 666.393,296.468 664.059,296.802 661.5,296.5C 661.5,278.167 661.5,259.833 661.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8dcdd",
    d: "M 388.5,272.5 C 389.833,273.167 389.833,273.167 388.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6ae70",
    d: "M 632.5,213.5 C 632.5,233.5 632.5,253.5 632.5,273.5C 622.167,273.5 611.833,273.5 601.5,273.5C 601.5,273.167 601.5,272.833 601.5,272.5C 611.5,272.5 621.5,272.5 631.5,272.5C 631.17,252.66 631.503,232.993 632.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbac68",
    d: "M 210.5,123.5 C 210.5,173.5 210.5,223.5 210.5,273.5C 224.167,273.5 237.833,273.5 251.5,273.5C 251.182,242.456 251.515,211.456 252.5,180.5C 252.527,211.612 252.527,242.945 252.5,274.5C 238.167,274.5 223.833,274.5 209.5,274.5C 209.168,223.997 209.501,173.664 210.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#894c12",
    d: "M 239.5,251.5 C 239.5,253.5 239.5,255.5 239.5,257.5C 234.167,257.5 228.833,257.5 223.5,257.5C 228.349,256.834 233.349,256.167 238.5,255.5C 237.068,253.703 237.401,252.37 239.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#36291c",
    d: "M 236.5,248.5 C 238.167,248.5 239.833,248.5 241.5,248.5C 242.239,248.369 242.906,248.536 243.5,249C 242.263,249.232 241.263,249.732 240.5,250.5C 239.833,250.5 239.5,250.833 239.5,251.5C 237.401,252.37 237.068,253.703 238.5,255.5C 233.349,256.167 228.349,256.834 223.5,257.5C 221.51,257.007 221.51,255.84 223.5,254C 222.934,253.005 222.267,252.172 221.5,251.5C 221.47,250.503 221.97,249.836 223,249.5C 225.413,250.024 227.58,251.024 229.5,252.5C 230.386,251.675 230.719,250.675 230.5,249.5C 232.735,249.795 234.735,249.461 236.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#965822",
    d: "M 241.5,248.5 C 242.601,247.402 243.934,247.235 245.5,248C 244.383,249.892 242.716,250.725 240.5,250.5C 241.263,249.732 242.263,249.232 243.5,249C 242.906,248.536 242.239,248.369 241.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#af5c11",
    d: "M 236.5,248.5 C 234.735,249.461 232.735,249.795 230.5,249.5C 230.719,250.675 230.386,251.675 229.5,252.5C 227.58,251.024 225.413,250.024 223,249.5C 221.97,249.836 221.47,250.503 221.5,251.5C 220.596,250.791 220.263,249.791 220.5,248.5C 225.833,248.5 231.167,248.5 236.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e5919",
    d: "M 234.5,233.5 C 237.167,233.5 239.833,233.5 242.5,233.5C 242.5,235.167 242.5,236.833 242.5,238.5C 237.156,238.666 231.823,238.499 226.5,238C 225.263,237.768 224.263,237.268 223.5,236.5C 226.711,236.988 229.544,236.321 232,234.5C 232.374,235.416 232.874,236.25 233.5,237C 236.146,237.497 238.813,237.664 241.5,237.5C 241.5,236.5 241.5,235.5 241.5,234.5C 238.941,234.802 236.607,234.468 234.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4736",
    d: "M 224.5,231.5 C 227.833,232.167 231.167,232.833 234.5,233.5C 236.607,234.468 238.941,234.802 241.5,234.5C 241.5,235.5 241.5,236.5 241.5,237.5C 238.813,237.664 236.146,237.497 233.5,237C 232.874,236.25 232.374,235.416 232,234.5C 229.544,236.321 226.711,236.988 223.5,236.5C 221.31,235.626 220.31,233.959 220.5,231.5C 221.833,231.5 223.167,231.5 224.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e5a23",
    d: "M 224.5,231.5 C 223.167,231.5 221.833,231.5 220.5,231.5C 220.31,233.959 221.31,235.626 223.5,236.5C 222.167,236.5 220.833,236.5 219.5,236.5C 219.5,234.5 219.5,232.5 219.5,230.5C 221.415,230.216 223.081,230.549 224.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#653e1a",
    d: "M 221.5,210.5 C 221.5,211.5 221.5,212.5 221.5,213.5C 227.664,215.228 233.997,215.894 240.5,215.5C 233.656,216.819 226.656,216.819 219.5,215.5C 220.028,213.664 220.694,211.997 221.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242826",
    d: "M 224.5,205.5 C 225.833,205.5 227.167,205.5 228.5,205.5C 228.838,207.854 229.338,210.187 230,212.5C 233.418,211.734 236.918,211.734 240.5,212.5C 240.5,213.5 240.5,214.5 240.5,215.5C 233.997,215.894 227.664,215.228 221.5,213.5C 221.5,212.5 221.5,211.5 221.5,210.5C 222.248,208.668 223.248,207.001 224.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#914613",
    d: "M 224.5,205.5 C 227.794,203.903 230.794,204.403 233.5,207C 231.385,207.424 230.552,208.591 231,210.5C 231.561,209.978 232.228,209.645 233,209.5C 235.135,210.127 237.302,210.627 239.5,211C 240.056,211.383 240.389,211.883 240.5,212.5C 236.918,211.734 233.418,211.734 230,212.5C 229.338,210.187 228.838,207.854 228.5,205.5C 227.167,205.5 225.833,205.5 224.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3540f",
    d: "M 237.5,189.5 C 239.924,189.192 242.257,189.526 244.5,190.5C 244.145,191.522 243.478,192.189 242.5,192.5C 241.198,190.972 239.531,189.972 237.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a36821",
    d: "M 231.5,181.5 C 232.748,182.334 233.415,183.667 233.5,185.5C 233.167,186.833 232.833,188.167 232.5,189.5C 231.52,186.914 231.187,184.247 231.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadddb",
    d: "M 388.5,273.5 C 387.833,274.167 387.833,274.167 388.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070708",
    d: "M -0.5,274.5 C 24.0057,274.169 48.3391,274.502 72.5,275.5C 72.5,288.167 72.5,300.833 72.5,313.5C 48.1667,313.5 23.8333,313.5 -0.5,313.5C -0.5,300.5 -0.5,287.5 -0.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8e8e",
    d: "M 532.5,49.5 C 532.5,49.8333 532.5,50.1667 532.5,50.5C 532.25,125.838 532.583,201.172 533.5,276.5C 540.508,276.666 547.508,276.5 554.5,276C 553.54,272.27 553.207,268.437 553.5,264.5C 553.5,263.833 553.833,263.5 554.5,263.5C 554.5,266.833 554.5,270.167 554.5,273.5C 556.95,273.702 559.283,273.369 561.5,272.5C 561.578,275.487 560.411,276.153 558,274.5C 554.557,275.864 554.724,276.531 558.5,276.5C 558.5,276.833 558.5,277.167 558.5,277.5C 549.833,277.5 541.167,277.5 532.5,277.5C 531.247,201.337 531.247,125.337 532.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6a18",
    d: "M 739.5,337.5 C 738.503,353.992 738.17,370.658 738.5,387.5C 728.5,387.5 718.5,387.5 708.5,387.5C 708.83,371.658 708.496,355.991 707.5,340.5C 702.655,331.199 696.988,330.532 690.5,338.5C 689.504,354.658 689.17,370.991 689.5,387.5C 680.167,387.5 670.833,387.5 661.5,387.5C 660.337,366.337 660.171,345.004 661,323.5C 661.582,313.829 666.082,306.662 674.5,302C 687.851,296.771 700.851,297.437 713.5,304C 718.084,307.593 721.584,312.093 724,317.5C 727.848,306.477 735.681,300.644 747.5,300C 759.592,297.549 770.426,300.049 780,307.5C 783.368,311.935 785.368,316.935 786,322.5C 789.637,346.9 789.304,371.234 785,395.5C 784.261,399.062 782.761,402.228 780.5,405C 771.833,405.667 763.167,405.667 754.5,405C 752.112,402.694 751.112,399.861 751.5,396.5C 752.478,389.065 753.978,381.732 756,374.5C 756.667,363.5 756.667,352.5 756,341.5C 754.311,333.937 749.811,331.437 742.5,334C 741.364,335.145 740.364,336.312 739.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a8a8",
    d: "M 202.5,300.5 C 208.537,300.171 214.537,300.504 220.5,301.5C 229.024,313.904 237.524,326.238 246,338.5C 246.5,325.838 246.667,313.171 246.5,300.5C 253.5,300.5 260.5,300.5 267.5,300.5C 267.5,323.833 267.5,347.167 267.5,370.5C 260.825,370.666 254.158,370.5 247.5,370C 242.71,363.541 237.543,357.374 232,351.5C 230.16,346.48 227.327,342.146 223.5,338.5C 222.501,349.146 222.168,359.813 222.5,370.5C 215.833,370.5 209.167,370.5 202.5,370.5C 202.5,347.167 202.5,323.833 202.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a7a7",
    d: "M 106.5,300.5 C 111.752,301.285 117.085,301.785 122.5,302C 129.167,303.619 131.333,307.786 129,314.5C 128.5,315.5 128,316.5 127.5,317.5C 121.537,318.496 115.537,318.829 109.5,318.5C 109.264,321.226 110.097,323.559 112,325.5C 115.973,329.318 120.306,332.651 125,335.5C 137.179,353.619 132.679,365.786 111.5,372C 101.871,373.67 92.8711,372.004 84.5,367C 83.8333,366 83.1667,365 82.5,364C 85.1277,355.842 90.7944,351.842 99.5,352C 100.91,351.632 101.91,350.799 102.5,349.5C 97.1866,343.019 91.6866,336.686 86,330.5C 81.6731,312.811 88.5064,302.811 106.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a9a9",
    d: "M 566.5,300.5 C 580.504,300.333 594.504,300.5 608.5,301C 626.554,305.091 635.888,316.424 636.5,335C 635.256,354.818 624.923,366.818 605.5,371C 592.504,371.5 579.504,371.667 566.5,371.5C 566.5,347.833 566.5,324.167 566.5,300.5 Z M 591.5,320.5 C 598.251,319.295 604.085,320.962 609,325.5C 611.913,334.273 610.413,342.106 604.5,349C 600.312,350.631 595.979,351.464 591.5,351.5C 591.5,341.167 591.5,330.833 591.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0e0f",
    d: "M 994.5,304.5 C 997.336,305.776 1000.34,306.442 1003.5,306.5C 1005.68,308.585 1008.35,309.585 1011.5,309.5C 1013.15,309.66 1014.49,310.326 1015.5,311.5C 1015.82,313.048 1016.82,313.715 1018.5,313.5C 1018.83,314.833 1019.17,316.167 1019.5,317.5C 1018.52,321.634 1018.18,325.968 1018.5,330.5C 1017.5,330.5 1016.5,330.5 1015.5,330.5C 1011.84,330.277 1008.5,329.277 1005.5,327.5C 1002.26,325.624 998.93,325.29 995.5,326.5C 993.343,327.407 991.01,328.073 988.5,328.5C 986.958,329.301 985.292,329.634 983.5,329.5C 983.5,330.5 983.5,331.5 983.5,332.5C 985.685,332.704 987.685,333.37 989.5,334.5C 999.857,333.992 1008.86,336.992 1016.5,343.5C 1017.08,345.749 1018.41,347.415 1020.5,348.5C 1021.8,350.371 1022.8,352.371 1023.5,354.5C 1023.5,359.167 1023.5,363.833 1023.5,368.5C 1022.59,370.933 1021.59,373.433 1020.5,376C 1015.33,379.085 1010.33,382.419 1005.5,386C 996.88,387.464 988.213,387.798 979.5,387C 975.509,386.502 971.842,385.335 968.5,383.5C 967.365,381.787 965.698,381.12 963.5,381.5C 961.559,381.131 959.725,380.464 958,379.5C 954.578,369.634 957.912,363.967 968,362.5C 970.111,362.701 971.945,363.367 973.5,364.5C 974.78,365.931 976.447,366.598 978.5,366.5C 983.14,367.397 987.806,367.564 992.5,367C 994.332,366.252 995.999,365.252 997.5,364C 996.619,363.292 995.953,362.458 995.5,361.5C 994.713,359.896 993.38,359.229 991.5,359.5C 991.027,358.094 990.027,357.427 988.5,357.5C 984.767,355.589 980.767,354.256 976.5,353.5C 974.102,353.741 972.102,353.074 970.5,351.5C 969.738,349.738 968.404,348.738 966.5,348.5C 961.844,345.863 959.178,341.863 958.5,336.5C 958.413,331.463 958.746,326.463 959.5,321.5C 959.263,320.209 959.596,319.209 960.5,318.5C 962.262,317.738 963.262,316.404 963.5,314.5C 972.402,307.2 982.736,303.867 994.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919191",
    d: "M 994.5,304.5 C 994.917,303.876 995.584,303.543 996.5,303.5C 998.895,304.655 1001.23,305.655 1003.5,306.5C 1000.34,306.442 997.336,305.776 994.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5a5a5",
    d: "M 145.5,300.5 C 159.504,300.333 173.504,300.5 187.5,301C 188.806,306.446 188.806,311.946 187.5,317.5C 180.558,316.536 173.558,316.203 166.5,316.5C 166.5,320.5 166.5,324.5 166.5,328.5C 173.167,328.5 179.833,328.5 186.5,328.5C 186.8,333.333 186.8,337.999 186.5,342.5C 179.833,342.5 173.167,342.5 166.5,342.5C 166.5,346.167 166.5,349.833 166.5,353.5C 173.508,353.334 180.508,353.5 187.5,354C 188.471,359.072 188.805,364.238 188.5,369.5C 174.27,370.612 160.103,370.612 146,369.5C 145.5,346.502 145.333,323.502 145.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 871.5,307.5 C 871.5,313.833 871.5,320.167 871.5,326.5C 860.986,326.172 850.653,326.506 840.5,327.5C 840.5,330.833 840.5,334.167 840.5,337.5C 850.653,338.494 860.986,338.828 871.5,338.5C 871.5,342.833 871.5,347.167 871.5,351.5C 860.986,351.172 850.653,351.506 840.5,352.5C 840.5,357.167 840.5,361.833 840.5,366.5C 848.167,366.5 855.833,366.5 863.5,366.5C 866.287,367.477 869.287,367.81 872.5,367.5C 872.5,373.167 872.5,378.833 872.5,384.5C 852.5,384.5 832.5,384.5 812.5,384.5C 812.5,358.833 812.5,333.167 812.5,307.5C 832.167,307.5 851.833,307.5 871.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#565656",
    d: "M 887.5,308.5 C 887.5,308.167 887.5,307.833 887.5,307.5C 907.844,307.167 928.178,307.5 948.5,308.5C 948.376,309.107 948.043,309.44 947.5,309.5C 927.674,308.503 907.674,308.17 887.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 528.5,301.5 C 535.982,300.508 543.648,300.175 551.5,300.5C 551.831,324.006 551.498,347.339 550.5,370.5C 550.5,347.5 550.5,324.5 550.5,301.5C 543.167,301.5 535.833,301.5 528.5,301.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 887.5,308.5 C 907.674,308.17 927.674,308.503 947.5,309.5C 947.982,312.721 947.982,316.054 947.5,319.5C 946.539,321.265 946.205,323.265 946.5,325.5C 936.167,325.5 925.833,325.5 915.5,325.5C 915.5,328.5 915.5,331.5 915.5,334.5C 925.833,334.5 936.167,334.5 946.5,334.5C 947.833,339.5 947.833,344.5 946.5,349.5C 936.167,349.5 925.833,349.5 915.5,349.5C 915.5,354.833 915.5,360.167 915.5,365.5C 926.167,365.5 936.833,365.5 947.5,365.5C 947.5,371.833 947.5,378.167 947.5,384.5C 927.5,384.5 907.5,384.5 887.5,384.5C 887.5,359.167 887.5,333.833 887.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7d7d",
    d: "M 1003.5,306.5 C 1006.44,306.98 1009.11,307.98 1011.5,309.5C 1008.35,309.585 1005.68,308.585 1003.5,306.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9d9d",
    d: "M 872.5,307.5 C 872.167,307.5 871.833,307.5 871.5,307.5C 851.833,307.5 832.167,307.5 812.5,307.5C 812.5,333.167 812.5,358.833 812.5,384.5C 812.5,384.833 812.5,385.167 812.5,385.5C 811.502,359.339 811.169,333.005 811.5,306.5C 832.007,306.17 852.34,306.503 872.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8b",
    d: "M 1015.5,311.5 C 1016.71,311.932 1017.71,312.599 1018.5,313.5C 1016.82,313.715 1015.82,313.048 1015.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#676768",
    d: "M 72.5,275.5 C 73.4955,288.323 73.8288,301.323 73.5,314.5C 48.8333,314.5 24.1667,314.5 -0.5,314.5C -0.5,314.167 -0.5,313.833 -0.5,313.5C 23.8333,313.5 48.1667,313.5 72.5,313.5C 72.5,300.833 72.5,288.167 72.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999c9c",
    d: "M 1018.5,313.5 C 1020.52,314.538 1020.85,315.872 1019.5,317.5C 1019.17,316.167 1018.83,314.833 1018.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7b7c7c",
    d: "M 963.5,314.5 C 963.262,316.404 962.262,317.738 960.5,318.5C 960.738,316.596 961.738,315.262 963.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a9",
    d: "M 363.5,299.5 C 376.171,299.333 388.838,299.5 401.5,300C 422.089,302.898 428.923,314.065 422,333.5C 419.688,336.979 416.854,339.979 413.5,342.5C 419.638,351.804 425.972,360.971 432.5,370C 423.167,370.667 413.833,370.667 404.5,370C 400.043,363.048 395.043,356.548 389.5,350.5C 388.816,357.055 388.149,363.555 387.5,370C 379.507,370.5 371.507,370.666 363.5,370.5C 363.5,346.833 363.5,323.167 363.5,299.5 Z M 389.5,319.5 C 400.329,318.796 402.995,322.962 397.5,332C 394.607,333.149 391.607,333.649 388.5,333.5C 388.226,328.737 388.559,324.07 389.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a1a2",
    d: "M 1019.5,317.5 C 1020.61,322.023 1020.27,326.357 1018.5,330.5C 1018.18,325.968 1018.52,321.634 1019.5,317.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a0909",
    d: "M 34.5,324.5 C 36.9052,325.768 39.5718,326.435 42.5,326.5C 45.3973,327.129 48.064,328.129 50.5,329.5C 51.5387,331.531 53.2054,332.864 55.5,333.5C 57.5735,334.3 59.2402,335.633 60.5,337.5C 61.4194,340.089 63.086,342.089 65.5,343.5C 65.427,345.027 66.0937,346.027 67.5,346.5C 77.2754,365.322 76.7754,383.989 66,402.5C 56.7994,414.517 44.6328,420.183 29.5,419.5C 23.171,419.1 16.8376,418.767 10.5,418.5C 6.8455,418.058 3.17884,417.724 -0.5,417.5C -0.5,405.167 -0.5,392.833 -0.5,380.5C 7.90818,398.248 20.4082,401.915 37,391.5C 38.7501,387.664 40.7501,383.998 43,380.5C 46.8558,364.865 41.3558,354.532 26.5,349.5C 24.3452,347.466 22.0118,347.133 19.5,348.5C 8.99178,350.031 2.32512,355.697 -0.5,365.5C -0.5,352.833 -0.5,340.167 -0.5,327.5C 0.833333,327.167 2.16667,326.833 3.5,326.5C 5.7857,326.405 7.7857,325.738 9.5,324.5C 17.8333,323.167 26.1667,323.167 34.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858787",
    d: "M 9.5,324.5 C 7.7857,325.738 5.7857,326.405 3.5,326.5C 5.10163,324.926 7.10163,324.259 9.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797a79",
    d: "M 34.5,324.5 C 37.4951,324.294 40.1617,324.96 42.5,326.5C 39.5718,326.435 36.9052,325.768 34.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606060",
    d: "M 871.5,307.5 C 871.833,307.5 872.167,307.5 872.5,307.5C 872.5,314.167 872.5,320.833 872.5,327.5C 861.833,327.5 851.167,327.5 840.5,327.5C 850.653,326.506 860.986,326.172 871.5,326.5C 871.5,320.167 871.5,313.833 871.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707172",
    d: "M 995.5,326.5 C 998.93,325.29 1002.26,325.624 1005.5,327.5C 1002.17,327.167 998.833,326.833 995.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717171",
    d: "M 959.5,321.5 C 958.746,326.463 958.413,331.463 958.5,336.5C 957.838,334.696 957.505,332.696 957.5,330.5C 957.343,327.186 958.009,324.186 959.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505151",
    d: "M 988.5,328.5 C 988.461,329.583 988.127,330.583 987.5,331.5C 988.193,332.518 988.859,333.518 989.5,334.5C 987.685,333.37 985.685,332.704 983.5,332.5C 983.5,331.5 983.5,330.5 983.5,329.5C 985.292,329.634 986.958,329.301 988.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818281",
    d: "M 50.5,329.5 C 52.754,330.124 54.4206,331.457 55.5,333.5C 53.2054,332.864 51.5387,331.531 50.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#737273",
    d: "M 1015.5,330.5 C 1016.5,330.5 1017.5,330.5 1018.5,330.5C 1018.04,332.557 1017.04,332.557 1015.5,330.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a2a3",
    d: "M 947.5,319.5 C 947.5,321.833 947.5,324.167 947.5,326.5C 937.167,326.5 926.833,326.5 916.5,326.5C 916.5,328.833 916.5,331.167 916.5,333.5C 926.681,333.173 936.681,333.506 946.5,334.5C 936.167,334.5 925.833,334.5 915.5,334.5C 915.5,331.5 915.5,328.5 915.5,325.5C 925.833,325.5 936.167,325.5 946.5,325.5C 946.205,323.265 946.539,321.265 947.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3c3c3",
    d: "M 499.5,300.5 C 493.167,300.5 486.833,300.5 480.5,300.5C 480.5,323.833 480.5,347.167 480.5,370.5C 487.833,370.5 495.167,370.5 502.5,370.5C 502.168,359.147 502.501,347.814 503.5,336.5C 504.107,336.624 504.44,336.957 504.5,337.5C 503.505,348.654 503.172,359.988 503.5,371.5C 495.5,371.5 487.5,371.5 479.5,371.5C 479.5,347.5 479.5,323.5 479.5,299.5C 486.354,299.176 493.021,299.509 499.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727270",
    d: "M 60.5,337.5 C 62.914,338.911 64.5806,340.911 65.5,343.5C 63.086,342.089 61.4194,340.089 60.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaaaaa",
    d: "M 440.5,299.5 C 448.752,299.184 456.919,299.518 465,300.5C 465.5,323.831 465.667,347.164 465.5,370.5C 456.833,370.5 448.167,370.5 439.5,370.5C 439.177,346.759 439.511,323.092 440.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757677",
    d: "M 840.5,337.5 C 851.167,337.5 861.833,337.5 872.5,337.5C 872.5,342.5 872.5,347.5 872.5,352.5C 862.167,352.5 851.833,352.5 841.5,352.5C 841.167,352.5 840.833,352.5 840.5,352.5C 850.653,351.506 860.986,351.172 871.5,351.5C 871.5,347.167 871.5,342.833 871.5,338.5C 860.986,338.828 850.653,338.494 840.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a8",
    d: "M 499.5,300.5 C 508.74,312.613 518.24,324.613 528,336.5C 528.5,324.838 528.667,313.171 528.5,301.5C 535.833,301.5 543.167,301.5 550.5,301.5C 550.5,324.5 550.5,347.5 550.5,370.5C 543.345,371.655 536.012,371.822 528.5,371C 520.358,359.863 512.358,348.696 504.5,337.5C 504.44,336.957 504.107,336.624 503.5,336.5C 502.501,347.814 502.168,359.147 502.5,370.5C 495.167,370.5 487.833,370.5 480.5,370.5C 480.5,347.167 480.5,323.833 480.5,300.5C 486.833,300.5 493.167,300.5 499.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8a8b",
    d: "M 1016.5,343.5 C 1018.59,344.585 1019.92,346.251 1020.5,348.5C 1018.41,347.415 1017.08,345.749 1016.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8f8f",
    d: "M 65.5,343.5 C 66.9063,343.973 67.573,344.973 67.5,346.5C 66.0937,346.027 65.427,345.027 65.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c391f",
    d: "M 19.5,348.5 C 22.0118,347.133 24.3452,347.466 26.5,349.5C 24.1944,349.007 21.861,348.674 19.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f6e6f",
    d: "M 966.5,348.5 C 968.404,348.738 969.738,349.738 970.5,351.5C 968.596,351.262 967.262,350.262 966.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69696a",
    d: "M 976.5,353.5 C 980.767,354.256 984.767,355.589 988.5,357.5C 984.085,357.139 980.085,355.806 976.5,353.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9aaaa",
    d: "M 281.5,300.5 C 290.167,300.5 298.833,300.5 307.5,300.5C 307.333,315.504 307.5,330.504 308,345.5C 311.274,350.738 315.774,351.904 321.5,349C 322.893,347.829 323.727,346.329 324,344.5C 324.5,329.837 324.667,315.17 324.5,300.5C 332.5,300.5 340.5,300.5 348.5,300.5C 348.667,317.17 348.5,333.837 348,350.5C 347.067,361.767 340.9,368.6 329.5,371C 318.011,373.256 306.678,372.59 295.5,369C 290,366.167 285.833,362 283,356.5C 281.539,337.902 281.039,319.235 281.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfcecc",
    d: "M 971.5,355.5 C 972.833,356.167 972.833,356.167 971.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69a51",
    d: "M 19.5,348.5 C 21.861,348.674 24.1944,349.007 26.5,349.5C 41.3558,354.532 46.8558,364.865 43,380.5C 40.7501,383.998 38.7501,387.664 37,391.5C 20.4082,401.915 7.90818,398.248 -0.5,380.5C -0.5,375.5 -0.5,370.5 -0.5,365.5C 2.32512,355.697 8.99178,350.031 19.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M 988.5,357.5 C 990.027,357.427 991.027,358.094 991.5,359.5C 989.973,359.573 988.973,358.906 988.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979895",
    d: "M 991.5,359.5 C 993.38,359.229 994.713,359.896 995.5,361.5C 993.847,361.34 992.514,360.674 991.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9a9aa",
    d: "M 946.5,349.5 C 936.681,350.494 926.681,350.827 916.5,350.5C 916.5,355.167 916.5,359.833 916.5,364.5C 927.346,364.172 938.013,364.506 948.5,365.5C 948.167,365.5 947.833,365.5 947.5,365.5C 936.833,365.5 926.167,365.5 915.5,365.5C 915.5,360.167 915.5,354.833 915.5,349.5C 925.833,349.5 936.167,349.5 946.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b5b5",
    d: "M 840.5,352.5 C 840.833,352.5 841.167,352.5 841.5,352.5C 841.5,356.833 841.5,361.167 841.5,365.5C 849.019,365.175 856.352,365.508 863.5,366.5C 855.833,366.5 848.167,366.5 840.5,366.5C 840.5,361.833 840.5,357.167 840.5,352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838382",
    d: "M 973.5,364.5 C 975.553,364.402 977.22,365.069 978.5,366.5C 976.447,366.598 974.78,365.931 973.5,364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcad7f",
    d: "M 690.5,338.5 C 690.5,355.167 690.5,371.833 690.5,388.5C 680.652,388.827 670.986,388.494 661.5,387.5C 670.833,387.5 680.167,387.5 689.5,387.5C 689.17,370.991 689.504,354.658 690.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767676",
    d: "M 963.5,381.5 C 965.698,381.12 967.365,381.787 968.5,383.5C 966.597,383.204 964.93,382.537 963.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fca573",
    d: "M 162.5,410.5 C 162.167,410.5 161.833,410.5 161.5,410.5C 161.5,402.167 161.5,393.833 161.5,385.5C 139.167,385.5 116.833,385.5 94.5,385.5C 94.5,421.833 94.5,458.167 94.5,494.5C 93.5015,458.004 93.1682,421.337 93.5,384.5C 116.5,384.5 139.5,384.5 162.5,384.5C 162.5,393.167 162.5,401.833 162.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb28a",
    d: "M 205.5,386.5 C 198.922,385.54 192.255,385.207 185.5,385.5C 185.5,421.833 185.5,458.167 185.5,494.5C 184.502,458.004 184.168,421.337 184.5,384.5C 191.913,383.872 198.913,384.539 205.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6a16",
    d: "M 445.5,384.5 C 446.833,421.167 446.833,457.833 445.5,494.5C 434.833,494.5 424.167,494.5 413.5,494.5C 413.5,457.833 413.5,421.167 413.5,384.5C 424.167,384.5 434.833,384.5 445.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd8f50",
    d: "M 535.5,384.5 C 514.402,385.826 493.402,385.826 472.5,384.5C 493.58,384.479 514.58,384.479 535.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6b1a",
    d: "M 627.5,387.5 C 628.635,389.213 630.302,389.88 632.5,389.5C 636.046,390.043 638.379,392.043 639.5,395.5C 637.19,403.62 633.19,410.787 627.5,417C 619.14,414.36 610.474,412.527 601.5,411.5C 593.016,413.54 592.349,417.04 599.5,422C 608.731,424.743 617.731,428.077 626.5,432C 639.465,440.439 644.298,452.273 641,467.5C 633.953,488.948 619.12,498.781 596.5,497C 578.888,495.918 563.888,489.252 551.5,477C 560.44,471.623 566.94,464.123 571,454.5C 573.278,455.719 575.445,457.052 577.5,458.5C 577.427,460.027 578.094,461.027 579.5,461.5C 587.748,466.642 596.748,468.476 606.5,467C 610.735,461.423 609.401,457.423 602.5,455C 591.701,451.843 581.368,447.51 571.5,442C 563.969,436.771 560.302,429.604 560.5,420.5C 561.344,416.901 561.677,413.234 561.5,409.5C 563.489,398.847 569.489,391.514 579.5,387.5C 581.553,387.598 583.22,386.931 584.5,385.5C 589.59,384.035 594.923,383.368 600.5,383.5C 607.191,383.669 613.858,384.169 620.5,385C 623.104,385.39 625.438,386.224 627.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#565657",
    d: "M 863.5,366.5 C 866.833,366.5 870.167,366.5 873.5,366.5C 873.5,372.833 873.5,379.167 873.5,385.5C 853.167,385.5 832.833,385.5 812.5,385.5C 812.5,385.167 812.5,384.833 812.5,384.5C 832.5,384.5 852.5,384.5 872.5,384.5C 872.5,378.833 872.5,373.167 872.5,367.5C 869.287,367.81 866.287,367.477 863.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747474",
    d: "M 887.5,307.5 C 887.5,307.833 887.5,308.167 887.5,308.5C 887.5,333.833 887.5,359.167 887.5,384.5C 907.5,384.5 927.5,384.5 947.5,384.5C 947.5,378.167 947.5,371.833 947.5,365.5C 947.833,365.5 948.167,365.5 948.5,365.5C 948.5,372.167 948.5,378.833 948.5,385.5C 927.833,385.5 907.167,385.5 886.5,385.5C 886.169,359.328 886.502,333.328 887.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd680f",
    d: "M 161.5,410.5 C 149.5,410.5 137.5,410.5 125.5,410.5C 125.5,415.833 125.5,421.167 125.5,426.5C 136.833,426.5 148.167,426.5 159.5,426.5C 160.833,434.5 160.833,442.5 159.5,450.5C 148.167,450.5 136.833,450.5 125.5,450.5C 125.5,456.167 125.5,461.833 125.5,467.5C 137.5,467.5 149.5,467.5 161.5,467.5C 161.5,476.5 161.5,485.5 161.5,494.5C 139.167,494.5 116.833,494.5 94.5,494.5C 94.5,458.167 94.5,421.833 94.5,385.5C 116.833,385.5 139.167,385.5 161.5,385.5C 161.5,393.833 161.5,402.167 161.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd6815",
    d: "M 205.5,386.5 C 220.422,400.424 234.755,415.09 248.5,430.5C 248.56,431.043 248.893,431.376 249.5,431.5C 250.499,416.181 250.833,400.848 250.5,385.5C 260.5,385.5 270.5,385.5 280.5,385.5C 280.5,404.5 280.5,423.5 280.5,442.5C 280.56,460.334 280.56,478.334 280.5,496.5C 277.432,496.453 274.432,495.953 271.5,495C 269.167,493.333 266.833,491.667 264.5,490C 248.785,475.606 232.785,461.772 216.5,448.5C 216.44,447.957 216.107,447.624 215.5,447.5C 214.501,461.818 214.167,476.151 214.5,490.5C 214.5,492.167 214.5,493.833 214.5,495.5C 204.652,495.827 194.986,495.494 185.5,494.5C 185.5,458.167 185.5,421.833 185.5,385.5C 192.255,385.207 198.922,385.54 205.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6917",
    d: "M 350.5,385.5 C 352.74,386.264 355.073,387.098 357.5,388C 358.126,388.75 358.626,389.584 359,390.5C 360.049,388.893 361.549,388.227 363.5,388.5C 379.51,394.351 389.343,405.684 393,422.5C 400.458,474.713 377.791,499.046 325,495.5C 318.325,495.5 311.825,495.166 305.5,494.5C 305.5,458.167 305.5,421.833 305.5,385.5C 320.5,385.5 335.5,385.5 350.5,385.5 Z M 348.5,413.5 C 350.456,414.492 352.456,415.492 354.5,416.5C 356.091,419.352 357.424,422.352 358.5,425.5C 358.932,426.71 359.599,427.71 360.5,428.5C 362.214,439.433 360.381,449.766 355,459.5C 349.672,463.878 343.505,465.878 336.5,465.5C 336.5,447.833 336.5,430.167 336.5,412.5C 340.519,412.646 344.519,412.979 348.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb691",
    d: "M 584.5,385.5 C 583.22,386.931 581.553,387.598 579.5,387.5C 580.78,386.069 582.447,385.402 584.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff8c50",
    d: "M 363.5,388.5 C 361.549,388.227 360.049,388.893 359,390.5C 358.626,389.584 358.126,388.75 357.5,388C 355.073,387.098 352.74,386.264 350.5,385.5C 351.15,385.196 351.817,384.863 352.5,384.5C 356.332,385.696 359.999,387.03 363.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcac7f",
    d: "M 739.5,337.5 C 739.5,354.5 739.5,371.5 739.5,388.5C 728.833,388.5 718.167,388.5 707.5,388.5C 707.5,372.5 707.5,356.5 707.5,340.5C 708.496,355.991 708.83,371.658 708.5,387.5C 718.5,387.5 728.5,387.5 738.5,387.5C 738.17,370.658 738.503,353.992 739.5,337.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd965f",
    d: "M 539.5,394.5 C 538.763,391.275 538.097,387.941 537.5,384.5C 537.81,383.262 538.31,383.262 539,384.5C 539.498,387.817 539.665,391.15 539.5,394.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffac7e",
    d: "M 627.5,387.5 C 629.403,387.796 631.07,388.463 632.5,389.5C 630.302,389.88 628.635,389.213 627.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dbdc",
    d: "M 681.5,405.5 C 681.783,404.711 682.283,404.044 683,403.5C 684.365,404.593 684.699,405.926 684,407.5C 683.583,406.244 682.75,405.577 681.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbdcdd",
    d: "M 674.5,404.5 C 675.649,404.791 676.316,405.624 676.5,407C 676.333,407.833 676.167,408.667 676,409.5C 675.392,407.846 674.892,406.179 674.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbb48b",
    d: "M 472.5,384.5 C 470.506,420.818 469.84,457.485 470.5,494.5C 469.502,457.67 469.168,420.67 469.5,383.5C 470.791,383.263 471.791,383.596 472.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dada",
    d: "M 681.5,405.5 C 681.737,406.791 681.404,407.791 680.5,408.5C 680.263,407.209 680.596,406.209 681.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdbdbd",
    d: "M 933.5,405.5 C 961.488,405.17 989.488,405.503 1017.5,406.5C 1017.5,432.167 1017.5,457.833 1017.5,483.5C 948.833,483.667 880.166,483.5 811.5,483C 810.999,457.713 810.666,432.213 810.5,406.5C 851.67,406.832 892.67,406.499 933.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadddc",
    d: "M 662.5,407.5 C 663.833,408.167 663.833,408.167 662.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcdbdc",
    d: "M 680.5,408.5 C 680.649,409.552 680.483,410.552 680,411.5C 679.26,410.251 679.427,409.251 680.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8dbda",
    d: "M 662.5,408.5 C 662.649,409.552 662.483,410.552 662,411.5C 661.26,410.251 661.427,409.251 662.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadedc",
    d: "M 691.5,409.5 C 692.833,410.167 692.833,410.167 691.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9cbb1",
    d: "M 539.5,410.5 C 527.678,411.495 515.678,411.828 503.5,411.5C 503.5,416.167 503.5,420.833 503.5,425.5C 503.167,425.5 502.833,425.5 502.5,425.5C 502.5,420.5 502.5,415.5 502.5,410.5C 514.833,410.5 527.167,410.5 539.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcdcdd",
    d: "M 675.5,410.5 C 676.525,410.897 676.692,411.563 676,412.5C 675.536,411.906 675.369,411.239 675.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcc2a2",
    d: "M 280.5,442.5 C 280.5,423.5 280.5,404.5 280.5,385.5C 270.5,385.5 260.5,385.5 250.5,385.5C 250.833,400.848 250.499,416.181 249.5,431.5C 248.893,431.376 248.56,431.043 248.5,430.5C 249.496,415.342 249.83,400.009 249.5,384.5C 260.167,384.5 270.833,384.5 281.5,384.5C 281.83,404.007 281.497,423.341 280.5,442.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcdeda",
    d: "M 666.5,413.5 C 667.833,414.167 667.833,414.167 666.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadbdc",
    d: "M 679.5,413.5 C 680.598,414.601 680.765,415.934 680,417.5C 679.51,416.207 679.343,414.873 679.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe9a62",
    d: "M 348.5,413.5 C 351.313,413.025 353.313,414.025 354.5,416.5C 352.456,415.492 350.456,414.492 348.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea270",
    d: "M 561.5,409.5 C 561.677,413.234 561.344,416.901 560.5,420.5C 560.087,418.605 559.753,416.605 559.5,414.5C 560.028,412.664 560.694,410.997 561.5,409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb58b",
    d: "M 161.5,410.5 C 161.833,410.5 162.167,410.5 162.5,410.5C 150.678,411.495 138.678,411.828 126.5,411.5C 126.5,416.167 126.5,420.833 126.5,425.5C 137.679,425.172 148.679,425.505 159.5,426.5C 148.167,426.5 136.833,426.5 125.5,426.5C 125.5,421.167 125.5,415.833 125.5,410.5C 137.5,410.5 149.5,410.5 161.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadbda",
    d: "M 663.5,417.5 C 662.833,416.167 662.833,416.167 663.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbdbda",
    d: "M 663.5,417.5 C 664.239,417.369 664.906,417.536 665.5,418C 664.563,418.692 663.897,418.525 663.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979796",
    d: "M 10.5,418.5 C 16.8376,418.767 23.171,419.1 29.5,419.5C 23.1269,420.564 16.7935,420.231 10.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea776",
    d: "M 445.5,384.5 C 434.833,384.5 424.167,384.5 413.5,384.5C 413.5,421.167 413.5,457.833 413.5,494.5C 424.167,494.5 434.833,494.5 445.5,494.5C 434.679,495.495 423.679,495.828 412.5,495.5C 412.5,458.167 412.5,420.833 412.5,383.5C 423.679,383.172 434.679,383.505 445.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb489",
    d: "M 358.5,425.5 C 360.048,425.821 360.715,426.821 360.5,428.5C 359.599,427.71 358.932,426.71 358.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 760.5,429.5 C 768.833,429.5 777.167,429.5 785.5,429.5C 785.5,453.167 785.5,476.833 785.5,500.5C 776.167,500.5 766.833,500.5 757.5,500.5C 757.829,487.323 757.495,474.323 756.5,461.5C 756.5,460.167 756.5,458.833 756.5,457.5C 750.5,457.5 744.5,457.5 738.5,457.5C 738.5,471.833 738.5,486.167 738.5,500.5C 728.833,500.5 719.167,500.5 709.5,500.5C 709.5,486.167 709.5,471.833 709.5,457.5C 702.833,457.5 696.167,457.5 689.5,457.5C 689.5,471.833 689.5,486.167 689.5,500.5C 680.167,500.5 670.833,500.5 661.5,500.5C 661.5,476.833 661.5,453.167 661.5,429.5C 694.5,429.5 727.5,429.5 760.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#060707",
    d: "M -0.5,429.5 C 4.84372,429.334 10.1771,429.501 15.5,430C 16.056,430.383 16.3893,430.883 16.5,431.5C 16.1201,433.698 16.7868,435.365 18.5,436.5C 20.9308,440.111 22.5975,444.111 23.5,448.5C 23.281,449.675 23.6143,450.675 24.5,451.5C 25.1067,451.376 25.44,451.043 25.5,450.5C 25.2627,449.209 25.596,448.209 26.5,447.5C 27.6737,446.486 28.3404,445.153 28.5,443.5C 28.9925,441.181 29.9925,439.181 31.5,437.5C 32.9063,437.027 33.573,436.027 33.5,434.5C 34.2674,433.828 34.9341,432.995 35.5,432C 47.1619,431.5 58.8286,431.333 70.5,431.5C 70.5,452.833 70.5,474.167 70.5,495.5C 60.5,495.5 50.5,495.5 40.5,495.5C 40.5,489.833 40.5,484.167 40.5,478.5C 41.6341,476.034 41.8007,473.367 41,470.5C 39.0972,472.441 38.2639,474.774 38.5,477.5C 38.6716,478.492 38.3382,479.158 37.5,479.5C 36.0687,480.78 35.4021,482.447 35.5,484.5C 34.1655,488.669 32.1655,492.502 29.5,496C 23.1667,496.667 16.8333,496.667 10.5,496C 8.17072,493.174 6.50405,490.008 5.5,486.5C 5.87988,484.302 5.21321,482.635 3.5,481.5C 1.9679,478.235 0.634569,474.902 -0.5,471.5C -0.5,457.5 -0.5,443.5 -0.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4f50",
    d: "M 70.5,430.5 C 70.5,430.833 70.5,431.167 70.5,431.5C 58.8286,431.333 47.1619,431.5 35.5,432C 34.9341,432.995 34.2674,433.828 33.5,434.5C 33.33,433.178 33.6634,432.011 34.5,431C 46.4954,430.5 58.4954,430.333 70.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6c6c",
    d: "M 16.5,431.5 C 17.5375,432.93 18.2041,434.597 18.5,436.5C 16.7868,435.365 16.1201,433.698 16.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb88e",
    d: "M 502.5,425.5 C 502.833,425.5 503.167,425.5 503.5,425.5C 514.833,425.5 526.167,425.5 537.5,425.5C 537.826,434.017 537.493,442.35 536.5,450.5C 536.5,442.5 536.5,434.5 536.5,426.5C 524.988,426.828 513.654,426.495 502.5,425.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd975e",
    d: "M 350.5,385.5 C 335.5,385.5 320.5,385.5 305.5,385.5C 305.5,421.833 305.5,458.167 305.5,494.5C 304.502,458.004 304.168,421.337 304.5,384.5C 320.009,384.17 335.342,384.504 350.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747675",
    d: "M 33.5,434.5 C 33.573,436.027 32.9063,437.027 31.5,437.5C 31.427,435.973 32.0937,434.973 33.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 28.5,443.5 C 28.3404,445.153 27.6737,446.486 26.5,447.5C 26.2291,445.62 26.8958,444.287 28.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6a16",
    d: "M 472.5,384.5 C 493.402,385.826 514.402,385.826 535.5,384.5C 536.167,384.5 536.833,384.5 537.5,384.5C 538.097,387.941 538.763,391.275 539.5,394.5C 540.833,399.833 540.833,405.167 539.5,410.5C 527.167,410.5 514.833,410.5 502.5,410.5C 502.5,415.5 502.5,420.5 502.5,425.5C 513.654,426.495 524.988,426.828 536.5,426.5C 536.5,434.5 536.5,442.5 536.5,450.5C 525.167,450.5 513.833,450.5 502.5,450.5C 502.5,456.167 502.5,461.833 502.5,467.5C 514.5,467.5 526.5,467.5 538.5,467.5C 539.828,476.568 539.828,485.735 538.5,495C 515.663,495.83 492.996,495.663 470.5,494.5C 469.84,457.485 470.506,420.818 472.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787879",
    d: "M 23.5,448.5 C 24.1667,449.167 24.8333,449.833 25.5,450.5C 25.44,451.043 25.1067,451.376 24.5,451.5C 23.6143,450.675 23.281,449.675 23.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb78f",
    d: "M 159.5,450.5 C 148.679,451.495 137.679,451.828 126.5,451.5C 126.5,456.5 126.5,461.5 126.5,466.5C 138.5,466.5 150.5,466.5 162.5,466.5C 162.5,476.167 162.5,485.833 162.5,495.5C 139.661,495.831 116.994,495.497 94.5,494.5C 116.833,494.5 139.167,494.5 161.5,494.5C 161.5,485.5 161.5,476.5 161.5,467.5C 149.5,467.5 137.5,467.5 125.5,467.5C 125.5,461.833 125.5,456.167 125.5,450.5C 136.833,450.5 148.167,450.5 159.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faceb3",
    d: "M 216.5,448.5 C 215.833,462.5 215.167,476.5 214.5,490.5C 214.167,476.151 214.501,461.818 215.5,447.5C 216.107,447.624 216.44,447.957 216.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feab7c",
    d: "M 577.5,458.5 C 578.906,458.973 579.573,459.973 579.5,461.5C 578.094,461.027 577.427,460.027 577.5,458.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab892",
    d: "M 536.5,450.5 C 525.679,451.495 514.679,451.828 503.5,451.5C 503.5,456.5 503.5,461.5 503.5,466.5C 515.345,466.172 527.012,466.505 538.5,467.5C 526.5,467.5 514.5,467.5 502.5,467.5C 502.5,461.833 502.5,456.167 502.5,450.5C 513.833,450.5 525.167,450.5 536.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#737374",
    d: "M 40.5,478.5 C 40.6567,477.127 40.49,475.793 40,474.5C 39.7679,475.737 39.2679,476.737 38.5,477.5C 38.2639,474.774 39.0972,472.441 41,470.5C 41.8007,473.367 41.6341,476.034 40.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a9",
    d: "M 756.5,461.5 C 755.596,460.791 755.263,459.791 755.5,458.5C 750.167,458.5 744.833,458.5 739.5,458.5C 739.829,473.01 739.496,487.343 738.5,501.5C 738.5,501.167 738.5,500.833 738.5,500.5C 738.5,486.167 738.5,471.833 738.5,457.5C 744.5,457.5 750.5,457.5 756.5,457.5C 756.5,458.833 756.5,460.167 756.5,461.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7d7f",
    d: "M 37.5,479.5 C 37.5979,481.553 36.9313,483.22 35.5,484.5C 35.4021,482.447 36.0687,480.78 37.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838485",
    d: "M 3.5,481.5 C 5.21321,482.635 5.87988,484.302 5.5,486.5C 4.46253,485.07 3.79586,483.403 3.5,481.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 760.5,428.5 C 760.5,428.833 760.5,429.167 760.5,429.5C 727.5,429.5 694.5,429.5 661.5,429.5C 661.5,453.167 661.5,476.833 661.5,500.5C 670.833,500.5 680.167,500.5 689.5,500.5C 689.833,500.5 690.167,500.5 690.5,500.5C 680.681,501.494 670.681,501.827 660.5,501.5C 660.5,477.167 660.5,452.833 660.5,428.5C 693.833,428.5 727.167,428.5 760.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606060",
    d: "M 738.5,500.5 C 738.5,500.833 738.5,501.167 738.5,501.5C 728.5,501.5 718.5,501.5 708.5,501.5C 708.5,487.167 708.5,472.833 708.5,458.5C 702.5,458.5 696.5,458.5 690.5,458.5C 690.5,472.5 690.5,486.5 690.5,500.5C 690.167,500.5 689.833,500.5 689.5,500.5C 689.5,486.167 689.5,471.833 689.5,457.5C 696.167,457.5 702.833,457.5 709.5,457.5C 709.5,471.833 709.5,486.167 709.5,500.5C 719.167,500.5 728.833,500.5 738.5,500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6e6e",
    d: "M 70.5,430.5 C 71.4974,452.327 71.8307,474.327 71.5,496.5C 60.8333,496.5 50.1667,496.5 39.5,496.5C 39.1771,490.31 39.5104,484.31 40.5,478.5C 40.5,484.167 40.5,489.833 40.5,495.5C 50.5,495.5 60.5,495.5 70.5,495.5C 70.5,474.167 70.5,452.833 70.5,431.5C 70.5,431.167 70.5,430.833 70.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#525252",
    d: "M 760.5,429.5 C 760.5,429.167 760.5,428.833 760.5,428.5C 769.167,428.5 777.833,428.5 786.5,428.5C 786.5,452.833 786.5,477.167 786.5,501.5C 776.5,501.5 766.5,501.5 756.5,501.5C 756.5,488.167 756.5,474.833 756.5,461.5C 757.495,474.323 757.829,487.323 757.5,500.5C 766.833,500.5 776.167,500.5 785.5,500.5C 785.5,476.833 785.5,453.167 785.5,429.5C 777.167,429.5 768.833,429.5 760.5,429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adadad",
    d: "M 577.5,504.5 C 589.139,505.757 593.306,512.091 590,523.5C 587.448,531.719 582.115,536.719 574,538.5C 570.314,538.377 567.647,536.71 566,533.5C 562.327,526.428 561.66,519.095 564,511.5C 566.124,510.378 567.957,508.878 569.5,507C 572.31,506.218 574.977,505.384 577.5,504.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 786.5,508.5 C 787.745,526.663 787.745,544.996 786.5,563.5C 785.167,572.833 785.167,582.167 786.5,591.5C 786.5,594.5 786.5,597.5 786.5,600.5C 744.833,600.5 703.167,600.5 661.5,600.5C 661.5,569.833 661.5,539.167 661.5,508.5C 703.167,508.5 744.833,508.5 786.5,508.5 Z M 756.5,535.5 C 756.5,547.5 756.5,559.5 756.5,571.5C 750.833,571.5 745.167,571.5 739.5,571.5C 739.5,559.5 739.5,547.5 739.5,535.5C 745.167,535.5 750.833,535.5 756.5,535.5 Z M 690.5,535.5 C 696.5,535.5 702.5,535.5 708.5,535.5C 708.5,547.5 708.5,559.5 708.5,571.5C 702.5,571.5 696.5,571.5 690.5,571.5C 690.5,559.5 690.5,547.5 690.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8d8e",
    d: "M 958.5,531.5 C 958.167,531.5 957.833,531.5 957.5,531.5C 967.653,530.506 977.986,530.172 988.5,530.5C 988.5,523.5 988.5,516.5 988.5,509.5C 967.5,509.5 946.5,509.5 925.5,509.5C 925.5,532.167 925.5,554.833 925.5,577.5C 924.502,554.673 924.169,531.673 924.5,508.5C 946.167,508.5 967.833,508.5 989.5,508.5C 989.5,516.167 989.5,523.833 989.5,531.5C 979.167,531.5 968.833,531.5 958.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 839.5,512.5 C 841.452,513.785 843.118,515.451 844.5,517.5C 844.833,518.5 845.5,519.167 846.5,519.5C 846.5,521.5 847.5,522.5 849.5,522.5C 849.427,524.027 850.094,525.027 851.5,525.5C 851.5,527.5 852.5,528.5 854.5,528.5C 855.5,528.833 856.167,529.5 856.5,530.5C 856.821,532.048 857.821,532.715 859.5,532.5C 860.5,532.833 861.167,533.5 861.5,534.5C 861.5,536.5 862.5,537.5 864.5,537.5C 865.338,537.842 865.672,538.508 865.5,539.5C 865.833,540.5 866.5,541.167 867.5,541.5C 869.167,542.5 870.5,543.833 871.5,545.5C 871.56,546.043 871.893,546.376 872.5,546.5C 873.429,545.311 873.762,543.978 873.5,542.5C 874.495,531.679 874.828,520.679 874.5,509.5C 884.5,509.5 894.5,509.5 904.5,509.5C 904.5,539.5 904.5,569.5 904.5,599.5C 896.445,599.77 888.445,599.437 880.5,598.5C 879.5,598.167 878.833,597.5 878.5,596.5C 878.027,595.094 877.027,594.427 875.5,594.5C 873.833,592.167 871.833,590.167 869.5,588.5C 869.027,587.094 868.027,586.427 866.5,586.5C 865.738,584.738 864.404,583.738 862.5,583.5C 860.863,581.525 859.196,579.525 857.5,577.5C 857.027,576.094 856.027,575.427 854.5,575.5C 851.427,573.431 849.094,570.764 847.5,567.5C 846.738,565.738 845.404,564.738 843.5,564.5C 843.44,563.957 843.107,563.624 842.5,563.5C 841.501,575.482 841.168,587.482 841.5,599.5C 831.5,599.5 821.5,599.5 811.5,599.5C 811.5,569.5 811.5,539.5 811.5,509.5C 820.192,509.169 828.859,509.502 837.5,510.5C 837.855,511.522 838.522,512.189 839.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 957.5,531.5 C 957.5,535.833 957.5,540.167 957.5,544.5C 967.833,544.5 978.167,544.5 988.5,544.5C 988.5,551.167 988.5,557.833 988.5,564.5C 978.319,564.173 968.319,564.506 958.5,565.5C 957.517,569.298 957.183,573.298 957.5,577.5C 968.167,577.5 978.833,577.5 989.5,577.5C 989.849,581.31 989.849,584.977 989.5,588.5C 988.518,591.962 988.185,595.629 988.5,599.5C 967.833,599.5 947.167,599.5 926.5,599.5C 926.825,591.981 926.492,584.648 925.5,577.5C 925.5,554.833 925.5,532.167 925.5,509.5C 946.5,509.5 967.5,509.5 988.5,509.5C 988.5,516.5 988.5,523.5 988.5,530.5C 977.986,530.172 967.653,530.506 957.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 1023.5,509.5 C 1023.5,539.5 1023.5,569.5 1023.5,599.5C 1018.83,599.5 1014.17,599.5 1009.5,599.5C 1009.5,569.5 1009.5,539.5 1009.5,509.5C 1014.17,509.5 1018.83,509.5 1023.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6a17",
    d: "M 462.5,560.5 C 463.906,560.027 464.573,559.027 464.5,557.5C 465.38,554.738 466.546,552.071 468,549.5C 473.653,541.998 480.82,536.664 489.5,533.5C 490.833,533.5 492.167,533.5 493.5,533.5C 493.693,537.449 494.193,537.449 495,533.5C 495.249,534.624 495.749,535.624 496.5,536.5C 496.313,535.183 496.98,533.85 498.5,532.5C 501.977,531.833 505.311,531.166 508.5,530.5C 518.167,530.5 527.833,530.5 537.5,530.5C 537.5,541.833 537.5,553.167 537.5,564.5C 523.656,564.171 509.99,564.504 496.5,565.5C 494.444,566.216 492.277,566.883 490,567.5C 485.41,578.001 481.41,588.668 478,599.5C 472.954,605.522 466.454,608.689 458.5,609C 452.651,609.818 446.985,609.652 441.5,608.5C 439.485,607.076 437.152,606.41 434.5,606.5C 423.306,599.958 416.306,590.291 413.5,577.5C 413.451,573.922 412.785,570.589 411.5,567.5C 410.835,564.518 410.502,561.352 410.5,558C 410.344,552.91 411.01,548.077 412.5,543.5C 413.924,541.485 414.59,539.152 414.5,536.5C 416.301,530.946 419.134,525.946 423,521.5C 427.451,518.717 431.617,515.55 435.5,512C 443.408,509.229 451.408,508.896 459.5,511C 461.513,511.68 462.846,513.013 463.5,515C 458.655,525.189 453.155,535.023 447,544.5C 445.187,550.42 443.687,556.42 442.5,562.5C 442.818,568.637 445.151,573.803 449.5,578C 451.441,578.743 453.274,578.576 455,577.5C 456.456,571.287 458.956,565.62 462.5,560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cacaca",
    d: "M 80.5,514.5 C 97.8365,514.333 115.17,514.5 132.5,515C 131.525,520.741 131.192,526.575 131.5,532.5C 121.5,532.5 111.5,532.5 101.5,532.5C 101.223,535.448 101.556,538.281 102.5,541C 112.161,541.5 121.828,541.666 131.5,541.5C 131.5,549.167 131.5,556.833 131.5,564.5C 121.5,564.5 111.5,564.5 101.5,564.5C 101.223,567.448 101.556,570.281 102.5,573C 112.494,573.5 122.494,573.666 132.5,573.5C 132.807,579.093 132.473,584.593 131.5,590C 114.593,590.825 97.7594,590.658 81,589.5C 80.5,564.502 80.3334,539.502 80.5,514.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cacaca",
    d: "M 145.5,514.5 C 157.15,514.561 168.65,514.561 180,514.5C 200.699,518.701 211.533,531.368 212.5,552.5C 212.673,574.351 202.006,586.851 180.5,590C 168.838,590.5 157.171,590.667 145.5,590.5C 145.5,565.167 145.5,539.833 145.5,514.5 Z M 170.5,532.5 C 187.868,535.741 193.868,545.908 188.5,563C 183.715,569.884 177.049,573.051 168.5,572.5C 167.88,558.92 168.547,545.587 170.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c9c9",
    d: "M 227.5,514.5 C 242.17,514.333 256.837,514.5 271.5,515C 272.478,521.41 272.811,527.91 272.5,534.5C 263.167,534.5 253.833,534.5 244.5,534.5C 244.5,538.167 244.5,541.833 244.5,545.5C 253.167,545.5 261.833,545.5 270.5,545.5C 270.5,550.833 270.5,556.167 270.5,561.5C 261.833,561.5 253.167,561.5 244.5,561.5C 244.5,564.833 244.5,568.167 244.5,571.5C 253.185,571.312 261.851,571.145 270.5,571C 272.723,571.652 273.89,573.152 274,575.5C 274.799,580.087 274.632,584.587 273.5,589C 256.926,589.824 240.426,589.658 224,588.5C 222.365,565.897 222.032,543.23 223,520.5C 223.884,517.942 225.384,515.942 227.5,514.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcbebc",
    d: "M 392.5,500.5 C 394.09,500.628 395.423,501.295 396.5,502.5C 399.5,506.5 402.5,510.5 405.5,514.5C 402.029,519.632 397.362,523.299 391.5,525.5C 384.236,523.289 381.236,518.622 382.5,511.5C 386.588,508.417 389.921,504.75 392.5,500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9a9a8",
    d: "M 844.5,517.5 C 845.833,517.5 846.5,518.167 846.5,519.5C 845.5,519.167 844.833,518.5 844.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717171",
    d: "M 846.5,519.5 C 847.833,520.167 848.833,521.167 849.5,522.5C 847.5,522.5 846.5,521.5 846.5,519.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3a3a3",
    d: "M 904.5,509.5 C 894.5,509.5 884.5,509.5 874.5,509.5C 874.828,520.679 874.495,531.679 873.5,542.5C 873.5,531.167 873.5,519.833 873.5,508.5C 884.014,508.172 894.347,508.506 904.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949796",
    d: "M 849.5,522.5 C 850.906,522.973 851.573,523.973 851.5,525.5C 850.094,525.027 849.427,524.027 849.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757676",
    d: "M 851.5,525.5 C 852.833,526.167 853.833,527.167 854.5,528.5C 852.5,528.5 851.5,527.5 851.5,525.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6d6d",
    d: "M 856.5,530.5 C 857.71,530.932 858.71,531.599 859.5,532.5C 857.821,532.715 856.821,532.048 856.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe8443",
    d: "M 508.5,530.5 C 505.311,531.166 501.977,531.833 498.5,532.5C 496.98,533.85 496.313,535.183 496.5,536.5C 495.749,535.624 495.249,534.624 495,533.5C 494.193,537.449 493.693,537.449 493.5,533.5C 492.167,533.5 490.833,533.5 489.5,533.5C 495.463,531.01 501.796,530.01 508.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b8b8c",
    d: "M 839.5,512.5 C 838.522,512.189 837.855,511.522 837.5,510.5C 828.859,509.502 820.192,509.169 811.5,509.5C 811.5,539.5 811.5,569.5 811.5,599.5C 821.5,599.5 831.5,599.5 841.5,599.5C 841.5,599.833 841.5,600.167 841.5,600.5C 831.167,600.5 820.833,600.5 810.5,600.5C 810.5,569.833 810.5,539.167 810.5,508.5C 822.553,508.109 834.553,508.609 846.5,510C 843.639,509.97 841.305,510.803 839.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f908f",
    d: "M 861.5,534.5 C 862.833,535.167 863.833,536.167 864.5,537.5C 862.5,537.5 861.5,536.5 861.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acaeae",
    d: "M 865.5,539.5 C 866.833,539.5 867.5,540.167 867.5,541.5C 866.5,541.167 865.833,540.5 865.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545554",
    d: "M 1023.5,508.5 C 1023.5,508.833 1023.5,509.167 1023.5,509.5C 1018.83,509.5 1014.17,509.5 1009.5,509.5C 1009.5,539.5 1009.5,569.5 1009.5,599.5C 1014.17,599.5 1018.83,599.5 1023.5,599.5C 1023.5,599.833 1023.5,600.167 1023.5,600.5C 1018.5,600.5 1013.5,600.5 1008.5,600.5C 1008.55,570.481 1008.22,540.981 1007.5,512C 1007.74,511.127 1008.07,510.293 1008.5,509.5C 1013.46,508.506 1018.46,508.173 1023.5,508.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6c6c6",
    d: "M 300.5,515.5 C 310.404,514.817 320.071,515.984 329.5,519C 330,519.5 330.5,520 331,520.5C 331.499,525.489 331.666,530.489 331.5,535.5C 329.192,535.914 326.858,536.247 324.5,536.5C 317.566,535.112 310.566,534.445 303.5,534.5C 303.736,537.785 304.736,540.785 306.5,543.5C 315.445,544.891 323.279,548.557 330,554.5C 335.847,565.912 334.347,576.079 325.5,585C 313.31,590.657 300.977,590.99 288.5,586C 287.12,584.075 285.62,582.241 284,580.5C 283.501,574.509 283.334,568.509 283.5,562.5C 289.613,564.723 295.613,567.223 301.5,570C 305.572,570.956 309.405,570.456 313,568.5C 313.755,565.503 312.922,563.003 310.5,561C 302.586,558.25 294.919,554.917 287.5,551C 285.996,549.509 285.163,547.676 285,545.5C 283.499,538.002 283.332,530.502 284.5,523C 285.858,521.311 287.525,519.978 289.5,519C 293.161,517.407 296.828,516.241 300.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb9d64",
    d: "M 414.5,536.5 C 414.59,539.152 413.924,541.485 412.5,543.5C 412.41,540.848 413.076,538.515 414.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcab7e",
    d: "M 508.5,530.5 C 518.319,529.506 528.319,529.173 538.5,529.5C 538.5,541.5 538.5,553.5 538.5,565.5C 524.5,565.5 510.5,565.5 496.5,565.5C 509.99,564.504 523.656,564.171 537.5,564.5C 537.5,553.167 537.5,541.833 537.5,530.5C 527.833,530.5 518.167,530.5 508.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4a4a3",
    d: "M 957.5,531.5 C 957.833,531.5 958.167,531.5 958.5,531.5C 958.5,535.5 958.5,539.5 958.5,543.5C 968.681,543.173 978.681,543.506 988.5,544.5C 978.167,544.5 967.833,544.5 957.5,544.5C 957.5,540.167 957.5,535.833 957.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeb0af",
    d: "M 873.5,542.5 C 873.762,543.978 873.429,545.311 872.5,546.5C 871.893,546.376 871.56,546.043 871.5,545.5C 872.167,544.5 872.833,543.5 873.5,542.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 34.5,513.5 C 44.2884,512.896 53.6217,515.063 62.5,520C 66.5245,524.834 68.8578,530.334 69.5,536.5C 62.9605,538.678 56.2939,540.678 49.5,542.5C 47.8786,540.847 46.7119,538.847 46,536.5C 34.1068,529.476 26.4401,532.809 23,546.5C 20.9467,557.211 24.4467,565.378 33.5,571C 41.661,574.576 47.661,572.409 51.5,564.5C 40.2226,565.235 35.8893,560.235 38.5,549.5C 48.8119,548.501 59.1452,548.168 69.5,548.5C 69.8215,560.414 69.4882,572.247 68.5,584C 54.7469,590.479 40.4136,592.146 25.5,589C 13.6667,585.167 5.83333,577.333 2,565.5C -3.46012,546.721 1.37321,531.388 16.5,519.5C 22.5663,516.366 28.5663,514.366 34.5,513.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaaaab",
    d: "M 605.5,506.5 C 610.511,506.334 615.511,506.501 620.5,507C 627.562,507.274 632.062,510.774 634,517.5C 641.424,545.377 631.257,562.877 603.5,570C 587.454,572.776 571.454,572.776 555.5,570C 554.167,560 554.167,550 555.5,540C 571.006,540.417 587.006,540.417 603.5,540C 606.978,538.058 608.978,535.058 609.5,531C 608.776,523.108 607.11,515.441 604.5,508C 605.056,507.617 605.389,507.117 605.5,506.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888889",
    d: "M 756.5,535.5 C 757.495,547.655 757.829,559.989 757.5,572.5C 751.167,572.5 744.833,572.5 738.5,572.5C 738.5,559.833 738.5,547.167 738.5,534.5C 744.69,534.177 750.69,534.51 756.5,535.5 Z M 756.5,535.5 C 750.833,535.5 745.167,535.5 739.5,535.5C 739.5,547.5 739.5,559.5 739.5,571.5C 745.167,571.5 750.833,571.5 756.5,571.5C 756.5,559.5 756.5,547.5 756.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555555",
    d: "M 348.5,554.5 C 347.957,554.44 347.624,554.107 347.5,553.5C 361.818,552.501 376.151,552.167 390.5,552.5C 390.18,621.189 390.513,689.856 391.5,758.5C 377.167,758.5 362.833,758.5 348.5,758.5C 348.5,690.5 348.5,622.5 348.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010202",
    d: "M 348.5,554.5 C 361.99,553.504 375.656,553.171 389.5,553.5C 389.17,621.208 389.504,688.875 390.5,756.5C 376.85,757.499 363.183,757.833 349.5,757.5C 349.833,689.665 349.499,621.998 348.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb189",
    d: "M 464.5,557.5 C 464.573,559.027 463.906,560.027 462.5,560.5C 462.427,558.973 463.094,557.973 464.5,557.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727372",
    d: "M 786.5,508.5 C 744.833,508.5 703.167,508.5 661.5,508.5C 661.5,539.167 661.5,569.833 661.5,600.5C 661.167,600.5 660.833,600.5 660.5,600.5C 660.5,569.5 660.5,538.5 660.5,507.5C 702.67,507.168 744.67,507.501 786.5,508.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747676",
    d: "M 843.5,564.5 C 845.404,564.738 846.738,565.738 847.5,567.5C 845.596,567.262 844.262,566.262 843.5,564.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6c",
    d: "M 988.5,544.5 C 989.491,551.313 989.825,558.313 989.5,565.5C 979.167,565.5 968.833,565.5 958.5,565.5C 968.319,564.506 978.319,564.173 988.5,564.5C 988.5,557.833 988.5,551.167 988.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcb287",
    d: "M 411.5,567.5 C 412.785,570.589 413.451,573.922 413.5,577.5C 411.989,574.456 411.322,571.122 411.5,567.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#717171",
    d: "M 690.5,535.5 C 690.5,547.5 690.5,559.5 690.5,571.5C 696.5,571.5 702.5,571.5 708.5,571.5C 708.5,559.5 708.5,547.5 708.5,535.5C 709.495,547.655 709.829,559.989 709.5,572.5C 702.833,572.5 696.167,572.5 689.5,572.5C 689.171,559.989 689.505,547.655 690.5,535.5 Z M 690.5,535.5 C 696.5,535.5 702.5,535.5 708.5,535.5C 708.5,547.5 708.5,559.5 708.5,571.5C 702.5,571.5 696.5,571.5 690.5,571.5C 690.5,559.5 690.5,547.5 690.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a8",
    d: "M 843.5,564.5 C 842.833,576.5 842.167,588.5 841.5,600.5C 841.5,600.167 841.5,599.833 841.5,599.5C 841.168,587.482 841.501,575.482 842.5,563.5C 843.107,563.624 843.44,563.957 843.5,564.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9b8b9",
    d: "M 566.5,574.5 C 571.032,574.069 575.365,574.569 579.5,576C 578.833,577.333 577.833,578.333 576.5,579C 573.5,579.667 570.5,579.667 567.5,579C 566.62,577.644 566.286,576.144 566.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8c91",
    d: "M 854.5,575.5 C 856.027,575.427 857.027,576.094 857.5,577.5C 855.973,577.573 854.973,576.906 854.5,575.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a6a5",
    d: "M 958.5,565.5 C 958.5,569.167 958.5,572.833 958.5,576.5C 969.014,576.172 979.347,576.506 989.5,577.5C 978.833,577.5 968.167,577.5 957.5,577.5C 957.183,573.298 957.517,569.298 958.5,565.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535150",
    d: "M 786.5,563.5 C 787.037,572.49 787.037,581.49 786.5,590.5C 786.5,590.833 786.5,591.167 786.5,591.5C 785.167,582.167 785.167,572.833 786.5,563.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 862.5,583.5 C 864.404,583.738 865.738,584.738 866.5,586.5C 864.596,586.262 863.262,585.262 862.5,583.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d6d6",
    d: "M -0.5,584.5 C 2.16667,585.167 2.16667,585.833 -0.5,586.5C -0.5,585.833 -0.5,585.167 -0.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa674",
    d: "M 518.5,587.5 C 514.833,587.5 511.167,587.5 507.5,587.5C 509.684,586.734 512.018,586.067 514.5,585.5C 516.026,585.994 517.359,586.661 518.5,587.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6a18",
    d: "M 507.5,587.5 C 511.167,587.5 514.833,587.5 518.5,587.5C 520.786,587.595 522.786,588.262 524.5,589.5C 524.821,591.048 525.821,591.715 527.5,591.5C 535.062,597.62 539.229,605.62 540,615.5C 542.877,654.118 525.043,674.451 486.5,676.5C 480.997,675.672 475.663,674.672 470.5,673.5C 468.485,672.076 466.152,671.41 463.5,671.5C 450.388,667.298 437.055,665.298 423.5,665.5C 423.5,652.5 423.5,639.5 423.5,626.5C 433.833,626.5 444.167,626.5 454.5,626.5C 464.039,628.438 472.706,632.271 480.5,638C 493.662,642.474 502.329,638.307 506.5,625.5C 507.491,622.756 507.157,620.089 505.5,617.5C 504.016,613.868 502.016,610.534 499.5,607.5C 499.047,606.542 498.381,605.708 497.5,605C 498.517,603.951 498.684,602.784 498,601.5C 495.851,602.84 494.684,602.173 494.5,599.5C 497.601,596.165 500.601,592.665 503.5,589C 504.745,588.209 506.078,587.709 507.5,587.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858687",
    d: "M 866.5,586.5 C 868.027,586.427 869.027,587.094 869.5,588.5C 867.973,588.573 866.973,587.906 866.5,586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffac7d",
    d: "M 524.5,589.5 C 525.71,589.932 526.71,590.599 527.5,591.5C 525.821,591.715 524.821,591.048 524.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8c8b",
    d: "M 875.5,594.5 C 877.027,594.427 878.027,595.094 878.5,596.5C 876.973,596.573 875.973,595.906 875.5,594.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797979",
    d: "M 904.5,509.5 C 905.498,539.662 905.831,569.995 905.5,600.5C 897.493,600.666 889.493,600.5 881.5,600C 880.944,599.617 880.611,599.117 880.5,598.5C 888.445,599.437 896.445,599.77 904.5,599.5C 904.5,569.5 904.5,539.5 904.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#525253",
    d: "M 925.5,577.5 C 926.492,584.648 926.825,591.981 926.5,599.5C 947.167,599.5 967.833,599.5 988.5,599.5C 988.185,595.629 988.518,591.962 989.5,588.5C 989.5,592.5 989.5,596.5 989.5,600.5C 968.167,600.5 946.833,600.5 925.5,600.5C 925.5,592.833 925.5,585.167 925.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd8140",
    d: "M 494.5,599.5 C 494.684,602.173 495.851,602.84 498,601.5C 498.684,602.784 498.517,603.951 497.5,605C 498.381,605.708 499.047,606.542 499.5,607.5C 495.793,606.489 492.127,605.323 488.5,604C 490.095,601.898 492.095,600.398 494.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a6a6",
    d: "M 786.5,590.5 C 787.482,593.962 787.815,597.629 787.5,601.5C 744.997,601.832 702.663,601.499 660.5,600.5C 660.833,600.5 661.167,600.5 661.5,600.5C 703.167,600.5 744.833,600.5 786.5,600.5C 786.5,597.5 786.5,594.5 786.5,591.5C 786.5,591.167 786.5,590.833 786.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaaaaa",
    d: "M 624.5,577.5 C 625.5,577.5 626.5,577.5 627.5,577.5C 628.102,584.483 628.769,584.817 629.5,578.5C 631.167,578.5 632.833,578.5 634.5,578.5C 634.5,592.833 634.5,607.167 634.5,621.5C 629.833,621.5 625.167,621.5 620.5,621.5C 620.67,620.178 620.337,619.011 619.5,618C 597.836,617.5 576.169,617.333 554.5,617.5C 554.602,609.046 554.602,600.713 554.5,592.5C 554.709,591.914 555.043,591.414 555.5,591C 559.152,590.501 562.818,590.335 566.5,590.5C 566.5,587.5 566.5,584.5 566.5,581.5C 575.342,582.792 584.342,583.626 593.5,584C 594.833,584.667 594.833,585.333 593.5,586C 588.167,586.333 582.833,586.667 577.5,587C 576.376,587.249 575.376,587.749 574.5,588.5C 584.062,589.705 594.062,590.372 604.5,590.5C 609.671,590.644 614.671,590.144 619.5,589C 615.198,588.353 611.031,588.52 607,589.5C 603.196,589.289 600.029,587.789 597.5,585C 597.833,584.667 598.167,584.333 598.5,584C 605.199,583.639 611.865,582.972 618.5,582C 617.833,581.667 617.167,581.333 616.5,581C 618.146,579.599 619.813,579.432 621.5,580.5C 620.391,582.214 621.058,582.881 623.5,582.5C 623.366,580.708 623.699,579.042 624.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb7302",
    d: "M 242.5,605.5 C 242.5,626.833 242.5,648.167 242.5,669.5C 184.5,669.5 126.5,669.5 68.5,669.5C 68.5,648.167 68.5,626.833 68.5,605.5C 126.5,605.5 184.5,605.5 242.5,605.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949595",
    d: "M 321.5,606.5 C 301.167,606.5 280.833,606.5 260.5,606.5C 260.5,616.167 260.5,625.833 260.5,635.5C 274.833,635.5 289.167,635.5 303.5,635.5C 303.5,640.5 303.5,645.5 303.5,650.5C 289.167,650.5 274.833,650.5 260.5,650.5C 260.5,661.167 260.5,671.833 260.5,682.5C 282.167,682.5 303.833,682.5 325.5,682.5C 303.673,683.497 281.673,683.831 259.5,683.5C 259.5,672.167 259.5,660.833 259.5,649.5C 273.833,649.5 288.167,649.5 302.5,649.5C 302.5,645.167 302.5,640.833 302.5,636.5C 288.167,636.5 273.833,636.5 259.5,636.5C 259.5,626.167 259.5,615.833 259.5,605.5C 280.34,605.169 301.007,605.503 321.5,606.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#060606",
    d: "M 321.5,606.5 C 323.144,606.286 324.644,606.62 326,607.5C 326.83,632.67 326.663,657.67 325.5,682.5C 303.833,682.5 282.167,682.5 260.5,682.5C 260.5,671.833 260.5,661.167 260.5,650.5C 274.833,650.5 289.167,650.5 303.5,650.5C 303.5,645.5 303.5,640.5 303.5,635.5C 289.167,635.5 274.833,635.5 260.5,635.5C 260.5,625.833 260.5,616.167 260.5,606.5C 280.833,606.5 301.167,606.5 321.5,606.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc9a64",
    d: "M 434.5,606.5 C 437.152,606.41 439.485,607.076 441.5,608.5C 438.848,608.59 436.515,607.924 434.5,606.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#040505",
    d: "M 658.5,607.5 C 662.452,608.272 666.452,608.605 670.5,608.5C 682.743,608.897 694.743,610.231 706.5,612.5C 714.774,613.558 723.108,614.892 731.5,616.5C 739.601,618.29 747.934,619.29 756.5,619.5C 760.9,621.104 765.566,621.771 770.5,621.5C 774.042,621.187 777.375,621.521 780.5,622.5C 782.265,623.461 784.265,623.795 786.5,623.5C 786.5,637.167 786.5,650.833 786.5,664.5C 779.928,664.239 773.594,664.906 767.5,666.5C 759.117,669.011 750.451,670.678 741.5,671.5C 737.922,671.549 734.589,672.215 731.5,673.5C 726.006,674.435 720.339,675.102 714.5,675.5C 709.786,675.173 705.12,675.507 700.5,676.5C 701.325,677.386 702.325,677.719 703.5,677.5C 707.295,678.617 711.295,679.283 715.5,679.5C 717.415,679.216 719.081,679.549 720.5,680.5C 725.591,682.129 730.924,683.129 736.5,683.5C 739.781,683.42 742.781,684.087 745.5,685.5C 747.838,687.04 750.505,687.706 753.5,687.5C 757.761,687.898 761.761,688.898 765.5,690.5C 771.051,693.39 777.051,695.057 783.5,695.5C 784.209,696.404 785.209,696.737 786.5,696.5C 786.5,709.833 786.5,723.167 786.5,736.5C 744.167,736.5 701.833,736.5 659.5,736.5C 659.572,725.817 659.238,715.15 658.5,704.5C 676.836,704.667 695.17,704.5 713.5,704C 716.468,701.822 716.135,700.656 712.5,700.5C 710.898,698.926 708.898,698.259 706.5,698.5C 700.915,697.77 695.582,696.437 690.5,694.5C 687.781,693.087 684.781,692.42 681.5,692.5C 677.622,689.987 673.289,688.654 668.5,688.5C 664.9,688.206 661.4,687.54 658,686.5C 657.813,674.787 657.313,663.121 656.5,651.5C 657.325,650.614 658.325,650.281 659.5,650.5C 670.42,650.674 681.087,649.674 691.5,647.5C 697.274,646.054 703.274,645.388 709.5,645.5C 711.924,645.808 714.257,645.474 716.5,644.5C 715.311,643.571 713.978,643.238 712.5,643.5C 705.347,642.462 698.014,641.796 690.5,641.5C 680.616,641.807 670.95,641.14 661.5,639.5C 660.791,638.596 659.791,638.263 658.5,638.5C 658.5,628.167 658.5,617.833 658.5,607.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797979",
    d: "M 658.5,607.5 C 658.917,606.876 659.584,606.543 660.5,606.5C 664.002,607.011 667.335,607.678 670.5,608.5C 666.452,608.605 662.452,608.272 658.5,607.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadddd",
    d: "M 733.5,611.5 C 734.833,612.167 734.833,612.167 733.5,611.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadcdd",
    d: "M 735.5,611.5 C 736.833,612.167 736.833,612.167 735.5,611.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcbcbe",
    d: "M 733.5,612.5 C 732.653,613.966 731.32,614.8 729.5,615C 730.416,615.278 731.082,615.778 731.5,616.5C 723.108,614.892 714.774,613.558 706.5,612.5C 715.569,611.602 724.569,611.602 733.5,612.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d5d5",
    d: "M 1023.5,614.5 C 1023.5,621.5 1023.5,628.5 1023.5,635.5C 1020.51,634.645 1017.51,634.145 1014.5,634C 1012.03,637.033 1011.03,640.533 1011.5,644.5C 1018.04,644.538 1018.04,645.204 1011.5,646.5C 1012.83,647.5 1012.83,648.5 1011.5,649.5C 1015.54,650.227 1019.54,650.894 1023.5,651.5C 1023.5,652.5 1023.5,653.5 1023.5,654.5C 1019.5,654.5 1015.5,654.5 1011.5,654.5C 1011.23,657.119 1011.56,659.619 1012.5,662C 1016.15,662.499 1019.82,662.665 1023.5,662.5C 1023.5,667.833 1023.5,673.167 1023.5,678.5C 952.348,678.472 880.681,678.805 808.5,679.5C 808.5,657.833 808.5,636.167 808.5,614.5C 880.167,614.5 951.833,614.5 1023.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a3a3",
    d: "M 658.5,607.5 C 658.5,617.833 658.5,628.167 658.5,638.5C 659.791,638.263 660.791,638.596 661.5,639.5C 660.167,639.5 658.833,639.5 657.5,639.5C 657.172,628.654 657.506,617.987 658.5,607.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#777778",
    d: "M 731.5,616.5 C 740.049,616.856 748.382,617.856 756.5,619.5C 747.934,619.29 739.601,618.29 731.5,616.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747576",
    d: "M 756.5,619.5 C 761.37,619.69 766.036,620.356 770.5,621.5C 765.566,621.771 760.9,621.104 756.5,619.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faae81",
    d: "M 505.5,617.5 C 507.157,620.089 507.491,622.756 506.5,625.5C 505.908,622.873 505.575,620.206 505.5,617.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd0cf",
    d: "M 16.5,649.5 C 18.772,650.723 19.9386,652.723 20,655.5C 20.8236,658.882 20.657,662.216 19.5,665.5C 17.2975,663.705 16.1308,661.371 16,658.5C 15.8603,661.043 15.1937,663.377 14,665.5C 12.8873,664.695 11.7206,664.028 10.5,663.5C 7.827,666.341 5.327,669.341 3,672.5C 1.88298,671.051 1.21631,669.384 1,667.5C 0.617425,668.056 0.117425,668.389 -0.5,668.5C -0.5,656.833 -0.5,645.167 -0.5,633.5C 0.833333,633.167 0.833333,632.833 -0.5,632.5C -0.5,626.167 -0.5,619.833 -0.5,613.5C 1.37857,613.393 1.7119,613.893 0.5,615C 2.54454,619.447 3.54454,618.947 3.5,613.5C 18.8918,612.879 34.2251,612.712 49.5,613C 46.9568,613.14 44.6234,613.806 42.5,615C 45.29,616.437 48.1233,616.27 51,614.5C 51.5,614.833 52,615.167 52.5,615.5C 51.5,616.333 50.5,617.167 49.5,618C 51.6687,618.429 53.6687,617.929 55.5,616.5C 56.906,617.951 58.406,619.284 60,620.5C 60.5946,621.899 60.4279,623.232 59.5,624.5C 61.0049,625.842 61.6715,627.508 61.5,629.5C 58.225,629.233 57.3916,630.233 59,632.5C 59.414,632.043 59.914,631.709 60.5,631.5C 61.4157,636.531 61.0824,641.531 59.5,646.5C 58.7193,645.263 57.7193,644.263 56.5,643.5C 52.3848,645.743 50.2182,649.077 50,653.5C 52.5829,652.126 55.0829,650.626 57.5,649C 56.0439,648.577 55.5439,647.744 56,646.5C 57.2989,647.09 58.1322,648.09 58.5,649.5C 57.1355,653.184 54.4689,654.851 50.5,654.5C 50.3433,655.873 50.51,657.207 51,658.5C 52.5445,657.179 53.7112,657.512 54.5,659.5C 53.1974,661.377 51.6974,663.043 50,664.5C 49.3333,665.167 49.3333,665.833 50,666.5C 53.4326,667.059 56.9326,667.393 60.5,667.5C 55.1977,668.663 49.8643,668.829 44.5,668C 42.8078,666.599 42.1412,664.766 42.5,662.5C 40.8008,662.34 39.1341,662.506 37.5,663C 38.3279,663.915 39.3279,664.581 40.5,665C 39.3379,665.827 38.1712,666.66 37,667.5C 33.3647,665.197 30.0314,662.53 27,659.5C 25.2817,657.103 24.1151,654.436 23.5,651.5C 22.8076,652.025 22.3076,652.692 22,653.5C 21.1064,650.608 19.4397,648.274 17,646.5C 16.1779,644.212 15.5112,641.878 15,639.5C 9.99498,635.467 5.66165,631.467 2,627.5C 1.6666,629.047 2.1666,630.38 3.5,631.5C 2.95289,634.378 2.61955,637.211 2.5,640C 3.96533,640.601 4.96533,640.101 5.5,638.5C 4.51529,636.902 4.34862,635.235 5,633.5C 7.45846,637.575 10.4585,641.241 14,644.5C 14.1725,648.871 14.6725,653.204 15.5,657.5C 16.48,654.914 16.8134,652.247 16.5,649.5 Z M 33.5,630.5 C 35.0348,629.212 36.7015,629.212 38.5,630.5C 36.6308,632.984 34.9641,632.984 33.5,630.5 Z M 47.5,628.5 C 47.281,629.675 47.6143,630.675 48.5,631.5C 53.0547,626.618 55.0547,627.952 54.5,635.5C 52.5588,635.869 50.7255,636.536 49,637.5C 48.3292,636.748 47.4959,636.414 46.5,636.5C 46.4142,635.504 46.7476,634.671 47.5,634C 46.1667,634 44.8333,634 43.5,634C 44.9771,632.188 46.3104,630.355 47.5,628.5 Z M 43.5,628.5 C 46.0009,628.511 46.1676,629.178 44,630.5C 43.5357,629.906 43.369,629.239 43.5,628.5 Z M 20.5,628.5 C 21.0431,628.56 21.3764,628.893 21.5,629.5C 20.277,630.614 18.9437,630.781 17.5,630C 18.7375,629.768 19.7375,629.268 20.5,628.5 Z M 14.5,628.5 C 15.5735,629.251 15.7401,630.251 15,631.5C 13.2716,630.648 13.105,629.648 14.5,628.5 Z M 47.5,628.5 C 47.5106,626.314 48.5106,625.481 50.5,626C 49.6266,627.045 48.6266,627.878 47.5,628.5 Z M 1.5,625.5 C 2.07683,624.227 2.7435,624.227 3.5,625.5C 3.03017,626.463 2.3635,626.463 1.5,625.5 Z M 51.5,623.5 C 53.7602,624.238 53.9269,625.238 52,626.5C 51.5172,625.552 51.3505,624.552 51.5,623.5 Z M 23.5,621.5 C 25.896,622.3 28.2293,623.3 30.5,624.5C 29.624,625.251 28.624,625.751 27.5,626C 28.7112,626.893 28.7112,627.726 27.5,628.5C 26.1204,626.138 24.7871,623.805 23.5,621.5 Z M 16.5,618.5 C 16.4827,620.028 15.816,620.528 14.5,620C 15.0442,619.283 15.7109,618.783 16.5,618.5 Z M 10.5,616.5 C 11.209,615.596 12.209,615.263 13.5,615.5C 13.2739,618.249 13.6072,620.916 14.5,623.5C 14,624.5 13.5,625.5 13,626.5C 11.9156,623.166 11.0823,619.832 10.5,616.5 Z M 31.5,615.5 C 31.9169,614.876 32.5836,614.543 33.5,614.5C 35.3904,615.612 37.3904,616.446 39.5,617C 37.114,618.887 35.9473,621.387 36,624.5C 35.1779,622.212 34.5112,619.878 34,617.5C 33.2917,616.619 32.4584,615.953 31.5,615.5 Z M 28.5,615.5 C 29.0768,614.227 29.7435,614.227 30.5,615.5C 30.0302,616.463 29.3635,616.463 28.5,615.5 Z M 22.5,614.5 C 23.6879,615.684 24.8545,615.684 26,614.5C 28.0318,615.94 27.6984,616.607 25,616.5C 23.6244,616.316 22.7911,615.649 22.5,614.5 Z M 16.5,618.5 C 16.0555,615.154 17.7221,613.987 21.5,615C 20.7809,617.556 19.1142,618.723 16.5,618.5 Z M 23.5,633.5 C 25.337,633.639 25.6704,634.306 24.5,635.5C 23.7025,635.043 23.3691,634.376 23.5,633.5 Z M 54.5,635.5 C 55.4232,634.697 56.4232,634.53 57.5,635C 55.7647,637.192 54.598,639.692 54,642.5C 52.4447,644.515 50.6114,644.848 48.5,643.5C 49.376,642.749 50.376,642.249 51.5,642C 50.3279,641.581 49.3279,640.915 48.5,640C 51.0139,639.119 53.0139,637.619 54.5,635.5 Z M 20.5,635.5 C 21.8366,636.315 22.8366,637.482 23.5,639C 21.5216,638.967 20.5216,637.8 20.5,635.5 Z M 27.5,636.5 C 30.1506,637.725 29.9839,638.725 27,639.5C 26.5,639.167 26,638.833 25.5,638.5C 26.2427,637.818 26.9094,637.151 27.5,636.5 Z M 46.5,636.5 C 47.6736,638.368 47.0069,639.368 44.5,639.5C 43.3264,637.632 43.9931,636.632 46.5,636.5 Z M 57.5,637.5 C 58.2891,637.783 58.9558,638.283 59.5,639C 58.184,639.528 57.5173,639.028 57.5,637.5 Z M 42.5,650.5 C 41.3064,651.777 39.6397,652.444 37.5,652.5C 35.8333,652.333 34.1667,652.167 32.5,652C 33.5,651.667 34.5,651.333 35.5,651C 34.7728,648.876 34.1062,646.709 33.5,644.5C 33.8333,644.167 34.1667,643.833 34.5,643.5C 37.337,644.509 38.6703,646.509 38.5,649.5C 39.9587,649.433 41.2921,649.766 42.5,650.5 Z M 2.5,644.5 C 3.76597,645.09 5.0993,645.59 6.5,646C 6.16667,646.333 5.83333,646.667 5.5,647C 8.01922,648.338 9.35255,650.504 9.5,653.5C 9.5472,655 8.88053,656 7.5,656.5C 6.77022,655.066 5.77022,653.9 4.5,653C 5.15009,651.391 4.65009,649.891 3,648.5C 2.50999,647.207 2.34332,645.873 2.5,644.5 Z M 11.5,646.5 C 12.7733,647.077 12.7733,647.743 11.5,648.5C 10.537,648.03 10.537,647.363 11.5,646.5 Z M 42.5,650.5 C 42.7467,648.025 43.4134,648.025 44.5,650.5C 44.0302,651.463 43.3635,651.463 42.5,650.5 Z M 35.5,660.5 C 33.6954,659.763 32.0287,658.763 30.5,657.5C 31.0016,656.479 31.6683,656.312 32.5,657C 34.0629,657.759 35.0629,658.926 35.5,660.5 Z M 10.5,663.5 C 9.63638,662.312 8.63638,661.145 7.5,660C 8.44802,659.517 9.44802,659.351 10.5,659.5C 10.5,660.833 10.5,662.167 10.5,663.5 Z M 46.5,661.5 C 48.6456,661.696 48.8122,662.696 47,664.5C 45.2716,663.648 45.105,662.648 46.5,661.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faa35e",
    d: "M 242.5,605.5 C 184.5,605.5 126.5,605.5 68.5,605.5C 68.5,626.833 68.5,648.167 68.5,669.5C 67.5027,648.006 67.1693,626.34 67.5,604.5C 126.002,604.168 184.336,604.501 242.5,605.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbdbdd",
    d: "M 1021.5,638.5 C 1022.97,641.557 1022.3,642.057 1019.5,640C 1020.42,639.722 1021.08,639.222 1021.5,638.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3d7d6",
    d: "M 13.5,640.5 C 14.8333,641.167 14.8333,641.167 13.5,640.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878988",
    d: "M 690.5,641.5 C 698.014,641.796 705.347,642.462 712.5,643.5C 704.929,643.843 697.596,643.177 690.5,641.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6e6c",
    d: "M 712.5,643.5 C 713.978,643.238 715.311,643.571 716.5,644.5C 714.257,645.474 711.924,645.808 709.5,645.5C 710.5,644.833 711.5,644.167 712.5,643.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606060",
    d: "M 780.5,622.5 C 782.833,622.5 785.167,622.5 787.5,622.5C 787.5,636.833 787.5,651.167 787.5,665.5C 780.82,665.612 774.153,665.946 767.5,666.5C 773.594,664.906 779.928,664.239 786.5,664.5C 786.5,650.833 786.5,637.167 786.5,623.5C 784.265,623.795 782.265,623.461 780.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9d8da",
    d: "M 16.5,649.5 C 15.475,649.103 15.3083,648.437 16,647.5C 16.4643,648.094 16.631,648.761 16.5,649.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767677",
    d: "M 691.5,647.5 C 681.087,649.674 670.42,650.674 659.5,650.5C 669.997,649.251 680.664,648.251 691.5,647.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcac7e",
    d: "M 454.5,626.5 C 444.167,626.5 433.833,626.5 423.5,626.5C 423.5,639.5 423.5,652.5 423.5,665.5C 422.504,652.344 422.171,639.01 422.5,625.5C 433.346,625.172 444.013,625.506 454.5,626.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cecfce",
    d: "M 558.5,650.5 C 573.833,650.5 589.167,650.5 604.5,650.5C 605.138,664.579 604.472,678.412 602.5,692C 604.414,696.858 605.081,702.025 604.5,707.5C 588.725,707.383 573.392,707.05 558.5,706.5C 558.905,687.916 558.905,669.249 558.5,650.5 Z M 562.5,692.5 C 561.325,692.719 560.325,692.386 559.5,691.5C 561.052,690.202 562.052,690.535 562.5,692.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dadb",
    d: "M 1013.5,658.5 C 1014.25,657.427 1015.25,657.26 1016.5,658C 1015.55,658.483 1014.55,658.649 1013.5,658.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dbdd",
    d: "M 1020.5,658.5 C 1020.9,657.475 1021.56,657.308 1022.5,658C 1021.91,658.464 1021.24,658.631 1020.5,658.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9a9a9",
    d: "M 634.5,648.5 C 634.5,651.167 634.5,653.833 634.5,656.5C 633.5,656.5 632.5,656.5 631.5,656.5C 631.977,667.996 631.477,679.329 630,690.5C 629.735,687.584 629.069,684.584 628,681.5C 624.938,683.13 623.271,682.13 623,678.5C 621.309,681.131 620.142,680.797 619.5,677.5C 618.908,669.113 618.075,660.779 617,652.5C 615.117,649.976 612.617,648.642 609.5,648.5C 608.517,644.702 608.183,640.702 608.5,636.5C 617.547,635.149 625.714,637.149 633,642.5C 634.128,644.345 634.628,646.345 634.5,648.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#facca6",
    d: "M 242.5,605.5 C 243.497,626.994 243.831,648.66 243.5,670.5C 184.998,670.832 126.664,670.499 68.5,669.5C 126.5,669.5 184.5,669.5 242.5,669.5C 242.5,648.167 242.5,626.833 242.5,605.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fea672",
    d: "M 463.5,671.5 C 466.152,671.41 468.485,672.076 470.5,673.5C 467.772,673.829 465.438,673.163 463.5,671.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838484",
    d: "M 741.5,671.5 C 738.456,673.011 735.122,673.678 731.5,673.5C 734.589,672.215 737.922,671.549 741.5,671.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6c6c",
    d: "M 714.5,675.5 C 710.833,676.167 707.167,676.833 703.5,677.5C 702.325,677.719 701.325,677.386 700.5,676.5C 705.12,675.507 709.786,675.173 714.5,675.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0d2d1",
    d: "M -0.5,684.5 C -0.5,681.833 -0.5,679.167 -0.5,676.5C 0.495904,676.414 1.32924,676.748 2,677.5C 14.7855,676.805 27.6188,675.971 40.5,675C 42.1554,673.556 42.822,671.722 42.5,669.5C 45.8499,669.335 49.1832,669.502 52.5,670C 52.5943,671.422 52.9276,672.922 53.5,674.5C 54.1667,673.833 54.8333,673.167 55.5,672.5C 58.6266,673.564 61.6266,674.897 64.5,676.5C 60.4458,676.706 56.7791,677.039 53.5,677.5C 57.4454,678.491 61.4454,678.824 65.5,678.5C 65.5,680.167 65.5,681.833 65.5,683.5C 43.4163,683.667 21.4163,684.001 -0.5,684.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8c8d",
    d: "M 703.5,677.5 C 707.79,677.198 711.79,677.864 715.5,679.5C 711.295,679.283 707.295,678.617 703.5,677.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b5b6",
    d: "M 609.5,648.5 C 612.617,648.642 615.117,649.976 617,652.5C 618.075,660.779 618.908,669.113 619.5,677.5C 620.142,680.797 621.309,681.131 623,678.5C 623.271,682.13 624.938,683.13 628,681.5C 629.069,684.584 629.735,687.584 630,690.5C 631.477,679.329 631.977,667.996 631.5,656.5C 632.5,656.5 633.5,656.5 634.5,656.5C 634.5,653.833 634.5,651.167 634.5,648.5C 635.661,664.328 635.828,680.328 635,696.5C 633.505,701.162 630.339,703.828 625.5,704.5C 627.415,702.423 628.748,700.423 629.5,698.5C 630.647,696.235 630.814,693.902 630,691.5C 628.235,690.761 626.235,690.761 624,691.5C 623.383,690.551 623.549,689.718 624.5,689C 622.431,688.676 622.098,687.842 623.5,686.5C 621.995,683.869 621.329,684.203 621.5,687.5C 620.448,687.351 619.448,687.517 618.5,688C 613.236,692.619 610.569,698.453 610.5,705.5C 612.833,705.5 615.167,705.5 617.5,705.5C 614.492,706.921 611.492,706.754 608.5,705C 610.662,694.494 611.662,683.827 611.5,673C 611.121,667.126 611.121,661.46 611.5,656C 610.78,653.509 610.113,651.009 609.5,648.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787878",
    d: "M 720.5,680.5 C 726.116,680.656 731.449,681.656 736.5,683.5C 730.924,683.129 725.591,682.129 720.5,680.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898889",
    d: "M 745.5,685.5 C 748.428,685.565 751.095,686.232 753.5,687.5C 750.505,687.706 747.838,687.04 745.5,685.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6711",
    d: "M 410.5,689.5 C 452.167,689.5 493.833,689.5 535.5,689.5C 535.173,699.681 535.506,709.681 536.5,719.5C 537.801,720.884 537.801,722.384 536.5,724C 533.961,724.796 531.628,724.629 529.5,723.5C 490.004,722.501 450.337,722.168 410.5,722.5C 410.5,711.5 410.5,700.5 410.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7e7d",
    d: "M 668.5,688.5 C 673.289,688.654 677.622,689.987 681.5,692.5C 676.968,691.543 672.635,690.21 668.5,688.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7b7b",
    d: "M 765.5,690.5 C 771.687,691.877 777.687,693.544 783.5,695.5C 777.051,695.057 771.051,693.39 765.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a7a7",
    d: "M 625.5,704.5 C 622.751,705.664 620.084,705.997 617.5,705.5C 615.167,705.5 612.833,705.5 610.5,705.5C 610.569,698.453 613.236,692.619 618.5,688C 619.448,687.517 620.448,687.351 621.5,687.5C 621.329,684.203 621.995,683.869 623.5,686.5C 622.098,687.842 622.431,688.676 624.5,689C 623.549,689.718 623.383,690.551 624,691.5C 626.235,690.761 628.235,690.761 630,691.5C 630.814,693.902 630.647,696.235 629.5,698.5C 628.748,700.423 627.415,702.423 625.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f7070",
    d: "M 681.5,692.5 C 684.781,692.42 687.781,693.087 690.5,694.5C 687.219,694.58 684.219,693.913 681.5,692.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 1023.5,695.5 C 1023.5,702.833 1023.5,710.167 1023.5,717.5C 1004.68,713.825 997.515,721.491 1002,740.5C 1007.21,748.184 1014.38,750.851 1023.5,748.5C 1023.5,755.833 1023.5,763.167 1023.5,770.5C 995.17,773.485 978.837,760.819 974.5,732.5C 975.582,721.947 979.249,712.447 985.5,704C 996.735,694.415 1009.4,691.581 1023.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8e8e",
    d: "M 840.5,695.5 C 853.409,695.939 861.076,702.439 863.5,715C 862.002,720.5 858.669,724.5 853.5,727C 861.559,729.926 865.559,735.759 865.5,744.5C 865.405,759.098 858.072,767.264 843.5,769C 830.66,769.827 817.993,769.66 805.5,768.5C 805.5,744.167 805.5,719.833 805.5,695.5C 817.167,695.5 828.833,695.5 840.5,695.5 Z M 837.5,713.5 C 841.747,719.499 839.914,722.499 832,722.5C 830.408,722.395 828.908,722.061 827.5,721.5C 827.5,718.833 827.5,716.167 827.5,713.5C 830.833,713.5 834.167,713.5 837.5,713.5 Z M 827.5,740.5 C 832.051,740.053 836.384,740.719 840.5,742.5C 841.795,745.439 841.128,747.939 838.5,750C 834.848,750.499 831.182,750.665 827.5,750.5C 827.5,747.167 827.5,743.833 827.5,740.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909191",
    d: "M 908.5,747.5 C 904.833,747.5 901.167,747.5 897.5,747.5C 897.5,754.5 897.5,761.5 897.5,768.5C 890.098,769.827 882.598,769.827 875,768.5C 874.333,744.167 874.333,719.833 875,695.5C 885.09,694.348 895.256,694.181 905.5,695C 928.147,699.875 935.647,713.375 928,735.5C 924.157,743.678 917.657,747.678 908.5,747.5 Z M 898.5,712.5 C 905.231,712.064 908.564,715.231 908.5,722C 908.729,728.27 905.729,731.437 899.5,731.5C 898.74,725.196 898.407,718.863 898.5,712.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 962.5,768.5 C 955.098,769.827 947.598,769.827 940,768.5C 939.534,744.126 939.701,720.126 940.5,696.5C 947.746,695.536 955.08,695.203 962.5,695.5C 962.5,719.833 962.5,744.167 962.5,768.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbcbcb",
    d: "M 42.5,698.5 C 47.5111,698.334 52.5111,698.501 57.5,699C 65.1788,701.7 67.1788,706.7 63.5,714C 58.6768,715.251 55.1768,713.418 53,708.5C 49.132,706.851 46.632,708.018 45.5,712C 45.7029,714.406 46.7029,716.406 48.5,718C 55.5278,719.922 60.6945,724.089 64,730.5C 64.6667,734.5 64.6667,738.5 64,742.5C 62.654,745.179 60.654,747.179 58,748.5C 50.1536,751.421 42.487,751.088 35,747.5C 32.2201,743.433 31.7201,739.099 33.5,734.5C 36.2706,734.421 38.9373,734.921 41.5,736C 43.4616,741.745 46.9616,742.911 52,739.5C 52.6667,737.167 52.6667,734.833 52,732.5C 47.1519,730.577 42.3186,728.577 37.5,726.5C 34.3783,723.921 32.7117,720.587 32.5,716.5C 33.2511,712.165 34.0845,707.832 35,703.5C 37.4795,701.686 39.9795,700.019 42.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcdcdb",
    d: "M 130.5,698.5 C 131.833,699.167 131.833,699.167 130.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 283.5,744.5 C 296.5,745.833 309.5,745.833 322.5,744.5C 323.5,744.5 324.5,744.5 325.5,744.5C 325.5,755.5 325.5,766.5 325.5,777.5C 303.833,777.5 282.167,777.5 260.5,777.5C 260.5,751.167 260.5,724.833 260.5,698.5C 282.167,698.5 303.833,698.5 325.5,698.5C 325.5,708.5 325.5,718.5 325.5,728.5C 311.167,728.5 296.833,728.5 282.5,728.5C 282.179,734.026 282.512,739.36 283.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848586",
    d: "M 706.5,698.5 C 708.898,698.259 710.898,698.926 712.5,700.5C 710.214,700.405 708.214,699.738 706.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbcbcb",
    d: "M -0.5,699.5 C 6.5736,699.161 13.5736,699.661 20.5,701C 30.4834,708.061 30.8167,715.727 21.5,724C 16.4844,726.333 11.3178,728.166 6,729.5C 5.50042,736.158 5.33375,742.825 5.5,749.5C 3.5,749.5 1.5,749.5 -0.5,749.5C -0.5,732.833 -0.5,716.167 -0.5,699.5 Z M 6.5,705.5 C 13.921,707.352 15.921,711.519 12.5,718C 10.3496,719.411 8.01632,720.245 5.5,720.5C 5.22128,715.405 5.55462,710.405 6.5,705.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbcbcb",
    d: "M 73.5,699.5 C 76.8333,699.5 80.1667,699.5 83.5,699.5C 83.9505,715.89 84.2839,732.556 84.5,749.5C 80.8333,749.5 77.1667,749.5 73.5,749.5C 73.5,732.833 73.5,716.167 73.5,699.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcece",
    d: "M 89.5,699.5 C 97.84,699.334 106.173,699.5 114.5,700C 116.359,701.558 117.859,703.391 119,705.5C 119.49,704.207 119.657,702.873 119.5,701.5C 123.179,701.724 126.846,702.058 130.5,702.5C 130.904,717.441 130.237,732.274 128.5,747C 128.833,747.333 129.167,747.667 129.5,748C 125.188,749.544 123.022,748.044 123,743.5C 120.97,745.737 118.47,747.237 115.5,748C 106.886,749.297 98.2189,749.797 89.5,749.5C 89.5,732.833 89.5,716.167 89.5,699.5 Z M 102.5,710.5 C 105.243,710.077 106.576,711.244 106.5,714C 106.491,715.404 105.991,716.57 105,717.5C 103.989,716.663 102.822,716.33 101.5,716.5C 101.325,714.379 101.659,712.379 102.5,710.5 Z M 110.5,710.5 C 112.308,711.918 112.975,713.918 112.5,716.5C 111.167,716.5 109.833,716.5 108.5,716.5C 108.259,714.114 108.925,712.114 110.5,710.5 Z M 116.5,717.5 C 119.841,716.843 121.841,718.176 122.5,721.5C 123.333,720.5 124.167,719.5 125,718.5C 125.814,720.902 125.647,723.235 124.5,725.5C 123.476,724.147 122.143,723.48 120.5,723.5C 120.617,725.484 119.95,727.15 118.5,728.5C 117.956,725.286 116.956,722.286 115.5,719.5C 115.863,718.817 116.196,718.15 116.5,717.5 Z M 101.5,730.5 C 105.908,730.062 107.575,732.062 106.5,736.5C 101.074,737.416 99.4071,735.416 101.5,730.5 Z M 108.5,731.5 C 112.34,732.568 112.507,734.235 109,736.5C 108.5,736 108,735.5 107.5,735C 108.337,733.989 108.67,732.822 108.5,731.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cccccb",
    d: "M 167.5,698.5 C 177.296,698.399 187.296,698.566 197.5,699C 197.793,704.056 197.793,709.222 197.5,714.5C 194.167,714.5 190.833,714.5 187.5,714.5C 187.662,712.473 187.495,710.473 187,708.5C 184.779,708.294 182.612,707.961 180.5,707.5C 179.511,711.107 179.177,714.774 179.5,718.5C 184.833,718.5 190.167,718.5 195.5,718.5C 195.29,722.858 196.29,726.858 198.5,730.5C 192.162,730.233 185.829,729.9 179.5,729.5C 179.223,732.448 179.556,735.281 180.5,738C 186.491,738.499 192.491,738.666 198.5,738.5C 198.5,742.167 198.5,745.833 198.5,749.5C 187.833,749.5 177.167,749.5 166.5,749.5C 166.248,732.579 166.581,715.579 167.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fca270",
    d: "M 410.5,689.5 C 452.33,688.501 494.33,688.168 536.5,688.5C 536.5,698.833 536.5,709.167 536.5,719.5C 535.506,709.681 535.173,699.681 535.5,689.5C 493.833,689.5 452.167,689.5 410.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#525253",
    d: "M 712.5,700.5 C 716.135,700.656 716.468,701.822 713.5,704C 695.17,704.5 676.836,704.667 658.5,704.5C 658.5,704.167 658.5,703.833 658.5,703.5C 676.503,703.667 694.503,703.5 712.5,703C 713.598,702.23 713.598,701.397 712.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcccc",
    d: "M 138.5,698.5 C 141.024,698.957 143.691,698.957 146.5,698.5C 146.5,712.167 146.5,725.833 146.5,739.5C 151.5,739.5 156.5,739.5 161.5,739.5C 161.5,742.833 161.5,746.167 161.5,749.5C 152.5,749.5 143.5,749.5 134.5,749.5C 134.5,732.833 134.5,716.167 134.5,699.5C 136.099,699.768 137.432,699.434 138.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcecd",
    d: "M 837.5,713.5 C 834.167,713.5 830.833,713.5 827.5,713.5C 827.5,716.167 827.5,718.833 827.5,721.5C 826.523,718.713 826.19,715.713 826.5,712.5C 830.371,712.185 834.038,712.518 837.5,713.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cccdcd",
    d: "M 216.5,698.5 C 221.688,698.819 226.854,698.819 232,698.5C 238.406,701.117 240.239,705.783 237.5,712.5C 235.568,713.52 233.568,713.687 231.5,713C 228.041,709.886 224.041,708.886 219.5,710C 217.473,711.396 217.14,713.062 218.5,715C 224.175,716.907 229.509,719.407 234.5,722.5C 240.73,730.24 241.063,738.24 235.5,746.5C 233.869,748.297 231.869,749.464 229.5,750C 224.833,750.667 220.167,750.667 215.5,750C 211.611,749.938 208.111,748.771 205,746.5C 204.503,743.332 204.003,740.499 203.5,738C 207.833,737.333 212.167,737.333 216.5,738C 222.908,743.61 227.241,742.444 229.5,734.5C 228.687,733.186 227.687,732.019 226.5,731C 219.793,728.726 212.96,727.226 206,726.5C 205.168,717.814 205.335,709.147 206.5,700.5C 209.971,699.903 213.305,699.236 216.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b3b3",
    d: "M 571.5,720.5 C 577.523,719.777 583.023,721.111 588,724.5C 590.266,733.347 590.933,742.347 590,751.5C 581.251,752.484 572.418,752.817 563.5,752.5C 563.334,743.494 563.5,734.494 564,725.5C 566.17,723.177 568.67,721.51 571.5,720.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abacac",
    d: "M 610.5,720.5 C 620.881,718.786 629.048,722.119 635,730.5C 641.556,753.7 634.556,771.367 614,783.5C 613.667,783.167 613.333,782.833 613,782.5C 609.022,784.057 604.855,784.89 600.5,785C 585.278,785.507 570.278,785.841 555.5,786C 554.515,776.583 554.182,767.083 554.5,757.5C 556.342,757.277 558.175,756.943 560,756.5C 574.52,758.582 589.02,758.749 603.5,757C 607.521,754.323 609.687,750.489 610,745.5C 610.5,737.173 610.666,728.84 610.5,720.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe9c63",
    d: "M 410.5,689.5 C 410.5,700.5 410.5,711.5 410.5,722.5C 450.337,722.168 490.004,722.501 529.5,723.5C 489.5,723.5 449.5,723.5 409.5,723.5C 409.172,711.988 409.505,700.654 410.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888989",
    d: "M 283.5,744.5 C 282.512,739.36 282.179,734.026 282.5,728.5C 296.833,728.5 311.167,728.5 325.5,728.5C 325.5,718.5 325.5,708.5 325.5,698.5C 303.833,698.5 282.167,698.5 260.5,698.5C 260.5,724.833 260.5,751.167 260.5,777.5C 282.167,777.5 303.833,777.5 325.5,777.5C 325.833,777.5 326.167,777.5 326.5,777.5C 304.34,778.497 282.006,778.831 259.5,778.5C 259.5,751.5 259.5,724.5 259.5,697.5C 281.833,697.5 304.167,697.5 326.5,697.5C 326.5,708.167 326.5,718.833 326.5,729.5C 312.167,729.5 297.833,729.5 283.5,729.5C 283.5,734.5 283.5,739.5 283.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebfbf",
    d: "M 840.5,695.5 C 828.833,695.5 817.167,695.5 805.5,695.5C 805.5,719.833 805.5,744.167 805.5,768.5C 804.502,744.006 804.169,719.339 804.5,694.5C 816.678,694.172 828.678,694.505 840.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cececd",
    d: "M 15.5,730.5 C 17.8273,730.247 19.8273,730.914 21.5,732.5C 24.355,737.998 26.6884,743.665 28.5,749.5C 25.1501,749.665 21.8168,749.498 18.5,749C 13.491,744.498 11.1576,738.998 11.5,732.5C 13.0255,732.006 14.3588,731.339 15.5,730.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0cfcd",
    d: "M 26.5,735.5 C 27.5983,736.601 27.765,737.934 27,739.5C 26.51,738.207 26.3433,736.873 26.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a5b",
    d: "M 783.5,695.5 C 784.833,695.5 786.167,695.5 787.5,695.5C 787.5,709.5 787.5,723.5 787.5,737.5C 744.5,737.5 701.5,737.5 658.5,737.5C 658.165,725.985 658.165,714.652 658.5,703.5C 658.5,703.833 658.5,704.167 658.5,704.5C 659.238,715.15 659.572,725.817 659.5,736.5C 701.833,736.5 744.167,736.5 786.5,736.5C 786.5,723.167 786.5,709.833 786.5,696.5C 785.209,696.737 784.209,696.404 783.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4e4e",
    d: "M 322.5,744.5 C 309.5,745.833 296.5,745.833 283.5,744.5C 296.464,744.293 309.464,744.293 322.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b5b5",
    d: "M 962.5,768.5 C 962.5,744.167 962.5,719.833 962.5,695.5C 955.08,695.203 947.746,695.536 940.5,696.5C 939.262,696.19 939.262,695.69 940.5,695C 948.159,694.5 955.826,694.334 963.5,694.5C 963.831,719.339 963.498,744.006 962.5,768.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6d6d",
    d: "M 322.5,744.5 C 323.568,743.566 324.901,743.232 326.5,743.5C 326.5,754.833 326.5,766.167 326.5,777.5C 326.167,777.5 325.833,777.5 325.5,777.5C 325.5,766.5 325.5,755.5 325.5,744.5C 324.5,744.5 323.5,744.5 322.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#050506",
    d: "M 729.5,744.5 C 733.267,745.795 737.267,746.461 741.5,746.5C 743.292,746.366 744.958,746.699 746.5,747.5C 747.183,749.176 748.517,749.843 750.5,749.5C 750.821,751.048 751.821,751.715 753.5,751.5C 756.4,752.443 758.733,754.11 760.5,756.5C 761.326,758.264 762.659,759.598 764.5,760.5C 767.851,762.854 770.518,765.854 772.5,769.5C 772.738,771.404 773.738,772.738 775.5,773.5C 775.5,773.833 775.5,774.167 775.5,774.5C 775.66,776.153 776.326,777.486 777.5,778.5C 778.79,782.082 779.79,785.749 780.5,789.5C 780.832,793.493 781.165,797.493 781.5,801.5C 780.909,809.977 779.575,818.31 777.5,826.5C 777.159,829.516 775.993,832.182 774,834.5C 771.638,838.027 768.804,841.027 765.5,843.5C 764.5,843.833 763.833,844.5 763.5,845.5C 755.461,854.167 745.461,858.834 733.5,859.5C 708.833,859.5 684.167,859.5 659.5,859.5C 659.5,821.5 659.5,783.5 659.5,745.5C 679.34,745.83 699.007,745.497 718.5,744.5C 722.017,743.38 725.684,743.38 729.5,744.5 Z M 690.5,781.5 C 703.758,782.315 717.092,782.815 730.5,783C 740.075,785.276 744.409,791.442 743.5,801.5C 742.448,816.895 734.115,823.561 718.5,821.5C 709.348,820.506 700.015,820.173 690.5,820.5C 690.5,807.5 690.5,794.5 690.5,781.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#737474",
    d: "M 729.5,744.5 C 733.764,744.344 737.764,745.011 741.5,746.5C 737.267,746.461 733.267,745.795 729.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd6815",
    d: "M 498.5,785.5 C 498.5,792.167 498.5,798.833 498.5,805.5C 511.167,805.5 523.833,805.5 536.5,805.5C 536.5,816.5 536.5,827.5 536.5,838.5C 494.5,838.5 452.5,838.5 410.5,838.5C 410.571,835.861 411.571,833.694 413.5,832C 413.974,828.624 413.974,825.124 413.5,821.5C 415.991,820.459 415.991,819.626 413.5,819C 413.957,818.586 414.291,818.086 414.5,817.5C 413.846,815.885 413.346,814.218 413,812.5C 412.346,813.696 411.846,813.696 411.5,812.5C 414.028,811.184 414.028,810.017 411.5,809C 412.687,807.981 413.687,806.814 414.5,805.5C 413.61,804.289 413.61,802.955 414.5,801.5C 414.081,800.328 413.415,799.328 412.5,798.5C 413.397,798.331 414.397,797.998 415.5,797.5C 414.624,796.749 413.624,796.249 412.5,796C 414.834,792.191 415.501,788.525 414.5,785C 415.167,783 416.5,781.667 418.5,781C 418.48,779.285 417.814,777.452 416.5,775.5C 416.977,774.522 417.643,773.689 418.5,773C 417.483,771.951 417.316,770.784 418,769.5C 418.333,769.833 418.667,770.167 419,770.5C 420.375,766.836 422.208,763.503 424.5,760.5C 438.569,748.065 454.903,743.899 473.5,748C 478.479,749.24 482.979,751.406 487,754.5C 489.1,752.4 491.267,750.233 493.5,748C 507.848,746.334 521.848,745.667 535.5,746C 536.22,756.305 537.22,766.638 538.5,777C 538.441,778.436 538.108,779.769 537.5,781C 524.504,781.5 511.504,781.667 498.5,781.5C 498.5,782.833 498.5,784.167 498.5,785.5 Z M 451.5,781.5 C 455.234,781.323 458.901,781.656 462.5,782.5C 468.967,788.263 471.3,795.596 469.5,804.5C 459.5,804.5 449.5,804.5 439.5,804.5C 439.103,794.286 443.103,786.619 451.5,781.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f8180",
    d: "M 746.5,747.5 C 747.995,747.989 749.329,748.655 750.5,749.5C 748.517,749.843 747.183,749.176 746.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9baba",
    d: "M 908.5,747.5 C 905.375,748.479 902.042,748.813 898.5,748.5C 898.824,755.354 898.491,762.021 897.5,768.5C 897.5,761.5 897.5,754.5 897.5,747.5C 901.167,747.5 904.833,747.5 908.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696869",
    d: "M 750.5,749.5 C 751.71,749.932 752.71,750.599 753.5,751.5C 751.821,751.715 750.821,751.048 750.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7978",
    d: "M 760.5,756.5 C 762.773,756.957 764.106,758.29 764.5,760.5C 762.659,759.598 761.326,758.264 760.5,756.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd6812",
    d: "M 237.5,807.5 C 235.274,808.756 232.941,808.756 230.5,807.5C 204.167,806.167 177.833,806.167 151.5,807.5C 151.19,808.738 150.69,808.738 150,807.5C 149.754,804.11 149.254,800.777 148.5,797.5C 148.329,794.252 148.662,790.919 149.5,787.5C 149.5,781.167 149.5,774.833 149.5,768.5C 178.833,768.5 208.167,768.5 237.5,768.5C 237.5,781.5 237.5,794.5 237.5,807.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020303",
    d: "M -0.5,769.5 C 18.1667,769.5 36.8333,769.5 55.5,769.5C 55.5,782.5 55.5,795.5 55.5,808.5C 36.8333,808.5 18.1667,808.5 -0.5,808.5C -0.5,795.5 -0.5,782.5 -0.5,769.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7c",
    d: "M 772.5,769.5 C 774.262,770.262 775.262,771.596 775.5,773.5C 773.738,772.738 772.738,771.404 772.5,769.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe7b35",
    d: "M 424.5,760.5 C 422.208,763.503 420.375,766.836 419,770.5C 418.667,770.167 418.333,769.833 418,769.5C 417.316,770.784 417.483,771.951 418.5,773C 417.643,773.689 416.977,774.522 416.5,775.5C 417.814,777.452 418.48,779.285 418.5,781C 416.5,781.667 415.167,783 414.5,785C 415.501,788.525 414.834,792.191 412.5,796C 413.624,796.249 414.624,796.749 415.5,797.5C 414.397,797.998 413.397,798.331 412.5,798.5C 413.415,799.328 414.081,800.328 414.5,801.5C 413.61,802.955 413.61,804.289 414.5,805.5C 413.687,806.814 412.687,807.981 411.5,809C 414.028,810.017 414.028,811.184 411.5,812.5C 411.846,813.696 412.346,813.696 413,812.5C 413.346,814.218 413.846,815.885 414.5,817.5C 414.291,818.086 413.957,818.586 413.5,819C 415.991,819.626 415.991,820.459 413.5,821.5C 413.974,825.124 413.974,828.624 413.5,832C 411.571,833.694 410.571,835.861 410.5,838.5C 409.834,830.674 409.5,822.674 409.5,814.5C 407.402,796.744 410.569,780.077 419,764.5C 420.451,762.536 422.284,761.203 424.5,760.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f908e",
    d: "M 775.5,774.5 C 777.104,775.287 777.771,776.62 777.5,778.5C 776.326,777.486 775.66,776.153 775.5,774.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb48c",
    d: "M 451.5,781.5 C 454.64,780.359 457.973,780.192 461.5,781C 462.056,781.383 462.389,781.883 462.5,782.5C 458.901,781.656 455.234,781.323 451.5,781.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 267.5,783.5 C 273.711,783.091 279.211,784.757 284,788.5C 284.812,795.747 284.646,802.914 283.5,810C 284.244,811.039 285.244,811.539 286.5,811.5C 292.5,811.5 298.5,811.5 304.5,811.5C 304.5,806.167 304.5,800.833 304.5,795.5C 311.5,795.5 318.5,795.5 325.5,795.5C 325.5,812.167 325.5,828.833 325.5,845.5C 311.323,845.171 297.323,845.504 283.5,846.5C 282.515,850.634 282.182,854.968 282.5,859.5C 296.833,859.5 311.167,859.5 325.5,859.5C 325.5,867.833 325.5,876.167 325.5,884.5C 311.167,884.5 296.833,884.5 282.5,884.5C 282.177,890.69 282.51,896.69 283.5,902.5C 289.537,902.829 295.537,902.496 301.5,901.5C 302.275,899.604 303.275,897.937 304.5,896.5C 305.833,895.833 306.833,894.833 307.5,893.5C 308.209,892.596 309.209,892.263 310.5,892.5C 315.5,892.5 320.5,892.5 325.5,892.5C 325.5,908.833 325.5,925.167 325.5,941.5C 303.833,941.5 282.167,941.5 260.5,941.5C 260.5,888.833 260.5,836.167 260.5,783.5C 262.833,783.5 265.167,783.5 267.5,783.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc9e69",
    d: "M 237.5,807.5 C 237.5,794.5 237.5,781.5 237.5,768.5C 208.167,768.5 178.833,768.5 149.5,768.5C 149.5,774.833 149.5,781.167 149.5,787.5C 148.509,781.021 148.176,774.354 148.5,767.5C 178.5,767.5 208.5,767.5 238.5,767.5C 238.829,781.01 238.496,794.344 237.5,807.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9ad73",
    d: "M 884.5,823.5 C 884.5,811.167 884.5,798.833 884.5,786.5C 859.5,786.5 834.5,786.5 809.5,786.5C 809.5,799.167 809.5,811.833 809.5,824.5C 808.505,811.677 808.171,798.677 808.5,785.5C 834.167,785.5 859.833,785.5 885.5,785.5C 885.829,798.344 885.495,811.011 884.5,823.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa7508",
    d: "M 884.5,823.5 C 872.352,824.832 859.852,825.499 847,825.5C 834.329,825.5 821.829,825.167 809.5,824.5C 809.5,811.833 809.5,799.167 809.5,786.5C 834.5,786.5 859.5,786.5 884.5,786.5C 884.5,798.833 884.5,811.167 884.5,823.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020203",
    d: "M 1008.5,789.5 C 1008.2,803.216 1008.54,816.882 1009.5,830.5C 976.5,830.5 943.5,830.5 910.5,830.5C 910.5,816.833 910.5,803.167 910.5,789.5C 943.167,789.5 975.833,789.5 1008.5,789.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe7914",
    d: "M 373.5,790.5 C 377.97,791.486 382.637,791.819 387.5,791.5C 387.216,793.415 387.549,795.081 388.5,796.5C 389.827,804.235 389.827,812.068 388.5,820C 384.821,822.78 380.654,823.947 376,823.5C 371.442,822.759 366.942,822.759 362.5,823.5C 357.544,823.043 354.711,820.377 354,815.5C 353.076,808.392 353.409,801.392 355,794.5C 356.214,792.951 357.714,791.785 359.5,791C 363.753,790.8 367.92,790.3 372,789.5C 372.383,790.056 372.883,790.389 373.5,790.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb9e52",
    d: "M 373.5,790.5 C 378.5,790.5 383.5,790.5 388.5,790.5C 388.5,792.5 388.5,794.5 388.5,796.5C 387.549,795.081 387.216,793.415 387.5,791.5C 382.637,791.819 377.97,791.486 373.5,790.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4d4d",
    d: "M 1008.5,789.5 C 1008.83,789.5 1009.17,789.5 1009.5,789.5C 1009.56,803.389 1009.56,817.056 1009.5,830.5C 1008.54,816.882 1008.2,803.216 1008.5,789.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919292",
    d: "M 325.5,795.5 C 318.5,795.5 311.5,795.5 304.5,795.5C 304.5,800.833 304.5,806.167 304.5,811.5C 298.5,811.5 292.5,811.5 286.5,811.5C 291.975,810.511 297.642,810.178 303.5,810.5C 303.5,805.167 303.5,799.833 303.5,794.5C 311.019,794.175 318.352,794.508 325.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6e6e",
    d: "M 718.5,744.5 C 699.007,745.497 679.34,745.83 659.5,745.5C 659.5,783.5 659.5,821.5 659.5,859.5C 684.167,859.5 708.833,859.5 733.5,859.5C 708.672,860.498 683.672,860.831 658.5,860.5C 658.5,821.833 658.5,783.167 658.5,744.5C 678.5,744.5 698.5,744.5 718.5,744.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666767",
    d: "M -0.5,769.5 C -0.5,769.167 -0.5,768.833 -0.5,768.5C 18.5,768.5 37.5,768.5 56.5,768.5C 56.5,782.167 56.5,795.833 56.5,809.5C 37.5,809.5 18.5,809.5 -0.5,809.5C -0.5,809.167 -0.5,808.833 -0.5,808.5C 18.1667,808.5 36.8333,808.5 55.5,808.5C 55.5,795.5 55.5,782.5 55.5,769.5C 36.8333,769.5 18.1667,769.5 -0.5,769.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdb992",
    d: "M 498.5,785.5 C 499.49,791.645 499.823,797.978 499.5,804.5C 512.167,804.5 524.833,804.5 537.5,804.5C 537.5,816.167 537.5,827.833 537.5,839.5C 494.997,839.832 452.663,839.499 410.5,838.5C 452.5,838.5 494.5,838.5 536.5,838.5C 536.5,827.5 536.5,816.5 536.5,805.5C 523.833,805.5 511.167,805.5 498.5,805.5C 498.5,798.833 498.5,792.167 498.5,785.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa9152",
    d: "M 151.5,807.5 C 177.833,806.167 204.167,806.167 230.5,807.5C 204.472,807.516 178.139,807.516 151.5,807.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a7a7",
    d: "M 690.5,781.5 C 690.5,794.5 690.5,807.5 690.5,820.5C 700.015,820.173 709.348,820.506 718.5,821.5C 708.833,821.5 699.167,821.5 689.5,821.5C 689.171,807.99 689.504,794.656 690.5,781.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9a9aa",
    d: "M 588.5,794.5 C 589.82,797.428 590.486,800.761 590.5,804.5C 590.498,809.556 589.998,814.556 589,819.5C 582.136,828.864 574.136,829.864 565,822.5C 564.5,813.84 564.334,805.173 564.5,796.5C 572.693,796.384 580.693,795.717 588.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9baba",
    d: "M 61.5,799.5 C 85.8333,799.5 110.167,799.5 134.5,799.5C 134.667,844.168 134.5,888.835 134,933.5C 109.908,934.494 85.7414,934.828 61.5,934.5C 61.5,889.5 61.5,844.5 61.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888887",
    d: "M 780.5,789.5 C 783.527,802.111 782.527,814.444 777.5,826.5C 779.575,818.31 780.909,809.977 781.5,801.5C 781.165,797.493 780.832,793.493 780.5,789.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888989",
    d: "M 1009.5,789.5 C 1009.17,789.5 1008.83,789.5 1008.5,789.5C 975.833,789.5 943.167,789.5 910.5,789.5C 910.5,803.167 910.5,816.833 910.5,830.5C 943.5,830.5 976.5,830.5 1009.5,830.5C 976.338,831.498 943.004,831.832 909.5,831.5C 909.5,817.167 909.5,802.833 909.5,788.5C 943.004,788.168 976.338,788.502 1009.5,789.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d5d5",
    d: "M 208.5,821.5 C 218.5,821.5 228.5,821.5 238.5,821.5C 238.528,826.138 237.861,830.638 236.5,835C 237.308,835.308 237.975,835.808 238.5,836.5C 238.579,838.929 238.245,841.429 237.5,844C 235.182,844.342 233.015,843.842 231,842.5C 228.085,843.377 225.085,844.043 222,844.5C 217.539,843.655 213.039,843.322 208.5,843.5C 208.5,838.833 208.5,834.167 208.5,829.5C 217.506,829.666 226.506,829.5 235.5,829C 232.759,828.023 229.925,827.523 227,827.5C 221.013,828.327 214.847,828.327 208.5,827.5C 208.5,825.5 208.5,823.5 208.5,821.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#abacab",
    d: "M 601.5,793.5 C 613.055,792.258 623.222,795.258 632,802.5C 643.374,830.234 635.207,849.4 607.5,860C 603.886,860.945 600.219,861.612 596.5,862C 586.167,862.333 575.833,862.667 565.5,863C 563.649,863.837 561.816,864.671 560,865.5C 555.428,859.684 553.261,853.018 553.5,845.5C 554.14,840.125 555.473,834.958 557.5,830C 563.322,827.5 568.655,828.166 573.5,832C 585.372,832.69 597.039,831.523 608.5,828.5C 610.99,815.749 608.656,804.082 601.5,793.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6811",
    d: "M -0.5,832.5 C 12.5,832.5 25.5,832.5 38.5,832.5C 38.5,844.167 38.5,855.833 38.5,867.5C 25.5,867.5 12.5,867.5 -0.5,867.5C -0.5,855.833 -0.5,844.167 -0.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1d3d3",
    d: "M 808.5,837.5 C 833.33,836.337 858.33,836.17 883.5,837C 858.502,837.5 833.502,837.667 808.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9e9e",
    d: "M 388.5,845.5 C 391.48,852.344 393.48,859.844 394.5,868C 389.601,875.468 382.601,879.968 373.5,881.5C 370.002,881.292 366.669,880.459 363.5,879C 348.835,869.666 347.835,858.999 360.5,847C 369.257,842.513 378.424,841.013 388,842.5C 388.483,843.448 388.649,844.448 388.5,845.5 Z M 388.5,845.5 C 388.217,846.289 387.717,846.956 387,847.5C 386.472,846.184 386.972,845.517 388.5,845.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cececd",
    d: "M 809.5,843.5 C 834.509,843.167 859.509,843.5 884.5,844.5C 872,844.833 859.5,845.167 847,845.5C 834.148,845.499 821.648,844.832 809.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a8a9",
    d: "M 765.5,843.5 C 765.5,844.833 764.833,845.5 763.5,845.5C 763.833,844.5 764.5,843.833 765.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7c7c",
    d: "M 325.5,795.5 C 326.497,812.325 326.83,829.325 326.5,846.5C 312.167,846.5 297.833,846.5 283.5,846.5C 297.323,845.504 311.323,845.171 325.5,845.5C 325.5,828.833 325.5,812.167 325.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fb955a",
    d: "M -0.5,832.5 C -0.5,832.167 -0.5,831.833 -0.5,831.5C 12.8333,831.5 26.1667,831.5 39.5,831.5C 39.5,843.833 39.5,856.167 39.5,868.5C 26.1667,868.5 12.8333,868.5 -0.5,868.5C -0.5,868.167 -0.5,867.833 -0.5,867.5C 12.5,867.5 25.5,867.5 38.5,867.5C 38.5,855.833 38.5,844.167 38.5,832.5C 25.5,832.5 12.5,832.5 -0.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe6a16",
    d: "M 537.5,923.5 C 536.252,924.334 535.585,925.667 535.5,927.5C 535.511,929.045 535.844,930.378 536.5,931.5C 536.5,940.167 536.5,948.833 536.5,957.5C 494.5,957.5 452.5,957.5 410.5,957.5C 409.338,937.671 409.171,917.671 410,897.5C 414.354,878.788 425.188,864.955 442.5,856C 473.839,842.069 501.505,847.236 525.5,871.5C 537.338,886.516 541.838,903.516 539,922.5C 538.617,923.056 538.117,923.389 537.5,923.5 Z M 467.5,884.5 C 471.833,884.5 476.167,884.5 480.5,884.5C 482.599,885.612 484.933,886.279 487.5,886.5C 497.783,891.306 504.616,899.306 508,910.5C 508.499,914.821 508.666,919.154 508.5,923.5C 485.167,923.5 461.833,923.5 438.5,923.5C 439.719,915.237 441.885,907.237 445,899.5C 448.07,894.927 451.904,891.261 456.5,888.5C 460.307,887.307 463.974,885.974 467.5,884.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030403",
    d: "M 927.5,852.5 C 927.5,856.5 927.5,860.5 927.5,864.5C 921.833,864.5 916.167,864.5 910.5,864.5C 910.5,860.833 910.5,857.167 910.5,853.5C 916.259,853.786 921.925,853.452 927.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0d1d1",
    d: "M 809.5,853.5 C 833.374,853.751 858.041,854.084 883.5,854.5C 883.5,856.167 883.5,857.833 883.5,859.5C 858.824,859.664 834.157,859.33 809.5,858.5C 809.5,856.833 809.5,855.167 809.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6d6d6",
    d: "M 942.5,854.5 C 964.833,854.5 987.167,854.5 1009.5,854.5C 1009.5,876.167 1009.5,897.833 1009.5,919.5C 987.172,920.103 964.838,920.436 942.5,920.5C 942.5,898.5 942.5,876.5 942.5,854.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575757",
    d: "M 927.5,852.5 C 921.925,853.452 916.259,853.786 910.5,853.5C 910.5,857.167 910.5,860.833 910.5,864.5C 910.167,864.5 909.833,864.5 909.5,864.5C 909.069,859.968 909.569,855.635 911,851.5C 916.658,852.392 922.158,852.726 927.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5b5b",
    d: "M 283.5,846.5 C 283.5,850.5 283.5,854.5 283.5,858.5C 297.5,858.5 311.5,858.5 325.5,858.5C 325.5,858.833 325.5,859.167 325.5,859.5C 311.167,859.5 296.833,859.5 282.5,859.5C 282.182,854.968 282.515,850.634 283.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7f7f",
    d: "M 267.5,783.5 C 265.167,783.5 262.833,783.5 260.5,783.5C 260.5,836.167 260.5,888.833 260.5,941.5C 282.167,941.5 303.833,941.5 325.5,941.5C 325.5,941.833 325.5,942.167 325.5,942.5C 303.5,942.5 281.5,942.5 259.5,942.5C 259.5,889.167 259.5,835.833 259.5,782.5C 262.385,782.194 265.052,782.527 267.5,783.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3d4d4",
    d: "M 212.5,847.5 C 216.554,845.66 220.887,845.16 225.5,846C 228.167,846.333 230.833,846.667 233.5,847C 234.595,848.675 236.095,849.842 238,850.5C 239.025,855.402 238.525,860.069 236.5,864.5C 237.025,865.192 237.692,865.692 238.5,866C 236.216,867.363 236.049,868.863 238,870.5C 238.262,875.45 238.429,880.283 238.5,885C 238.043,885.414 237.709,885.914 237.5,886.5C 231.77,887.202 226.103,888.202 220.5,889.5C 226.48,890.413 232.48,890.413 238.5,889.5C 238.665,892.85 238.498,896.183 238,899.5C 237.612,900.428 236.945,901.095 236,901.5C 227.852,900.621 219.685,900.454 211.5,901C 210.289,899.887 210.289,898.72 211.5,897.5C 210.675,896.614 209.675,896.281 208.5,896.5C 208.5,892.833 208.5,889.167 208.5,885.5C 216.926,885.848 225.259,885.181 233.5,883.5C 229.303,883.014 225.303,882.014 221.5,880.5C 219.711,881.877 217.711,882.877 215.5,883.5C 213.547,882.239 211.547,881.073 209.5,880C 210.191,878.933 210.691,877.766 211,876.5C 213.212,875.88 215.046,874.713 216.5,873C 216.167,872.5 215.833,872 215.5,871.5C 213.043,873.225 210.377,873.725 207.5,873C 207.488,871.025 207.822,868.858 208.5,866.5C 210.492,866.328 212.158,866.995 213.5,868.5C 215.046,867.316 216.713,866.316 218.5,865.5C 215.291,864.213 212.125,864.213 209,865.5C 208.517,864.552 208.351,863.552 208.5,862.5C 216.507,862.666 224.507,862.5 232.5,862C 232.957,861.586 233.291,861.086 233.5,860.5C 231.535,859.708 229.535,859.041 227.5,858.5C 220.897,859.472 214.564,859.472 208.5,858.5C 208.334,854.486 208.501,850.486 209,846.5C 210.011,847.337 211.178,847.67 212.5,847.5 Z M 220.5,855.5 C 222.656,855.872 222.656,856.872 220.5,858.5C 219.438,857.575 219.438,856.575 220.5,855.5 Z M 227.5,854.5 C 229.225,854.843 229.725,855.843 229,857.5C 227.961,856.756 227.461,855.756 227.5,854.5 Z M 212.5,847.5 C 216.006,849.144 217.506,851.811 217,855.5C 213.695,853.894 212.195,851.227 212.5,847.5 Z M 217.5,871.5 C 222.214,871.173 226.88,871.507 231.5,872.5C 227.359,873.658 223.359,874.325 219.5,874.5C 218.081,873.995 217.415,872.995 217.5,871.5 Z M 213.5,888.5 C 216.001,888.511 216.168,889.178 214,890.5C 213.536,889.906 213.369,889.239 213.5,888.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a8b8b",
    d: "M 927.5,852.5 C 928.491,859.313 928.825,866.313 928.5,873.5C 922.642,873.178 916.975,873.511 911.5,874.5C 911.167,874.5 910.833,874.5 910.5,874.5C 909.586,871.272 909.253,867.939 909.5,864.5C 909.833,864.5 910.167,864.5 910.5,864.5C 916.167,864.5 921.833,864.5 927.5,864.5C 927.5,860.5 927.5,856.5 927.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#050504",
    d: "M 910.5,866.5 C 916.167,866.5 921.833,866.5 927.5,866.5C 927.5,868.5 927.5,870.5 927.5,872.5C 921.833,872.5 916.167,872.5 910.5,872.5C 910.5,870.5 910.5,868.5 910.5,866.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0cfd0",
    d: "M 561.5,871.5 C 561.897,870.475 562.563,870.308 563.5,871C 562.906,871.464 562.239,871.631 561.5,871.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0cfcf",
    d: "M 813.5,869.5 C 836.94,870.127 860.607,870.461 884.5,870.5C 884.5,871.5 884.5,872.5 884.5,873.5C 859.167,873.5 833.833,873.5 808.5,873.5C 808.5,872.5 808.5,871.5 808.5,870.5C 810.415,870.784 812.081,870.451 813.5,869.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbdcda",
    d: "M 562.5,875.5 C 562.897,874.475 563.563,874.308 564.5,875C 563.906,875.464 563.239,875.631 562.5,875.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030504",
    d: "M 910.5,874.5 C 910.833,874.5 911.167,874.5 911.5,874.5C 916.64,875.488 921.974,875.821 927.5,875.5C 927.5,876.5 927.5,877.5 927.5,878.5C 921.833,878.5 916.167,878.5 910.5,878.5C 910.5,877.167 910.5,875.833 910.5,874.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4c4c4",
    d: "M 776.5,875.5 C 780.5,875.5 784.5,875.5 788.5,875.5C 788.5,889.833 788.5,904.167 788.5,918.5C 744.833,918.5 701.167,918.5 657.5,918.5C 657.5,904.5 657.5,890.5 657.5,876.5C 697.337,876.832 737.004,876.499 776.5,875.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f6060",
    d: "M 911.5,874.5 C 917.167,874.5 922.833,874.5 928.5,874.5C 928.784,876.415 928.451,878.081 927.5,879.5C 921.642,879.822 915.975,879.489 910.5,878.5C 916.167,878.5 921.833,878.5 927.5,878.5C 927.5,877.5 927.5,876.5 927.5,875.5C 921.974,875.821 916.64,875.488 911.5,874.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cecece",
    d: "M 808.5,881.5 C 833.833,881.5 859.167,881.5 884.5,881.5C 884.5,882.5 884.5,883.5 884.5,884.5C 860.438,885.059 835.105,885.392 808.5,885.5C 808.5,884.167 808.5,882.833 808.5,881.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8dad9",
    d: "M 208.5,881.5 C 209.525,881.897 209.692,882.563 209,883.5C 208.536,882.906 208.369,882.239 208.5,881.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff8240",
    d: "M 467.5,884.5 C 463.974,885.974 460.307,887.307 456.5,888.5C 457.953,887.175 457.619,886.342 455.5,886C 456.253,884.513 457.086,884.346 458,885.5C 458.851,882.388 460.017,882.054 461.5,884.5C 462.216,883.689 463.05,883.022 464,882.5C 465.077,883.429 466.244,884.096 467.5,884.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b9b9b",
    d: "M 325.5,858.5 C 326.493,867.318 326.827,876.318 326.5,885.5C 312.167,885.5 297.833,885.5 283.5,885.5C 283.5,891.167 283.5,896.833 283.5,902.5C 282.51,896.69 282.177,890.69 282.5,884.5C 296.833,884.5 311.167,884.5 325.5,884.5C 325.5,876.167 325.5,867.833 325.5,859.5C 325.5,859.167 325.5,858.833 325.5,858.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa978",
    d: "M 480.5,884.5 C 483.228,884.171 485.562,884.837 487.5,886.5C 484.933,886.279 482.599,885.612 480.5,884.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcece",
    d: "M 808.5,892.5 C 833.836,892.333 859.169,892.5 884.5,893C 883.663,894.011 883.33,895.178 883.5,896.5C 858.5,896.5 833.5,896.5 808.5,896.5C 808.5,895.167 808.5,893.833 808.5,892.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebebe",
    d: "M 577.5,880.5 C 576.596,881.209 576.263,882.209 576.5,883.5C 572.759,884.401 570.759,883.068 570.5,879.5C 571.833,879.5 573.167,879.5 574.5,879.5C 574.5,878.167 574.5,876.833 574.5,875.5C 572.5,875.5 570.5,875.5 568.5,875.5C 568.5,878.5 568.5,881.5 568.5,884.5C 570.833,884.5 573.167,884.5 575.5,884.5C 575.928,890.176 576.095,895.843 576,901.5C 573.544,903.321 570.711,903.988 567.5,903.5C 567.366,905.292 567.699,906.958 568.5,908.5C 564.167,908.5 559.833,908.5 555.5,908.5C 555.334,900.493 555.5,892.493 556,884.5C 559.73,883.54 563.563,883.207 567.5,883.5C 567.114,879.124 567.781,874.957 569.5,871C 572.099,870.231 574.599,870.398 577,871.5C 577.295,873.931 578.462,875.764 580.5,877C 578.574,877.422 577.574,878.589 577.5,880.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8d8d",
    d: "M 307.5,893.5 C 306.833,894.833 305.833,895.833 304.5,896.5C 304.5,894.5 305.5,893.5 307.5,893.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9dbda",
    d: "M 208.5,899.5 C 209.833,900.167 209.833,900.167 208.5,899.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888a8a",
    d: "M 910.5,874.5 C 910.5,875.833 910.5,877.167 910.5,878.5C 915.975,879.489 921.642,879.822 927.5,879.5C 927.5,879.833 927.5,880.167 927.5,880.5C 928.833,891.833 928.833,903.167 927.5,914.5C 927.5,914.167 927.5,913.833 927.5,913.5C 927.666,908.489 927.499,903.489 927,898.5C 925.613,900.301 924.113,900.968 922.5,900.5C 926.573,898.451 928.239,895.118 927.5,890.5C 921.833,890.5 916.167,890.5 910.5,890.5C 910.167,890.5 909.833,890.5 909.5,890.5C 909.179,884.974 909.512,879.64 910.5,874.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d0e0d",
    d: "M 927.5,880.5 C 927.5,883.167 927.5,885.833 927.5,888.5C 921.833,888.5 916.167,888.5 910.5,888.5C 910.5,885.833 910.5,883.167 910.5,880.5C 916.167,880.5 921.833,880.5 927.5,880.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a0b0b",
    d: "M 910.5,890.5 C 916.167,890.5 921.833,890.5 927.5,890.5C 928.239,895.118 926.573,898.451 922.5,900.5C 924.113,900.968 925.613,900.301 927,898.5C 927.499,903.489 927.666,908.489 927.5,913.5C 921.833,913.5 916.167,913.5 910.5,913.5C 910.5,905.833 910.5,898.167 910.5,890.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4a4a4",
    d: "M 352.5,901.5 C 365.359,902.262 378.359,902.929 391.5,903.5C 391.195,908.762 391.529,913.928 392.5,919C 391.801,922.8 391.135,926.633 390.5,930.5C 388.869,932.297 386.869,933.464 384.5,934C 376.796,934.428 369.296,934.595 362,934.5C 357.872,933.604 354.872,931.271 353,927.5C 352.5,918.84 352.334,910.173 352.5,901.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9a9a9",
    d: "M 576.5,908.5 C 574.167,908.5 571.833,908.5 569.5,908.5C 569.167,908.5 568.833,908.5 568.5,908.5C 567.699,906.958 567.366,905.292 567.5,903.5C 570.711,903.988 573.544,903.321 576,901.5C 576.095,895.843 575.928,890.176 575.5,884.5C 573.167,884.5 570.833,884.5 568.5,884.5C 568.5,881.5 568.5,878.5 568.5,875.5C 570.5,875.5 572.5,875.5 574.5,875.5C 574.5,876.833 574.5,878.167 574.5,879.5C 573.167,879.5 571.833,879.5 570.5,879.5C 570.759,883.068 572.759,884.401 576.5,883.5C 576.263,882.209 576.596,881.209 577.5,880.5C 578.694,881.777 580.36,882.444 582.5,882.5C 592.685,882.328 603.019,882.328 613.5,882.5C 613.5,879.833 613.5,877.167 613.5,874.5C 619.176,874.334 624.843,874.501 630.5,875C 634.233,875.066 637.733,875.899 641,877.5C 641.5,887.828 641.666,898.161 641.5,908.5C 619.833,908.5 598.167,908.5 576.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f6060",
    d: "M 909.5,890.5 C 909.833,890.5 910.167,890.5 910.5,890.5C 910.5,898.167 910.5,905.833 910.5,913.5C 916.167,913.5 921.833,913.5 927.5,913.5C 927.5,913.833 927.5,914.167 927.5,914.5C 922.156,914.334 916.823,914.501 911.5,915C 912.737,915.232 913.737,915.732 914.5,916.5C 913.167,916.5 911.833,916.5 910.5,916.5C 910.5,924.167 910.5,931.833 910.5,939.5C 915.032,939.182 919.366,939.515 923.5,940.5C 918.833,940.5 914.167,940.5 909.5,940.5C 910.362,923.736 910.362,907.069 909.5,890.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d4d2",
    d: "M 599.5,917.5 C 599.897,916.475 600.563,916.308 601.5,917C 600.906,917.464 600.239,917.631 599.5,917.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadedb",
    d: "M 569.5,917.5 C 570.833,918.167 570.833,918.167 569.5,917.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5d6d6",
    d: "M 208.5,902.5 C 212.369,903.68 216.369,904.68 220.5,905.5C 220.977,906.931 221.643,908.264 222.5,909.5C 223.893,907.326 223.56,905.493 221.5,904C 226.405,903.799 231.405,903.799 236.5,904C 239.033,905.916 239.033,907.916 236.5,910C 239.388,912.296 238.888,913.462 235,913.5C 233.284,913.252 231.784,912.585 230.5,911.5C 229.304,911.846 229.304,912.346 230.5,913C 228.337,913.245 226.67,914.245 225.5,916C 229.835,916.263 234.168,916.097 238.5,915.5C 238.666,921.842 238.5,928.175 238,934.5C 235.527,935.12 233.027,935.786 230.5,936.5C 232.886,936.676 235.552,936.676 238.5,936.5C 238.917,939.079 238.25,941.246 236.5,943C 227.833,943.667 219.167,943.667 210.5,943C 207.471,937.441 206.971,931.608 209,925.5C 209.914,926.654 210.747,926.487 211.5,925C 209.393,923.736 208.393,921.903 208.5,919.5C 213.378,919.394 218.044,919.894 222.5,921C 221.315,919.647 219.981,918.48 218.5,917.5C 219.855,916.325 219.688,915.325 218,914.5C 216.853,915.458 215.853,915.125 215,913.5C 212.763,914.056 210.763,915.056 209,916.5C 208.501,911.845 208.334,907.179 208.5,902.5 Z M 221.5,910.5 C 226.833,911.5 226.833,912.5 221.5,913.5C 221.5,912.5 221.5,911.5 221.5,910.5 Z M 214.5,909.5 C 215.847,910.171 217.014,910.171 218,909.5C 219.23,910.275 219.563,911.275 219,912.5C 217.94,912.254 216.773,912.254 215.5,912.5C 214.614,911.675 214.281,910.675 214.5,909.5 Z M 221.5,924.5 C 226.348,923.186 231.348,923.186 236.5,924.5C 231.449,925.779 226.449,925.779 221.5,924.5 Z M 214.5,925.5 C 215.497,925.47 216.164,925.97 216.5,927C 216.505,930.668 216.505,933.834 216.5,936.5C 215.5,935.167 214.5,935.167 213.5,936.5C 212.833,932.805 213.167,929.139 214.5,925.5 Z M 219.5,927.5 C 224.172,927.861 224.005,929.195 219,931.5C 218.5,931.167 218,930.833 217.5,930.5C 218.193,929.482 218.859,928.482 219.5,927.5 Z M 222.5,936.5 C 223.251,935.427 224.251,935.26 225.5,936C 224.648,937.728 223.648,937.895 222.5,936.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999a99",
    d: "M 310.5,892.5 C 315.64,891.512 320.974,891.179 326.5,891.5C 326.83,908.675 326.497,925.675 325.5,942.5C 325.5,942.167 325.5,941.833 325.5,941.5C 325.5,925.167 325.5,908.833 325.5,892.5C 320.5,892.5 315.5,892.5 310.5,892.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aaaaaa",
    d: "M 568.5,921.5 C 572.5,921.5 576.5,921.5 580.5,921.5C 580.81,924.713 580.477,927.713 579.5,930.5C 578.26,928.015 577.26,928.015 576.5,930.5C 576.5,932.167 576.5,933.833 576.5,935.5C 577.833,935.5 579.167,935.5 580.5,935.5C 592.167,935.5 603.833,935.5 615.5,935.5C 616.486,931.03 616.819,926.363 616.5,921.5C 622.838,921.233 629.171,920.9 635.5,920.5C 635.5,935.833 635.5,951.167 635.5,966.5C 608.831,966.667 582.165,966.5 555.5,966C 554.514,956.25 554.181,946.416 554.5,936.5C 556.167,936.5 557.833,936.5 559.5,936.5C 559.5,931.5 559.5,926.5 559.5,921.5C 562.5,921.5 565.5,921.5 568.5,921.5 Z M 579.5,930.5 C 579.762,931.978 579.429,933.311 578.5,934.5C 577.828,933.051 577.161,931.718 576.5,930.5C 577.26,928.015 578.26,928.015 579.5,930.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8d9d9",
    d: "M 616.5,921.5 C 616.819,926.363 616.486,931.03 615.5,935.5C 615.5,931.5 615.5,927.5 615.5,923.5C 605.161,923.666 594.828,923.5 584.5,923C 595.088,921.571 605.755,921.071 616.5,921.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cacccb",
    d: "M 569.5,908.5 C 571.833,908.5 574.167,908.5 576.5,908.5C 576.334,912.514 576.501,916.514 577,920.5C 578.113,919.289 579.28,919.289 580.5,920.5C 581.666,925.503 581.666,930.503 580.5,935.5C 579.167,935.5 577.833,935.5 576.5,935.5C 576.5,933.833 576.5,932.167 576.5,930.5C 577.161,931.718 577.828,933.051 578.5,934.5C 579.429,933.311 579.762,931.978 579.5,930.5C 580.477,927.713 580.81,924.713 580.5,921.5C 576.5,921.5 572.5,921.5 568.5,921.5C 569.568,920.566 570.901,920.232 572.5,920.5C 572.5,916.833 572.5,913.167 572.5,909.5C 571.209,909.737 570.209,909.404 569.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9a975",
    d: "M 537.5,923.5 C 536.612,926.054 536.279,928.721 536.5,931.5C 535.844,930.378 535.511,929.045 535.5,927.5C 535.585,925.667 536.252,924.334 537.5,923.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#141515",
    d: "M 927.5,948.5 C 921.799,950.985 915.799,951.652 909.5,950.5C 910.393,947.916 910.726,945.249 910.5,942.5C 915.122,942.844 919.455,942.177 923.5,940.5C 919.366,939.515 915.032,939.182 910.5,939.5C 910.5,931.833 910.5,924.167 910.5,916.5C 911.833,916.5 913.167,916.5 914.5,916.5C 919.151,916.321 923.651,916.321 928,916.5C 928.825,927.341 928.659,938.008 927.5,948.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818282",
    d: "M 909.5,940.5 C 914.167,940.5 918.833,940.5 923.5,940.5C 919.455,942.177 915.122,942.844 910.5,942.5C 910.726,945.249 910.393,947.916 909.5,950.5C 915.799,951.652 921.799,950.985 927.5,948.5C 927.5,949.5 927.5,950.5 927.5,951.5C 921.171,951.9 914.838,952.233 908.5,952.5C 909.162,948.534 909.495,944.534 909.5,940.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575857",
    d: "M 919.5,953.5 C 916.713,954.477 913.713,954.81 910.5,954.5C 910.802,957.059 910.468,959.393 909.5,961.5C 909.5,961.167 909.5,960.833 909.5,960.5C 909.5,958.167 909.5,955.833 909.5,953.5C 912.833,953.5 916.167,953.5 919.5,953.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdc29f",
    d: "M 536.5,931.5 C 537.493,940.318 537.827,949.318 537.5,958.5C 494.997,958.832 452.663,958.499 410.5,957.5C 452.5,957.5 494.5,957.5 536.5,957.5C 536.5,948.833 536.5,940.167 536.5,931.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#050605",
    d: "M 919.5,953.5 C 922.167,953.5 924.833,953.5 927.5,953.5C 927.5,962.167 927.5,970.833 927.5,979.5C 922.637,979.181 917.97,979.514 913.5,980.5C 912.167,980.5 910.833,980.5 909.5,980.5C 908.911,976.029 909.577,972.029 911.5,968.5C 911.833,968.5 912.167,968.5 912.5,968.5C 912.56,969.043 912.893,969.376 913.5,969.5C 914.466,967.604 914.799,965.604 914.5,963.5C 913.209,963.263 912.209,963.596 911.5,964.5C 909.952,964.179 909.285,963.179 909.5,961.5C 910.468,959.393 910.802,957.059 910.5,954.5C 913.713,954.81 916.713,954.477 919.5,953.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5f5f",
    d: "M 911.5,964.5 C 912.209,963.596 913.209,963.263 914.5,963.5C 914.799,965.604 914.466,967.604 913.5,969.5C 912.893,969.376 912.56,969.043 912.5,968.5C 913.124,968.083 913.457,967.416 913.5,966.5C 913.253,965.287 912.586,964.62 911.5,964.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9b9b9",
    d: "M 909.5,960.5 C 909.5,960.833 909.5,961.167 909.5,961.5C 909.285,963.179 909.952,964.179 911.5,964.5C 910.167,965.833 910.167,967.167 911.5,968.5C 909.577,972.029 908.911,976.029 909.5,980.5C 910.833,980.5 912.167,980.5 913.5,980.5C 912.081,981.451 910.415,981.784 908.5,981.5C 908.175,974.313 908.509,967.313 909.5,960.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838383",
    d: "M 919.5,953.5 C 922.287,952.523 925.287,952.19 928.5,952.5C 928.5,961.833 928.5,971.167 928.5,980.5C 923.5,980.5 918.5,980.5 913.5,980.5C 917.97,979.514 922.637,979.181 927.5,979.5C 927.5,970.833 927.5,962.167 927.5,953.5C 924.833,953.5 922.167,953.5 919.5,953.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/t2.aa7ab0d6f874ccd1d24fc7019450634a.svg";
export { ForwardRef as ReactComponent };